/** THIS IS AN AUTO GENERATED FILE, DO NOT EDIT MANUALLY -- Created by @graphql-codegen */
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  AWSDate: { input: string; output: string }
  AWSDateTime: { input: string; output: string }
  AWSEmail: { input: string; output: string }
  AWSJSON: { input: string; output: string }
  AWSTime: { input: string; output: string }
}

export type ActionEntry = {
  author: AuditEntry
  code: ActionEntryCode
  description: Scalars['String']['output']
}

export enum ActionEntryCode {
  Email = 'EMAIL',
  Sms = 'SMS',
}

export enum ActiveStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export type Address = {
  city: Scalars['String']['output']
  countryCode?: Maybe<Scalars['String']['output']>
  line: Array<Scalars['String']['output']>
  postalCode: Scalars['String']['output']
  state: Scalars['String']['output']
  text?: Maybe<Scalars['String']['output']>
}

export type AddressComponents = {
  city?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
  zipcode?: Maybe<Scalars['String']['output']>
}

export type AddressComponentsInput = {
  city?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
  zipcode?: InputMaybe<Scalars['String']['input']>
}

export type AddressCreateInput = {
  city: Scalars['String']['input']
  countryCode?: InputMaybe<Scalars['String']['input']>
  line: Array<Scalars['String']['input']>
  postalCode: Scalars['String']['input']
  state: Scalars['String']['input']
}

export type AddressUpdateInput = {
  city?: InputMaybe<Scalars['String']['input']>
  countryCode?: InputMaybe<Scalars['String']['input']>
  line?: InputMaybe<Array<Scalars['String']['input']>>
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
}

export type Annotation = IAnnotation & {
  authorReference: Reference
  text: Scalars['String']['output']
  time: Scalars['AWSDateTime']['output']
}

export type ApiAuditEntry = {
  apiName: Scalars['String']['output']
  arguments?: Maybe<Scalars['AWSJSON']['output']>
  caller: ApiAuditEntryCaller
  endpoint: Scalars['String']['output']
  endpointMethod: Scalars['String']['output']
  ipAddress: Scalars['String']['output']
  metaData?: Maybe<Scalars['AWSJSON']['output']>
  raw?: Maybe<Scalars['AWSJSON']['output']>
  requestId: Scalars['ID']['output']
  requestTimestamp: Scalars['AWSDateTime']['output']
  responseStatus?: Maybe<Scalars['String']['output']>
  s3?: Maybe<Scalars['AWSJSON']['output']>
  selectionSetList?: Maybe<Array<Scalars['String']['output']>>
}

export type ApiAuditEntryCaller = {
  cognitoId?: Maybe<Scalars['String']['output']>
  patientId?: Maybe<Scalars['String']['output']>
  phoneNumber?: Maybe<Scalars['String']['output']>
  treatmentId?: Maybe<Scalars['String']['output']>
  username?: Maybe<Scalars['String']['output']>
}

export type AppendListItemInput = {
  description?: InputMaybe<Scalars['String']['input']>
  label: Scalars['String']['input']
  sortOrder?: InputMaybe<Scalars['Int']['input']>
  value: Scalars['String']['input']
}

export type Appointment = Node & {
  _id: Scalars['ID']['output']
  appointmentType: AppointmentType
  cancelationReason?: Maybe<Scalars['String']['output']>
  createdDate: Scalars['AWSDateTime']['output']
  description?: Maybe<Scalars['String']['output']>
  endDate: Scalars['AWSDateTime']['output']
  fulfilledStatus?: Maybe<FulfilledAppointmentStatistics>
  identifiers?: Maybe<Array<AppointmentIdentifier>>
  minutesDuration?: Maybe<Scalars['Float']['output']>
  notes?: Maybe<Array<Annotation>>
  occuranceChanged?: Maybe<Scalars['Boolean']['output']>
  occuranceIndex?: Maybe<Scalars['Int']['output']>
  participants: Array<Participant>
  reoccuranceTemplate?: Maybe<ReoccuranceTemplate>
  replacesAppointmentId?: Maybe<Scalars['ID']['output']>
  serviceCategory: ServiceCategory
  serviceType?: Maybe<ServiceType>
  startDate: Scalars['AWSDateTime']['output']
  status: AppointmentStatus
  syncMessage?: Maybe<Scalars['String']['output']>
  virtualService?: Maybe<VirtualService>
}

export type AppointmentDisplay = {
  careManagerDisplay?: Maybe<Scalars['String']['output']>
  careManagerId?: Maybe<Scalars['ID']['output']>
  endDateTime: Scalars['AWSDateTime']['output']
  serviceType?: Maybe<Scalars['String']['output']>
  startDateTime: Scalars['AWSDateTime']['output']
  type?: Maybe<Scalars['String']['output']>
}

export type AppointmentFlags = {
  disableLegacyAppointmentSideEffects?: Maybe<Scalars['Boolean']['output']>
  useSchedulingAppt?: Maybe<Scalars['Boolean']['output']>
}

export type AppointmentIdentifier = {
  source: AppointmentIdentifierSource
  value?: Maybe<Scalars['String']['output']>
}

export type AppointmentIdentifierInput = {
  source: AppointmentIdentifierSource
  value?: InputMaybe<Scalars['String']['input']>
}

export enum AppointmentIdentifierSource {
  CareManager = 'CARE_MANAGER',
  DrChrono = 'DR_CHRONO',
  LumaApptId = 'LUMA_APPT_ID',
  MedplumId = 'MEDPLUM_ID',
  MmrId = 'MMR_ID',
  NextgenId = 'NEXTGEN_ID',
}

export type AppointmentInput = {
  appointmentType?: InputMaybe<AppointmentType>
  cancelationReason?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  endDate?: InputMaybe<Scalars['AWSDateTime']['input']>
  fulfilledStatus?: InputMaybe<FulfilledAppointmentStatisticsInput>
  identifiers?: InputMaybe<Array<AppointmentIdentifierInput>>
  minutesDuration?: InputMaybe<Scalars['Float']['input']>
  note?: InputMaybe<Scalars['String']['input']>
  participants?: InputMaybe<Array<ParticipantInput>>
  reoccuranceTemplate?: InputMaybe<ReoccuranceTemplateInput>
  replacesAppointmentId?: InputMaybe<Scalars['String']['input']>
  serviceCategory?: InputMaybe<ServiceCategoryCode>
  serviceType?: InputMaybe<ServiceTypeCode>
  startDate?: InputMaybe<Scalars['AWSDateTime']['input']>
  status?: InputMaybe<AppointmentStatus>
  syncMessage?: InputMaybe<Scalars['String']['input']>
  virtualService?: InputMaybe<VirtualServiceInput>
}

export type AppointmentOptions = {
  forceOverlap?: InputMaybe<Scalars['Boolean']['input']>
}

export type AppointmentParticipantType = ICodeableConcept & {
  code: AppointmentParticipantTypeCode
  coding?: Maybe<Array<Coding>>
  text?: Maybe<Scalars['String']['output']>
}

export enum AppointmentParticipantTypeCode {
  CoveringProvider = 'COVERING_PROVIDER',
  Patient = 'PATIENT',
  PrimaryPerformer = 'PRIMARY_PERFORMER',
}

export type AppointmentResponse = {
  results: Array<Appointment>
  searchAfter?: Maybe<Scalars['AWSJSON']['output']>
  totalCount: Scalars['Int']['output']
}

export type AppointmentSettings = {
  flags?: Maybe<AppointmentFlags>
}

export enum AppointmentStatus {
  Booked = 'BOOKED',
  Canceled = 'CANCELED',
  Canceled_24 = 'CANCELED_24',
  Canceled_48 = 'CANCELED_48',
  EnteredInError = 'ENTERED_IN_ERROR',
  Fulfilled = 'FULFILLED',
  Noshow = 'NOSHOW',
  Pending = 'PENDING',
  Proposed = 'PROPOSED',
  Rescheduled = 'RESCHEDULED',
  Waitlist = 'WAITLIST',
}

export enum AppointmentType {
  Checkup = 'CHECKUP',
  Emergency = 'EMERGENCY',
  Followup = 'FOLLOWUP',
  Routine = 'ROUTINE',
}

export type AppointmentWarning = {
  code?: Maybe<AppointmentWarningCode>
  endDate: Scalars['AWSDateTime']['output']
  id: Scalars['ID']['output']
  message?: Maybe<Scalars['String']['output']>
  startDate: Scalars['AWSDateTime']['output']
}

export enum AppointmentWarningCode {
  AppointmentOverlap = '[appointment_overlap]',
}

export type AttachmentAnnotation = IAnnotation & {
  attachments?: Maybe<Array<File>>
  authorReference: Reference
  text: Scalars['String']['output']
  time: Scalars['AWSDateTime']['output']
}

export type AttachmentAnnotationInput = {
  attachments?: InputMaybe<Array<FileCreate>>
  text: Scalars['String']['input']
}

export type AuditEntry = {
  date: Scalars['AWSDateTime']['output']
  reference: Reference
}

export enum Availability {
  CareCoordinatorOnly = 'CARE_COORDINATOR_ONLY',
  Closed = 'CLOSED',
  Open = 'OPEN',
  OpenFlexible = 'OPEN_FLEXIBLE',
  OpenPrioritized = 'OPEN_PRIORITIZED',
  Pending = 'PENDING',
  PilotOnly = 'PILOT_ONLY',
  Recruiting = 'RECRUITING',
  WaitlistOnly = 'WAITLIST_ONLY',
}

export type AvailabilityRequest = {
  endDate: Scalars['AWSDateTime']['input']
  patientEmrId?: InputMaybe<Scalars['String']['input']>
  providerEmrId: Scalars['String']['input']
  startDate: Scalars['AWSDateTime']['input']
}

export type AvailabilityResponse = {
  patientIsAvailable?: Maybe<Scalars['Boolean']['output']>
  providerIsAvailable: Scalars['Boolean']['output']
}

export type BillingInput = {
  comment?: InputMaybe<CommentAnnotationInput>
  consentPacketSignedDate?: InputMaybe<Scalars['AWSDateTime']['input']>
  creditCardOnFile?: InputMaybe<Scalars['Boolean']['input']>
  fullConsentPackedSigned?: InputMaybe<Scalars['Boolean']['input']>
  idFile?: InputMaybe<FileUpdate>
  idRelationship?: InputMaybe<PatientRelationshipToIdCard>
  idType?: InputMaybe<IdentificationType>
  idValue?: InputMaybe<Scalars['String']['input']>
  insurances?: InputMaybe<Array<BillingInsuredInput>>
  selfPay?: InputMaybe<Scalars['Boolean']['input']>
}

export type BillingInsured = {
  addressComponents?: Maybe<AddressComponents>
  cardBack?: Maybe<File>
  cardFront?: Maybe<File>
  coPay?: Maybe<Scalars['String']['output']>
  coinsurance?: Maybe<Scalars['Int']['output']>
  dateOfBirth?: Maybe<Scalars['AWSDate']['output']>
  deductible?: Maybe<Scalars['Int']['output']>
  effectiveDate?: Maybe<Scalars['AWSDate']['output']>
  eligibilityReason?: Maybe<Scalars['String']['output']>
  eligibilityVerification?: Maybe<EligibilityVerification>
  eligibilityVerified?: Maybe<Scalars['Boolean']['output']>
  emrSyncStatus?: Maybe<EmrSyncStatusCode>
  expirationDate?: Maybe<Scalars['AWSDate']['output']>
  familyDeductible?: Maybe<Scalars['Int']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  idNumber?: Maybe<Scalars['String']['output']>
  insurancePlanId?: Maybe<Scalars['ID']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  legalSex?: Maybe<PatientLegalSex>
  medicaidCard?: Maybe<File>
  medicaidIdNumber?: Maybe<Scalars['String']['output']>
  medicareCard?: Maybe<File>
  medicareIdNumber?: Maybe<Scalars['String']['output']>
  middleInitial?: Maybe<Scalars['String']['output']>
  note?: Maybe<Scalars['String']['output']>
  otherPayerInfo?: Maybe<Scalars['String']['output']>
  outOfNetwork?: Maybe<Scalars['Boolean']['output']>
  outOfNetworkPlan?: Maybe<OutOfNetworkPlan>
  payerPlanName?: Maybe<Scalars['String']['output']>
  payerPlanType?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  policyGroupFecaNumber?: Maybe<Scalars['String']['output']>
  policyGroupName?: Maybe<Scalars['String']['output']>
  priorAuthRequired?: Maybe<PriorAuthStatus>
  referralRequired?: Maybe<Scalars['Boolean']['output']>
  relationship?: Maybe<PatientRelationshipToInsured>
  type?: Maybe<InsuranceOrdinality>
}

export type BillingInsuredInput = {
  addressComponents?: InputMaybe<AddressComponentsInput>
  cardBack?: InputMaybe<FileUpdate>
  cardFront?: InputMaybe<FileUpdate>
  coPay?: InputMaybe<Scalars['String']['input']>
  coinsurance?: InputMaybe<Scalars['Int']['input']>
  dateOfBirth?: InputMaybe<Scalars['AWSDate']['input']>
  deductible?: InputMaybe<Scalars['Int']['input']>
  effectiveDate?: InputMaybe<Scalars['AWSDate']['input']>
  eligibilityVerificationId?: InputMaybe<Scalars['String']['input']>
  eligibilityVerified?: InputMaybe<Scalars['Boolean']['input']>
  expirationDate?: InputMaybe<Scalars['AWSDate']['input']>
  familyDeductible?: InputMaybe<Scalars['Int']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  idNumber?: InputMaybe<Scalars['String']['input']>
  insurancePlanId?: InputMaybe<Scalars['ID']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  legalSex?: InputMaybe<PatientLegalSex>
  medicaidCard?: InputMaybe<FileUpdate>
  medicaidIdNumber?: InputMaybe<Scalars['String']['input']>
  medicareCard?: InputMaybe<FileUpdate>
  medicareIdNumber?: InputMaybe<Scalars['String']['input']>
  middleInitial?: InputMaybe<Scalars['String']['input']>
  note?: InputMaybe<Scalars['String']['input']>
  otherPayerInfo?: InputMaybe<Scalars['String']['input']>
  outOfNetwork?: InputMaybe<Scalars['Boolean']['input']>
  outOfNetworkPlan?: InputMaybe<OutOfNetworkPlanInput>
  payerPlanName?: InputMaybe<Scalars['String']['input']>
  payerPlanType?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  policyGroupFecaNumber?: InputMaybe<Scalars['String']['input']>
  policyGroupName?: InputMaybe<Scalars['String']['input']>
  priorAuthRequired?: InputMaybe<PriorAuthStatus>
  referralRequired?: InputMaybe<Scalars['Boolean']['input']>
  relationship?: InputMaybe<PatientRelationshipToInsured>
  type?: InputMaybe<InsuranceOrdinality>
}

export enum BillingRelationshipType {
  Autoinherited = 'AUTOINHERITED',
  Direct = 'DIRECT',
  Inherited = 'INHERITED',
}

export type BulkInsurancePlanUpdateInput = {
  _id: Scalars['ID']['input']
  billingPayerName?: InputMaybe<Scalars['String']['input']>
  comment?: InputMaybe<Scalars['String']['input']>
  companyName?: InputMaybe<Scalars['String']['input']>
  credentialingPayerId?: InputMaybe<Scalars['String']['input']>
  credentialingPayerName?: InputMaybe<Scalars['String']['input']>
  delegatedAuditDate?: InputMaybe<Scalars['AWSDate']['input']>
  delegatedEffectiveDate?: InputMaybe<Scalars['AWSDate']['input']>
  effectiveDate?: InputMaybe<Scalars['AWSDate']['input']>
  expirationDate?: InputMaybe<Scalars['AWSDate']['input']>
  groupId?: InputMaybe<Scalars['String']['input']>
  inNetworkBenefitTerms?: InputMaybe<Scalars['String']['input']>
  isDelegated?: InputMaybe<Scalars['Boolean']['input']>
  isInNetwork?: InputMaybe<Scalars['Boolean']['input']>
  isInheritanceDisabled?: InputMaybe<Scalars['Boolean']['input']>
  lineOfBusiness?: InputMaybe<InsurancePlanLineOfBusiness>
  notes?: InputMaybe<Scalars['String']['input']>
  outOfNetworkBenefitTerms?: InputMaybe<Scalars['String']['input']>
  payerCode?: InputMaybe<Scalars['String']['input']>
  payerId?: InputMaybe<Scalars['String']['input']>
  planId?: InputMaybe<Scalars['String']['input']>
  planType?: InputMaybe<Scalars['String']['input']>
  recredentialingDate?: InputMaybe<Scalars['AWSDate']['input']>
  status?: InputMaybe<InsurancePlanStatus>
  vendorName?: InputMaybe<Scalars['String']['input']>
  verificationDefaultLocation?: InputMaybe<Scalars['String']['input']>
  verificationDefaultProviderName?: InputMaybe<Scalars['String']['input']>
  verificationDefaultProviderNpi?: InputMaybe<Scalars['String']['input']>
  verificationPayerId?: InputMaybe<Scalars['String']['input']>
  verificationPayerName?: InputMaybe<Scalars['String']['input']>
}

export type CareManagerPermissions = {
  accessToNotes?: Maybe<Scalars['Boolean']['output']>
  addPatients?: Maybe<Scalars['Boolean']['output']>
  caseloadBulkSend?: Maybe<Scalars['Boolean']['output']>
  isAdmin?: Maybe<Scalars['Boolean']['output']>
  isSupervisor?: Maybe<Scalars['Boolean']['output']>
  providerListRead?: Maybe<Scalars['Boolean']['output']>
  providerListWrite?: Maybe<Scalars['Boolean']['output']>
  viewAllPatients?: Maybe<Scalars['Boolean']['output']>
}

export type CareManagerPermissionsInput = {
  accessToNotes?: InputMaybe<Scalars['Boolean']['input']>
  addPatients?: InputMaybe<Scalars['Boolean']['input']>
  caseloadBulkSend?: InputMaybe<Scalars['Boolean']['input']>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>
  providerListRead?: InputMaybe<Scalars['Boolean']['input']>
  providerListWrite?: InputMaybe<Scalars['Boolean']['input']>
  viewAllPatients?: InputMaybe<Scalars['Boolean']['input']>
}

export type CareManagerUser = {
  careManagerId: Scalars['String']['output']
  email: Scalars['String']['output']
  emrId?: Maybe<Scalars['String']['output']>
  firstName: Scalars['String']['output']
  id: Scalars['String']['output']
  isEnabled: Scalars['Boolean']['output']
  isProvider: Scalars['Boolean']['output']
  lastName: Scalars['String']['output']
  permissions?: Maybe<CareManagerPermissions>
  pronouns?: Maybe<Scalars['String']['output']>
  username: Scalars['String']['output']
}

export type CareTeamInput = {
  forcePctmOOO?: InputMaybe<Scalars['Boolean']['input']>
  members?: InputMaybe<Array<CareTeamMemberInput>>
  pctmId: Scalars['ID']['input']
}

export type CareTeamMember = {
  displayName?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  isEnabled?: Maybe<Scalars['Boolean']['output']>
  isPctm?: Maybe<Scalars['Boolean']['output']>
  role?: Maybe<Scalars['String']['output']>
}

export enum CareTeamMemberAction {
  Add = 'add',
  Remove = 'remove',
}

export type CareTeamMemberInput = {
  ctmId: Scalars['ID']['input']
}

/** This is named different than the api and thus cannot use fragments */
export type CareTeamSearchMember = {
  careManagerId: Scalars['ID']['output']
  display?: Maybe<Scalars['String']['output']>
  isPrimary: Scalars['Boolean']['output']
}

export type CodeableConcept = ICodeableConcept & {
  code?: Maybe<Scalars['String']['output']>
  coding?: Maybe<Array<Coding>>
  text?: Maybe<Scalars['String']['output']>
}

export type Coding = {
  code: Scalars['String']['output']
  display?: Maybe<Scalars['String']['output']>
  system?: Maybe<Scalars['String']['output']>
}

export type Cognito = {
  isEnabled: Scalars['Boolean']['output']
  userAttributes: CognitoAttributes
  userStatus: Scalars['String']['output']
  username: Scalars['String']['output']
}

export type CognitoAttributes = {
  email: Scalars['String']['output']
  email_verified?: Maybe<Scalars['Boolean']['output']>
  family_name?: Maybe<Scalars['String']['output']>
  given_name?: Maybe<Scalars['String']['output']>
  identities?: Maybe<Scalars['String']['output']>
  middle_name?: Maybe<Scalars['String']['output']>
  nickname?: Maybe<Scalars['String']['output']>
  phone_number?: Maybe<Scalars['String']['output']>
  phone_number_verified?: Maybe<Scalars['Boolean']['output']>
  picture?: Maybe<Scalars['String']['output']>
  preferred_username?: Maybe<Scalars['String']['output']>
  pronouns?: Maybe<Scalars['String']['output']>
  sub: Scalars['String']['output']
  updated_at?: Maybe<Scalars['String']['output']>
}

export enum CognitoUserStatus {
  Archived = 'ARCHIVED',
  Compromised = 'COMPROMISED',
  Confirmed = 'CONFIRMED',
  ExternalProvider = 'EXTERNAL_PROVIDER',
  ForceChangePassword = 'FORCE_CHANGE_PASSWORD',
  ResetRequired = 'RESET_REQUIRED',
  Unconfirmed = 'UNCONFIRMED',
  Unknown = 'UNKNOWN',
}

export type CommentAnnotationInput = {
  text: Scalars['String']['input']
}

export enum CommunicationMedium {
  Email = 'EMAIL',
  Sms = 'SMS',
}

export enum CommunityIdentity {
  Bipoc = 'BIPOC',
  Lgbtqia = 'LGBTQIA',
}

export type CompleteFormSubmissionInput = {
  submissionId: Scalars['ID']['input']
}

export type CompletePatientRegistrationSubmission = {
  submissionId: Scalars['String']['input']
}

export type ConfigItem = {
  key: Scalars['String']['output']
  value: Scalars['AWSJSON']['output']
}

export type ConfirmOtpAndMatchInput = {
  dateOfBirth: Scalars['AWSDate']['input']
  emailAddress: Scalars['AWSEmail']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  otpToken: Scalars['String']['input']
  phoneNumber: Scalars['String']['input']
  publicCode?: InputMaybe<Scalars['String']['input']>
}

export type ConfirmOtpResponse = {
  access_token: Scalars['String']['output']
  expires_in: Scalars['Int']['output']
  token_type: TokenType
}

export type ConsentPacketInfo = {
  agreementId?: Maybe<Scalars['ID']['output']>
  sent?: Maybe<AuditEntry>
  signedDate?: Maybe<Scalars['AWSDateTime']['output']>
}

export enum ConsentPacketSigningUrlStatus {
  AlreadySigned = 'ALREADY_SIGNED',
  Error = 'ERROR',
  NoAgreementId = 'NO_AGREEMENT_ID',
  SigningUrlNotReady = 'SIGNING_URL_NOT_READY',
  SigningUrlRetrieved = 'SIGNING_URL_RETRIEVED',
  UnrecognizedVendor = 'UNRECOGNIZED_VENDOR',
}

export type Contact = {
  email?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  primary?: Maybe<Scalars['Boolean']['output']>
  relation?: Maybe<Scalars['String']['output']>
  use?: Maybe<Scalars['String']['output']>
}

export type ContactInput = {
  email?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  phone: Scalars['String']['input']
  primary?: InputMaybe<Scalars['Boolean']['input']>
  relation: PatientContactRelation
  use?: InputMaybe<PatientContactUse>
}

export type CreateAppointmentExternalInput = {
  appointmentType?: InputMaybe<AppointmentType>
  cancelationReason?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  endDate?: InputMaybe<Scalars['AWSDateTime']['input']>
  locationId?: InputMaybe<Scalars['String']['input']>
  minutesDuration?: InputMaybe<Scalars['Float']['input']>
  note?: InputMaybe<Scalars['String']['input']>
  providerId: Scalars['String']['input']
  serviceCategory?: InputMaybe<ServiceCategoryCode>
  serviceType?: InputMaybe<ServiceTypeCode>
  startDate?: InputMaybe<Scalars['AWSDateTime']['input']>
  status?: InputMaybe<AppointmentStatus>
  virtualService?: InputMaybe<VirtualServiceInput>
}

export type CreateAppointmentResponse = {
  appointment: Appointment
  warnings: Array<AppointmentWarning>
}

export type CreateConsentPacketExternalInput = {
  patientLegalName?: InputMaybe<Scalars['String']['input']>
  preferredLanguage?: InputMaybe<Scalars['String']['input']>
  primaryEmail: Scalars['String']['input']
  redirectUrl?: InputMaybe<Scalars['String']['input']>
}

export type CreateConsentPacketResponse = {
  code?: Maybe<Scalars['String']['output']>
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type CreateDocumentInput = {
  file: FileCreate
}

export type CreateFormSubmissionInput = {
  address?: InputMaybe<AddressComponentsInput>
  appointmentId?: InputMaybe<Scalars['String']['input']>
  billing?: InputMaybe<BillingInput>
  conditionInterferingWithVirtualTreatment?: InputMaybe<
    Scalars['Boolean']['input']
  >
  contacts?: InputMaybe<Array<ContactInput>>
  dischargeDate?: InputMaybe<Scalars['AWSDate']['input']>
  dischargeType?: InputMaybe<Scalars['String']['input']>
  dob: Scalars['AWSDate']['input']
  documents?: InputMaybe<Array<CreateDocumentInput>>
  email?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  gender?: InputMaybe<PatientGenderIdentity>
  genderDetails?: InputMaybe<Scalars['String']['input']>
  hospitalized?: InputMaybe<Scalars['Boolean']['input']>
  lastName: Scalars['String']['input']
  legalSex: PatientLegalSex
  meta?: InputMaybe<Scalars['AWSJSON']['input']>
  patientTimeZone?: InputMaybe<Scalars['String']['input']>
  phoneNumber: Scalars['String']['input']
  preferredContactDaysOfWeek?: InputMaybe<Array<DayOfWeek>>
  preferredContactTimes?: InputMaybe<Array<Scalars['String']['input']>>
  preferredLanguage?: InputMaybe<Scalars['String']['input']>
  preferredName?: InputMaybe<Scalars['String']['input']>
  pronouns?: InputMaybe<Scalars['String']['input']>
  referralSource?: InputMaybe<Scalars['String']['input']>
  referralSourceOther?: InputMaybe<Scalars['String']['input']>
  referrer?: InputMaybe<ReferrerInformationInput>
  serviceType?: InputMaybe<Array<Scalars['String']['input']>>
  specialty?: InputMaybe<Array<Scalars['String']['input']>>
  tellUsMore?: InputMaybe<Scalars['String']['input']>
  treatmentHistory?: InputMaybe<Scalars['String']['input']>
}

export type CreatePatientBillingInput = {
  data: UpdateBillingInput
  treatmentId: Scalars['ID']['input']
}

export type CreatePatientCareInput = {
  careTeam: CareTeamInput
  device?: InputMaybe<DeviceInput>
  disableChat?: InputMaybe<Scalars['Boolean']['input']>
  hospitalized?: InputMaybe<Scalars['Boolean']['input']>
  planTemplateIds?: InputMaybe<Array<Scalars['ID']['input']>>
  questionnaires?: InputMaybe<Array<QuestionnaireInput>>
  referralSource?: InputMaybe<Scalars['String']['input']>
  scaleId?: InputMaybe<Scalars['String']['input']>
}

export type CreatePatientConfigurationInput = {
  forceMultiPhone?: InputMaybe<Scalars['Boolean']['input']>
  modifyUsername?: InputMaybe<Scalars['Boolean']['input']>
  notifyPatient?: InputMaybe<Scalars['Boolean']['input']>
  skipUsernameValidation?: InputMaybe<Scalars['Boolean']['input']>
}

export type CreatePatientDemographicsInput = {
  addressComponents?: InputMaybe<AddressComponentsInput>
  contacts?: InputMaybe<Array<ContactInput>>
  dateOfBirth: Scalars['AWSDate']['input']
  email?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  gender: PatientLegalSex
  genderDetails?: InputMaybe<Scalars['String']['input']>
  genderIdentity?: InputMaybe<PatientGenderIdentity>
  languages?: InputMaybe<Array<Scalars['String']['input']>>
  lastName: Scalars['String']['input']
  middleName?: InputMaybe<Scalars['String']['input']>
  mrn?: InputMaybe<Scalars['String']['input']>
  phone: Scalars['String']['input']
  picture?: InputMaybe<Scalars['String']['input']>
  preferredLanguage?: InputMaybe<Scalars['String']['input']>
  preferredName?: InputMaybe<Scalars['String']['input']>
  primaryEmail?: InputMaybe<Scalars['String']['input']>
  primaryPhone?: InputMaybe<Scalars['String']['input']>
  pronouns?: InputMaybe<Scalars['String']['input']>
  registrationSource?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<PatientStatus>
  tags?: InputMaybe<Array<Scalars['String']['input']>>
  timezone: Scalars['String']['input']
  username?: InputMaybe<Scalars['String']['input']>
}

export type CreatePatientInput = {
  care: CreatePatientCareInput
  configuration?: InputMaybe<CreatePatientConfigurationInput>
  demographics: CreatePatientDemographicsInput
}

export type CreatePatientRegistrationSubmission = {
  additionalTaskDescription?: InputMaybe<Scalars['AWSJSON']['input']>
  address?: InputMaybe<AddressComponentsInput>
  appointmentId?: InputMaybe<Scalars['ID']['input']>
  billing?: InputMaybe<UpdateBillingInput>
  conditionInterferingWithVirtualTreatment?: InputMaybe<
    Scalars['Boolean']['input']
  >
  contacts?: InputMaybe<Array<ContactInput>>
  dischargeDate?: InputMaybe<Scalars['AWSDate']['input']>
  dischargeType?: InputMaybe<Scalars['String']['input']>
  dob: Scalars['AWSDate']['input']
  documents?: InputMaybe<Array<CreateDocumentInput>>
  email?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  gender?: InputMaybe<PatientGenderIdentity>
  genderDetails?: InputMaybe<Scalars['String']['input']>
  hospitalized?: InputMaybe<Scalars['Boolean']['input']>
  lastName: Scalars['String']['input']
  legalSex: PatientLegalSex
  meta?: InputMaybe<Scalars['AWSJSON']['input']>
  patientTimeZone?: InputMaybe<Scalars['String']['input']>
  phoneNumber: Scalars['String']['input']
  preferredContactDaysOfWeek?: InputMaybe<Array<DayOfWeek>>
  preferredContactTimes?: InputMaybe<Array<Scalars['String']['input']>>
  preferredLanguage?: InputMaybe<Scalars['String']['input']>
  preferredName?: InputMaybe<Scalars['String']['input']>
  referralSource?: InputMaybe<Scalars['String']['input']>
  referralSourceOther?: InputMaybe<Scalars['String']['input']>
  referrer?: InputMaybe<ReferrerInformation>
  serviceType?: InputMaybe<Array<Scalars['String']['input']>>
  specialty?: InputMaybe<Array<Scalars['String']['input']>>
  taskAssigneeOverride?: InputMaybe<Scalars['String']['input']>
  taskDueDateOverride?: InputMaybe<Scalars['AWSDate']['input']>
  taskPatientPreferencesOverride?: InputMaybe<Scalars['AWSJSON']['input']>
  taskTypeOverride?: InputMaybe<PatientOnboardingTaskType>
  tellUsMore?: InputMaybe<Scalars['String']['input']>
  treatmentHistory?: InputMaybe<Scalars['String']['input']>
}

export type CreatePayerEnrollmentInput = {
  comment?: InputMaybe<AttachmentAnnotationInput>
  effectiveDate?: InputMaybe<Scalars['AWSDate']['input']>
  entity?: InputMaybe<Scalars['String']['input']>
  expirationDate?: InputMaybe<Scalars['AWSDate']['input']>
  payerExternalProviderId?: InputMaybe<Scalars['String']['input']>
  payerId: Scalars['ID']['input']
  recredentialingDate?: InputMaybe<Scalars['AWSDate']['input']>
  status: Scalars['String']['input']
  submissionDate?: InputMaybe<Scalars['AWSDate']['input']>
  terminationDate?: InputMaybe<Scalars['AWSDate']['input']>
  vendor?: InputMaybe<Scalars['String']['input']>
}

export type CreateProviderDocumentInput = {
  documentCategory: DocumentCategory
  file: FileCreate
  stateCode?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<DocumentVerificationStatus>
}

export type CreateTaskInput = {
  assignee: Scalars['ID']['input']
  comment?: InputMaybe<Scalars['String']['input']>
  description: Scalars['String']['input']
  dueDate: Scalars['AWSDate']['input']
  patient?: InputMaybe<PatientMetaDataInput>
  patientId: Scalars['ID']['input']
  patientPreferences?: InputMaybe<Scalars['AWSJSON']['input']>
  referralSource?: InputMaybe<Scalars['String']['input']>
  serviceType?: InputMaybe<TaskServiceType>
  status: TaskStatus
  treatmentId: Scalars['ID']['input']
  type: TaskType
}

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
}

export type DayTime = {
  dayOfWeek: DayOfWeek
  endTime: Scalars['AWSTime']['output']
  startTime: Scalars['AWSTime']['output']
}

export type DayTimeInput = {
  dayOfWeek: DayOfWeek
  endTime: Scalars['AWSTime']['input']
  startTime: Scalars['AWSTime']['input']
}

export type DecryptInput = {
  algorithm?: InputMaybe<Scalars['String']['input']>
  cipherText: Scalars['String']['input']
  entityId: Scalars['ID']['input']
  fieldReference: FieldReference
}

export type DecryptResponse = {
  plainText: Scalars['String']['output']
}

export type Device = {
  type?: Maybe<Scalars['String']['output']>
  useMobileApp?: Maybe<Scalars['Boolean']['output']>
}

export type DeviceInput = {
  type?: InputMaybe<Scalars['String']['input']>
  useMobileApp: Scalars['Boolean']['input']
}

export type DisplayMessage = {
  en?: Maybe<Scalars['String']['output']>
  es?: Maybe<Scalars['String']['output']>
  zh_chs?: Maybe<Scalars['String']['output']>
  zh_tw?: Maybe<Scalars['String']['output']>
}

export type Document = {
  created: AuditEntry
  file: File
  id: Scalars['ID']['output']
  modified?: Maybe<AuditEntry>
}

export enum DocumentCategory {
  Attestation = 'ATTESTATION',
  ClinicalAcknowledgement = 'CLINICAL_ACKNOWLEDGEMENT',
  ClinicalLicense = 'CLINICAL_LICENSE',
  ClinicalRegistration = 'CLINICAL_REGISTRATION',
  Cme = 'CME',
  DeaLicense = 'DEA_LICENSE',
  Education = 'EDUCATION',
  Id = 'ID',
  Other = 'OTHER',
  PrimaryLiabilityInsurance = 'PRIMARY_LIABILITY_INSURANCE',
  ProfessionalLiabilityInsurance = 'PROFESSIONAL_LIABILITY_INSURANCE',
  Report = 'REPORT',
  ReportsAndVerifications = 'REPORTS_AND_VERIFICATIONS',
  /** Deprecated */
  ReportCaqhSummary = 'REPORT_CAQH_SUMMARY',
  /** Deprecated */
  ReportCmsOptOut = 'REPORT_CMS_OPT_OUT',
  /** Deprecated */
  ReportNpdbQuery = 'REPORT_NPDB_QUERY',
  /** Deprecated */
  ReportNppesOrNpi = 'REPORT_NPPES_OR_NPI',
  /** Deprecated */
  ReportOfac = 'REPORT_OFAC',
  /** Deprecated */
  ReportOig = 'REPORT_OIG',
  /** Deprecated */
  ReportSam = 'REPORT_SAM',
  /** Deprecated */
  ReportSsnvsFile = 'REPORT_SSNVS_FILE',
  Specialty = 'SPECIALTY',
}

export enum DocumentVerificationStatus {
  NotVerified = 'NOT_VERIFIED',
  Verified = 'VERIFIED',
}

export enum EducationProgramType {
  Associates = 'ASSOCIATES',
  ElementaryPrimarySchool = 'ELEMENTARY_PRIMARY_SCHOOL',
  GraduateSchool = 'GRADUATE_SCHOOL',
  HighSchool = 'HIGH_SCHOOL',
  LawSchool = 'LAW_SCHOOL',
  Masters = 'MASTERS',
  MedicalSchool = 'MEDICAL_SCHOOL',
  NursingGraduateProgram = 'NURSING_GRADUATE_PROGRAM',
  Undergraduate = 'UNDERGRADUATE',
}

export type EligibilityInsured = {
  dateOfServiceEnd: Scalars['String']['output']
  dateOfServiceStart: Scalars['String']['output']
  dob: Scalars['String']['output']
  firstName: Scalars['String']['output']
  lastName: Scalars['String']['output']
  memberId: Scalars['String']['output']
  patientRelationship: Scalars['String']['output']
}

export type EligibilityInsuredInput = {
  dateOfServiceStart: Scalars['String']['input']
  dob: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  memberId: Scalars['String']['input']
  patientRelationship: PatientRelationshipToInsured
}

export type EligibilityInsuredInputV2 = {
  dateOfServiceEnd?: InputMaybe<Scalars['String']['input']>
  dateOfServiceStart: Scalars['String']['input']
  dob: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  memberId: Scalars['String']['input']
  patientRelationship: Scalars['String']['input']
}

export type EligibilityPatient = {
  dob: Scalars['String']['output']
  firstName: Scalars['String']['output']
  lastName: Scalars['String']['output']
  mrn?: Maybe<Scalars['String']['output']>
}

export type EligibilityPatientInput = {
  dob: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  mrn?: InputMaybe<Scalars['String']['input']>
}

export type EligibilityPatientInputV2 = {
  dob: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  mrn?: InputMaybe<Scalars['String']['input']>
}

export type EligibilityVerification = {
  actionLog: Array<ActionEntry>
  benefitSummaryPdfFile?: Maybe<Scalars['String']['output']>
  billingInsuranceId?: Maybe<Scalars['ID']['output']>
  generatingBenefitSummaryPdfFile?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  insurancePlanId?: Maybe<Scalars['ID']['output']>
  insured?: Maybe<EligibilityInsured>
  isActive?: Maybe<Scalars['Boolean']['output']>
  location: Scalars['String']['output']
  payerId: Scalars['String']['output']
  providerName: Scalars['String']['output']
  providerNpi: Scalars['String']['output']
  requestId?: Maybe<Scalars['Int']['output']>
  treatmentId?: Maybe<Scalars['ID']['output']>
  ts?: Maybe<Scalars['AWSDateTime']['output']>
  vendor?: Maybe<VerificationVendor>
}

export type EligibilityVerificationExternal = {
  benefitSummaryPdfFile?: Maybe<Scalars['String']['output']>
  billingInsuranceId?: Maybe<Scalars['String']['output']>
  coPay?: Maybe<Scalars['String']['output']>
  coinsurance?: Maybe<Scalars['Int']['output']>
  deductible?: Maybe<Scalars['Int']['output']>
  eligibilityReason?: Maybe<Scalars['String']['output']>
  eligibilityVerificationCategory?: Maybe<Scalars['String']['output']>
  familyDeductible?: Maybe<Scalars['Int']['output']>
  id: Scalars['String']['output']
  insurancePlanId?: Maybe<Scalars['ID']['output']>
  insured?: Maybe<EligibilityInsured>
  isActive?: Maybe<Scalars['Boolean']['output']>
  location?: Maybe<Scalars['String']['output']>
  payerId: Scalars['String']['output']
  providerName: Scalars['String']['output']
  providerNpi: Scalars['String']['output']
  requestId?: Maybe<Scalars['Int']['output']>
  ts?: Maybe<Scalars['String']['output']>
  vendor?: Maybe<Scalars['String']['output']>
}

export type EligibilityVerificationV2 = {
  actionLog?: Maybe<Array<ActionEntry>>
  benefitSummaryPdfFile?: Maybe<Scalars['String']['output']>
  billingInsuranceId?: Maybe<Scalars['String']['output']>
  coPay?: Maybe<Scalars['String']['output']>
  coinsurance?: Maybe<Scalars['Int']['output']>
  deductible?: Maybe<Scalars['Int']['output']>
  familyDeductible?: Maybe<Scalars['Int']['output']>
  generatingBenefitSummaryPdfFile?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['String']['output']
  insurancePlanId?: Maybe<Scalars['ID']['output']>
  insured?: Maybe<EligibilityInsured>
  isActive?: Maybe<Scalars['Boolean']['output']>
  location?: Maybe<Scalars['String']['output']>
  note?: Maybe<Scalars['String']['output']>
  payerId: Scalars['String']['output']
  providerName: Scalars['String']['output']
  providerNpi: Scalars['String']['output']
  requestId?: Maybe<Scalars['Int']['output']>
  treatmentId?: Maybe<Scalars['String']['output']>
  ts?: Maybe<Scalars['String']['output']>
  vendor?: Maybe<Scalars['String']['output']>
}

export type Employment = {
  _id: Scalars['ID']['output']
  hireDate?: Maybe<Scalars['AWSDate']['output']>
  legalSex?: Maybe<LegalSex>
  onboardingCompleteDate?: Maybe<Scalars['AWSDate']['output']>
  profession?: Maybe<ProfessionCode>
  role?: Maybe<EmploymentRole>
  startDate?: Maybe<Scalars['AWSDate']['output']>
  stateOfResidence?: Maybe<Scalars['String']['output']>
  status?: Maybe<EmploymentStatus>
  terminationDate?: Maybe<Scalars['AWSDate']['output']>
  title?: Maybe<Scalars['String']['output']>
  type?: Maybe<EmploymentType>
}

export type EmploymentInput = {
  hireDate?: InputMaybe<Scalars['AWSDate']['input']>
  legalSex?: InputMaybe<LegalSex>
  profession?: InputMaybe<ProfessionCode>
  role?: InputMaybe<EmploymentRole>
  startDate?: InputMaybe<Scalars['AWSDate']['input']>
  stateOfResidence?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<EmploymentStatus>
  terminationDate?: InputMaybe<Scalars['AWSDate']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<EmploymentType>
}

export enum EmploymentRole {
  AssociateTherapist = 'ASSOCIATE_THERAPIST',
  CareCoordinator = 'CARE_COORDINATOR',
  CaseManager = 'CASE_MANAGER',
  GroupTherapy = 'GROUP_THERAPY',
  HealthConnector = 'HEALTH_CONNECTOR',
  MedicalAssistant = 'MEDICAL_ASSISTANT',
  Prescriber = 'PRESCRIBER',
  PrescriberSupervisor = 'PRESCRIBER_SUPERVISOR',
  Therapist = 'THERAPIST',
  TherapistSupervisor = 'THERAPIST_SUPERVISOR',
}

export enum EmploymentStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Onleave = 'ONLEAVE',
  Pending = 'PENDING',
  Resigning = 'RESIGNING',
}

export enum EmploymentType {
  Contract = 'CONTRACT',
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME',
}

export type EmrSyncStatistics = {
  emrSyncStatus: EmrSyncStatusCode
  lastSynced?: Maybe<AuditEntry>
}

export type EmrSyncStatisticsResponse = {
  emrSyncStatus: EmrSyncStatusCode
  lastSynced?: Maybe<AuditEntry>
  message?: Maybe<Scalars['String']['output']>
}

export enum EmrSyncStatusCode {
  Error = 'ERROR',
  ImportantUnsynced = 'IMPORTANT_UNSYNCED',
  InProgress = 'IN_PROGRESS',
  PartialUnsynced = 'PARTIAL_UNSYNCED',
  Synced = 'SYNCED',
  Unknown = 'UNKNOWN',
}

export enum EmrTarget {
  Mmr = 'MMR',
  Nextgen = 'NEXTGEN',
}

export type EncryptInput = {
  entityId: Scalars['ID']['input']
  fieldReference: FieldReference
  plainText: Scalars['String']['input']
}

export type EncryptResponse = {
  algorithm: Scalars['String']['output']
  cipherText: Scalars['String']['output']
}

export type EncryptedValue = {
  algorithm: Scalars['String']['output']
  cipherText: Scalars['String']['output']
  display?: Maybe<Scalars['String']['output']>
}

export enum Ethnicity {
  Hispanic = 'HISPANIC',
  NotHispanic = 'NOT_HISPANIC',
}

export type ExpectedHours = {
  endDate?: Maybe<Scalars['AWSDate']['output']>
  serviceCategory: ServiceCategory
  startDate?: Maybe<Scalars['AWSDate']['output']>
  weeklyMinutesTotal: Scalars['Int']['output']
}

export type ExpectedHoursInput = {
  endDate?: InputMaybe<Scalars['AWSDate']['input']>
  serviceCategory: ServiceCategoryCode
  startDate?: InputMaybe<Scalars['AWSDate']['input']>
  weeklyMinutesTotal: Scalars['Int']['input']
}

export type ExternalResponse = {
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export enum FieldReference {
  Externalaccountpassword = 'EXTERNALACCOUNTPASSWORD',
  Ssn = 'SSN',
}

export type File = {
  mimeType: Scalars['String']['output']
  name: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type FileCreate = {
  mimeType: Scalars['String']['input']
  name: Scalars['String']['input']
  s3Key: Scalars['String']['input']
}

export type FileUpdate = {
  mimeType?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  s3Key?: InputMaybe<Scalars['String']['input']>
}

export enum GenderIdentity {
  Female = 'FEMALE',
  Genderqueer = 'GENDERQUEER',
  Male = 'MALE',
  NonBinary = 'NON_BINARY',
  NonDisclose = 'NON_DISCLOSE',
  Other = 'OTHER',
  TransFemale = 'TRANS_FEMALE',
  TransMale = 'TRANS_MALE',
}

export type GeneratePatientLinkInput = {
  treatmentId: Scalars['ID']['input']
}

export type GetExternalLocationsInput = {
  programCode?: InputMaybe<Scalars['String']['input']>
}

export type GetExternalPracticeServicesInput = {
  programCode?: InputMaybe<Scalars['String']['input']>
}

export type GetExternalPracticeStatesInput = {
  programCode?: InputMaybe<Scalars['String']['input']>
}

export type GetSigningUrlExternalInput = {
  patientLegalName?: InputMaybe<Scalars['String']['input']>
  primaryEmail: Scalars['String']['input']
  redirectUrl?: InputMaybe<Scalars['String']['input']>
}

export type GetSigningUrlExternalResponse = {
  code?: Maybe<ConsentPacketSigningUrlStatus>
  message?: Maybe<Scalars['String']['output']>
  shouldEmbed?: Maybe<Scalars['Boolean']['output']>
  signingUrl?: Maybe<Scalars['String']['output']>
}

export type GetUserByIdInput = {
  careManagerId?: InputMaybe<Scalars['ID']['input']>
  cognitoUserId?: InputMaybe<Scalars['ID']['input']>
}

export type GoogleSignUpInput = {
  careManagerPermissions?: InputMaybe<CareManagerPermissionsInput>
  email: Scalars['String']['input']
  isProvider?: InputMaybe<Scalars['Boolean']['input']>
  permitRoles: Array<Scalars['ID']['input']>
}

export type IAnnotation = {
  authorReference: Reference
  text: Scalars['String']['output']
  time: Scalars['AWSDateTime']['output']
}

export type ICodeableConcept = {
  coding?: Maybe<Array<Coding>>
  text?: Maybe<Scalars['String']['output']>
}

export type IListItem = {
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  label: Scalars['String']['output']
  sortOrder?: Maybe<Scalars['Int']['output']>
  value: Scalars['String']['output']
}

export enum IdentificationType {
  DriversLicense = 'drivers_license',
  Passport = 'passport',
  StateId = 'state_id',
}

export type Identifier = {
  period?: Maybe<Period>
  type: CodeableConcept
  value: Scalars['String']['output']
}

export enum InsuranceOrdinality {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
}

export type InsurancePlanBillingRelationship = {
  reference?: Maybe<Reference>
  type: BillingRelationshipType
}

export type InsurancePlanBillingRelationshipInput = {
  referenceId?: InputMaybe<Scalars['ID']['input']>
  type: BillingRelationshipType
}

export type InsurancePlanCreateInput = {
  billingPayerName?: InputMaybe<Scalars['String']['input']>
  comment?: InputMaybe<Scalars['String']['input']>
  companyName?: InputMaybe<Scalars['String']['input']>
  credentialingPayerId?: InputMaybe<Scalars['String']['input']>
  credentialingPayerName?: InputMaybe<Scalars['String']['input']>
  delegatedAuditDate?: InputMaybe<Scalars['AWSDate']['input']>
  delegatedEffectiveDate?: InputMaybe<Scalars['AWSDate']['input']>
  effectiveDate?: InputMaybe<Scalars['AWSDate']['input']>
  expirationDate?: InputMaybe<Scalars['AWSDate']['input']>
  groupId?: InputMaybe<Scalars['String']['input']>
  identifiers?: InputMaybe<Array<InsurancePlanIdentifierInput>>
  inNetworkBenefitTerms?: InputMaybe<Scalars['String']['input']>
  isDelegated: Scalars['Boolean']['input']
  isInNetwork: Scalars['Boolean']['input']
  isInheritanceDisabled?: InputMaybe<Scalars['Boolean']['input']>
  lineOfBusiness?: InputMaybe<InsurancePlanLineOfBusiness>
  name: Scalars['String']['input']
  notes?: InputMaybe<Scalars['String']['input']>
  outOfNetworkBenefitTerms?: InputMaybe<Scalars['String']['input']>
  payerCode?: InputMaybe<Scalars['String']['input']>
  payerId?: InputMaybe<Scalars['String']['input']>
  planId?: InputMaybe<Scalars['String']['input']>
  planType?: InputMaybe<Scalars['String']['input']>
  recredentialingDate?: InputMaybe<Scalars['AWSDate']['input']>
  stateCode?: InputMaybe<Scalars['String']['input']>
  stateName?: InputMaybe<Scalars['String']['input']>
  status: InsurancePlanStatus
  tocConfiguration?: InputMaybe<Array<TocConfigurationInput>>
  vendorName?: InputMaybe<Scalars['String']['input']>
  verificationDefaultLocation?: InputMaybe<Scalars['String']['input']>
  verificationDefaultProviderName?: InputMaybe<Scalars['String']['input']>
  verificationDefaultProviderNpi?: InputMaybe<Scalars['String']['input']>
  verificationPayerId?: InputMaybe<Scalars['String']['input']>
  verificationPayerName?: InputMaybe<Scalars['String']['input']>
}

export type InsurancePlanExternal = {
  _id: Scalars['ID']['output']
  companyName?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  payerId?: Maybe<Scalars['String']['output']>
  payerName?: Maybe<Scalars['String']['output']>
  stateCode?: Maybe<Scalars['String']['output']>
  stateName?: Maybe<Scalars['String']['output']>
  tocConfiguration?: Maybe<Array<TocConfiguration>>
  verificationPayerId?: Maybe<Scalars['String']['output']>
  verificationPayerName?: Maybe<Scalars['String']['output']>
}

export type InsurancePlanFull = {
  _id: Scalars['ID']['output']
  billingPayerName?: Maybe<Scalars['String']['output']>
  comments?: Maybe<Array<Annotation>>
  companyName?: Maybe<Scalars['String']['output']>
  credentialingPayerId?: Maybe<Scalars['String']['output']>
  credentialingPayerName?: Maybe<Scalars['String']['output']>
  delegatedAuditDate?: Maybe<Scalars['AWSDate']['output']>
  delegatedEffectiveDate?: Maybe<Scalars['AWSDate']['output']>
  effectiveDate?: Maybe<Scalars['AWSDate']['output']>
  entityName?: Maybe<Scalars['String']['output']>
  expirationDate?: Maybe<Scalars['AWSDate']['output']>
  groupId?: Maybe<Scalars['String']['output']>
  groupNpi?: Maybe<Scalars['String']['output']>
  identifiers: Array<InsurancePlanIdentifier>
  inNetworkBenefitTerms?: Maybe<Scalars['String']['output']>
  isDelegated: Scalars['Boolean']['output']
  isInNetwork: Scalars['Boolean']['output']
  isInheritanceDisabled?: Maybe<Scalars['Boolean']['output']>
  lineOfBusiness?: Maybe<InsurancePlanLineOfBusiness>
  name: Scalars['String']['output']
  notes?: Maybe<Scalars['String']['output']>
  outOfNetworkBenefitTerms?: Maybe<Scalars['String']['output']>
  payerCode?: Maybe<Scalars['String']['output']>
  payerId?: Maybe<Scalars['String']['output']>
  payerName?: Maybe<Scalars['String']['output']>
  planId?: Maybe<Scalars['String']['output']>
  planType?: Maybe<Scalars['String']['output']>
  recredentialingDate?: Maybe<Scalars['AWSDate']['output']>
  stateCode?: Maybe<Scalars['String']['output']>
  stateName?: Maybe<Scalars['String']['output']>
  status: InsurancePlanStatus
  taxId?: Maybe<Scalars['String']['output']>
  tocConfiguration?: Maybe<Array<TocConfiguration>>
  vendorName?: Maybe<Scalars['String']['output']>
  verificationDefaultLocation?: Maybe<Scalars['String']['output']>
  verificationDefaultProviderName?: Maybe<Scalars['String']['output']>
  verificationDefaultProviderNpi?: Maybe<Scalars['String']['output']>
  verificationPayerId?: Maybe<Scalars['String']['output']>
  verificationPayerName?: Maybe<Scalars['String']['output']>
}

export type InsurancePlanIdentifier = {
  type: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type InsurancePlanIdentifierInput = {
  type: Scalars['String']['input']
  value: Scalars['String']['input']
}

export enum InsurancePlanLineOfBusiness {
  Autoinsurance = 'AUTOINSURANCE',
  Commercial = 'COMMERCIAL',
  Medicaid = 'MEDICAID',
  Medicare = 'MEDICARE',
  Veteransaffairs = 'VETERANSAFFAIRS',
  Workerscomp = 'WORKERSCOMP',
}

export type InsurancePlanPartial = {
  _id: Scalars['ID']['output']
  credentialingPayerId?: Maybe<Scalars['String']['output']>
  credentialingPayerName?: Maybe<Scalars['String']['output']>
  isDelegated?: Maybe<Scalars['Boolean']['output']>
  isInheritanceDisabled?: Maybe<Scalars['Boolean']['output']>
  name: Scalars['String']['output']
  payerCode?: Maybe<Scalars['String']['output']>
  stateCode?: Maybe<Scalars['String']['output']>
  stateName?: Maybe<Scalars['String']['output']>
  status?: Maybe<InsurancePlanStatus>
}

export type InsurancePlanParticipant = {
  _id: Scalars['ID']['output']
  billingRelationship: InsurancePlanBillingRelationship
  comments?: Maybe<Array<AttachmentAnnotation>>
  effectiveDate?: Maybe<Scalars['AWSDate']['output']>
  insurancePlan: InsurancePlanPartial
  status?: Maybe<InsurancePlanParticipantStatus>
  terminationDate?: Maybe<Scalars['AWSDate']['output']>
}

export type InsurancePlanParticipantInput = {
  _id?: InputMaybe<Scalars['ID']['input']>
  billingRelationship: InsurancePlanBillingRelationshipInput
  comment?: InputMaybe<AttachmentAnnotationInput>
  effectiveDate?: InputMaybe<Scalars['AWSDate']['input']>
  identifier?: InputMaybe<Scalars['String']['input']>
  insurancePlanId: Scalars['ID']['input']
  status?: InputMaybe<InsurancePlanParticipantStatus>
  terminationDate?: InputMaybe<Scalars['AWSDate']['input']>
}

export enum InsurancePlanParticipantStatus {
  Active = 'ACTIVE',
  ExistingPatientOnly = 'EXISTING_PATIENT_ONLY',
  Inactive = 'INACTIVE',
}

export enum InsurancePlanStatus {
  Active = 'ACTIVE',
  Contractinprogress = 'CONTRACTINPROGRESS',
  Groupinprogress = 'GROUPINPROGRESS',
  Inactive = 'INACTIVE',
  Onhold = 'ONHOLD',
}

export type InsurancePlanUpdateInput = {
  billingPayerName?: InputMaybe<Scalars['String']['input']>
  comment?: InputMaybe<Scalars['String']['input']>
  credentialingPayerId?: InputMaybe<Scalars['String']['input']>
  credentialingPayerName?: InputMaybe<Scalars['String']['input']>
  delegatedAuditDate?: InputMaybe<Scalars['AWSDate']['input']>
  delegatedEffectiveDate?: InputMaybe<Scalars['AWSDate']['input']>
  effectiveDate?: InputMaybe<Scalars['AWSDate']['input']>
  expirationDate?: InputMaybe<Scalars['AWSDate']['input']>
  groupId?: InputMaybe<Scalars['String']['input']>
  identifiers?: InputMaybe<Array<InsurancePlanIdentifierInput>>
  inNetworkBenefitTerms?: InputMaybe<Scalars['String']['input']>
  isDelegated?: InputMaybe<Scalars['Boolean']['input']>
  isInNetwork?: InputMaybe<Scalars['Boolean']['input']>
  isInheritanceDisabled?: InputMaybe<Scalars['Boolean']['input']>
  lineOfBusiness?: InputMaybe<InsurancePlanLineOfBusiness>
  name?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  outOfNetworkBenefitTerms?: InputMaybe<Scalars['String']['input']>
  payerCode?: InputMaybe<Scalars['String']['input']>
  payerId?: InputMaybe<Scalars['String']['input']>
  payerName?: InputMaybe<Scalars['String']['input']>
  planType?: InputMaybe<Scalars['String']['input']>
  recredentialingDate?: InputMaybe<Scalars['AWSDate']['input']>
  stateCode?: InputMaybe<Scalars['String']['input']>
  stateName?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<InsurancePlanStatus>
  tocConfiguration?: InputMaybe<Array<TocConfigurationInput>>
  vendorName?: InputMaybe<Scalars['String']['input']>
  verificationDefaultLocation?: InputMaybe<Scalars['String']['input']>
  verificationDefaultProviderName?: InputMaybe<Scalars['String']['input']>
  verificationDefaultProviderNpi?: InputMaybe<Scalars['String']['input']>
  verificationPayerId?: InputMaybe<Scalars['String']['input']>
  verificationPayerName?: InputMaybe<Scalars['String']['input']>
}

export type InternationalAddress = {
  city?: Maybe<Scalars['String']['output']>
  countryCode?: Maybe<Scalars['String']['output']>
  line?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  postalCode?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
}

export type InternationalAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>
  countryCode?: InputMaybe<Scalars['String']['input']>
  line?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
}

export type Language = {
  code?: Maybe<Scalars['String']['output']>
  display: Scalars['String']['output']
}

export type LayoutTab = {
  hidden: Scalars['Boolean']['output']
  id: Scalars['String']['output']
}

export enum LegalSex {
  Female = 'FEMALE',
  Male = 'MALE',
}

export enum LicenseDurationType {
  AutonomousRegistration = 'AUTONOMOUS_REGISTRATION',
  Limited = 'LIMITED',
  Multistate = 'MULTISTATE',
  Permanent = 'PERMANENT',
  PrescriptionAuthority = 'PRESCRIPTION_AUTHORITY',
  Telemedicine = 'TELEMEDICINE',
  Temporary = 'TEMPORARY',
  Training = 'TRAINING',
}

export enum LicenseRequestStatus {
  Completed = 'COMPLETED',
  NotSubmitted = 'NOT_SUBMITTED',
  Pending = 'PENDING',
  PendingProvider = 'PENDING_PROVIDER',
  PsvInProgress = 'PSV_IN_PROGRESS',
  PsvSubmitted = 'PSV_SUBMITTED',
}

export enum LicenseRequestType {
  Loq = 'LOQ',
  New = 'NEW',
  Reinstatement = 'REINSTATEMENT',
  Renewal = 'RENEWAL',
}

export enum LicenseType {
  Counselor = 'COUNSELOR',
  Csr = 'CSR',
  Dea = 'DEA',
  Do = 'DO',
  Lcadc = 'LCADC',
  Lcmhc = 'LCMHC',
  Lcmhcs = 'LCMHCS',
  Lcpc = 'LCPC',
  Lcsw = 'LCSW',
  Lcswa = 'LCSWA',
  Licsw = 'LICSW',
  Lisw = 'LISW',
  Lmft = 'LMFT',
  Lmhc = 'LMHC',
  Lmhca = 'LMHCA',
  LmhcD = 'LMHC-D',
  Lmsw = 'LMSW',
  Lpc = 'LPC',
  Lpn = 'LPN',
  Lsw = 'LSW',
  Md = 'MD',
  MhcLp = 'MHC-LP',
  MsMt = 'MS-MT',
  Np = 'NP',
  Pmhnp = 'PMHNP',
  Psyd = 'PSYD',
  PhD = 'PhD',
  Rn = 'RN',
}

export enum LineOfBusiness {
  Commercial = 'COMMERCIAL',
  Medicaid = 'MEDICAID',
  Medicare = 'MEDICARE',
}

export type ListEligibilityVerificationInput = {
  billingInsuranceId?: InputMaybe<Scalars['ID']['input']>
  billingInsuranceType?: InputMaybe<Scalars['String']['input']>
  from?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  treatmentId: Scalars['ID']['input']
}

export type ListEligibilityVerificationsInput = {
  billingInsuranceId?: InputMaybe<Scalars['ID']['input']>
  billingInsuranceType?: InputMaybe<Scalars['String']['input']>
  from?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  treatmentId: Scalars['ID']['input']
}

export type ListPatientEligibilityVerificationInput = {
  billingInsuranceId?: InputMaybe<Scalars['ID']['input']>
  billingInsuranceType?: InputMaybe<Scalars['String']['input']>
  from?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}

export type ListResponse = {
  key: Scalars['String']['output']
  list?: Maybe<Array<IListItem>>
}

export type LoadEligibilityVerificationInput = {
  billingInsuranceId: Scalars['String']['input']
  treatmentId: Scalars['String']['input']
}

export type LoadPatientBillingInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  treatmentId?: InputMaybe<Scalars['ID']['input']>
}

export type Location = {
  address: Address
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  identifiers?: Maybe<Array<Identifier>>
  name: Scalars['String']['output']
  physicalType: CodeableConcept
}

export type LocationSummary = {
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  stateCode?: Maybe<Scalars['String']['output']>
}

export type MatchedTokenResponse = {
  access_token: Scalars['String']['output']
  expires_in: Scalars['Int']['output']
  id_token: Scalars['String']['output']
  token_type: TokenType
}

export type MedicalDiagnosis = {
  code?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type MonthlyTemplate = PatternTemplate & {
  dayOfWeek: DayOfWeek
  endTime: Scalars['AWSTime']['output']
  interval: Scalars['Int']['output']
  nthWeekOfMonth: WeekOfMonth
  offset: Scalars['Int']['output']
  startTime: Scalars['AWSTime']['output']
}

export type MonthlyTemplateInput = {
  dayOfWeek: DayOfWeek
  endTime: Scalars['AWSTime']['input']
  interval: Scalars['Int']['input']
  nthWeekOfMonth: WeekOfMonth
  offset: Scalars['Int']['input']
  startTime: Scalars['AWSTime']['input']
}

export type Mutation = {
  addProviderLicenseRequests: Array<ProviderLicenseRequest>
  appendDocuments: Array<Document>
  appendInsurancePlanParticipants: Array<InsurancePlanParticipant>
  appendListItems: Array<IListItem>
  appendProviderDocuments: Array<ProviderDocument>
  appendProviderLicenses: Array<ProviderLicense>
  appendVerifiedProviderDocuments: Array<ProviderDocument>
  bulkUpdateInsurancePlans: Array<InsurancePlanFull>
  completeFormSubmission: SubmissionResponse
  completePatientRegistrationSubmission: SubmissionResponse
  confirmOTPAndMatch?: Maybe<MatchedTokenResponse>
  createAppointment: Appointment
  createAppointmentExternal: CreateAppointmentResponse
  createAppointmentV2: CreateAppointmentResponse
  createConsentPacketExternal: CreateConsentPacketResponse
  createFormSubmission: SubmissionResponse
  createInsurancePlan: InsurancePlanFull
  createPatient?: Maybe<PatientResponse>
  createPatientRegistrationSubmission: SubmissionResponse
  createPayerEnrollments: Array<PayerEnrollment>
  createPayers: Array<Payer>
  createProfessionalHistory: Array<ProfessionalHistory>
  createProvider: Provider
  createSchedule: Schedule
  createTask: Task
  decrypt: DecryptResponse
  deleteAppointment: Appointment
  deleteIdentifiers: Array<ProviderIdentifier>
  deleteInsurancePlan: InsurancePlanFull
  deleteListItems: Array<IListItem>
  deletePayerEnrollments: Array<PayerEnrollment>
  deletePayers: Array<Payer>
  deleteProfessionalHistory: Array<ProfessionalHistory>
  deleteProvider: Provider
  deleteProviderExternalAccounts: Array<ProviderExternalAccount>
  deleteSchedule: Schedule
  deleteTask: Task
  encrypt: EncryptResponse
  generatePatientLink: PatientLink
  patchSetting: ConfigItem
  pullSync?: Maybe<PullResponse>
  pushSync?: Maybe<PushResponse>
  removeDocuments: Array<Document>
  removeInsurancePlanParticipants: Array<InsurancePlanParticipant>
  removeProviderDocuments: Array<ProviderDocument>
  removeProviderLicenseRequests: Array<ProviderLicenseRequest>
  removeProviderLicenses: Array<ProviderLicense>
  removeUser: User
  removeVerifiedProviderDocuments: Array<ProviderDocument>
  resendUserPassword: ResendUserPasswordRes
  restorePatient?: Maybe<PatientResponse>
  restoreUser: ProvisionedUser
  resyncProviderAvailability: ResyncResponse
  revokeUser: User
  savePatientBilling?: Maybe<PatientBilling>
  savePatientBillingExternal: SavePatientBillingExternalOutput
  sendConsentPacket: SendConsentPacketResponse
  sendEligibilityVerification: ActionEntry
  sendOTP?: Maybe<ExternalResponse>
  signUpGoogleUser: ProvisionedUser
  signUpUser: ProvisionedUser
  syncInsuranceToEmr: EmrSyncStatisticsResponse
  syncToEmr: EmrSyncStatisticsResponse
  updateAppointment: Appointment
  updateAppointmentExternal: Appointment
  updateDocuments: Array<Document>
  updateEmployment: Employment
  updateFormSubmission: SubmissionResponse
  updateInsurancePlan: InsurancePlanFull
  updateInsurancePlanParticipant: InsurancePlanParticipant
  updateListItems: Array<IListItem>
  updatePatient?: Maybe<PatientResponse>
  updatePatientBillingInsured: PatientBilling
  updatePatientIntegration: PatientIntegration
  updatePatientRegistrationSubmission: SubmissionResponse
  updatePayerEnrollments: Array<PayerEnrollment>
  updatePayers: Array<Payer>
  updateProfessionalHistory: Array<ProfessionalHistory>
  updateProvider: Provider
  updateProviderCredentialing: ProviderCredentialing
  updateProviderDocuments: Array<ProviderDocument>
  updateProviderLicenseRequests: Array<ProviderLicenseRequest>
  updateProviderLicenses: Array<ProviderLicense>
  updateReoccuranceTemplate: UpdateReoccuranceTemplateResponse
  updateSchedule: Schedule
  updateTaskV2: Task
  updateTasks: Array<Task>
  updateUser: ProvisionedUser
  updateVerifiedProviderDocuments: Array<ProviderDocument>
  upsertIdentifiers: Array<ProviderIdentifier>
  upsertInsurancePlanParticipants: Array<InsurancePlanParticipant>
  upsertProviderExternalAccounts: Array<ProviderExternalAccount>
  validateCaptchaAndMatch?: Maybe<MatchedTokenResponse>
  verifyEligibility?: Maybe<EligibilityVerificationV2>
  verifyEligibilityExternal?: Maybe<
    Array<Maybe<EligibilityVerificationExternal>>
  >
  verifyEligibilityFromEmr?: Maybe<Array<Maybe<EligibilityVerificationV2>>>
}

export type MutationAddProviderLicenseRequestsArgs = {
  content: Array<ProviderLicenseRequestCreateInput>
  providerId: Scalars['ID']['input']
}

export type MutationAppendDocumentsArgs = {
  content: Array<CreateDocumentInput>
  treatmentId: Scalars['ID']['input']
}

export type MutationAppendInsurancePlanParticipantsArgs = {
  content?: InputMaybe<Array<InsurancePlanParticipantInput>>
  providerId: Scalars['ID']['input']
}

export type MutationAppendListItemsArgs = {
  input: Array<AppendListItemInput>
  key: Scalars['String']['input']
}

export type MutationAppendProviderDocumentsArgs = {
  content: Array<CreateProviderDocumentInput>
  providerId: Scalars['ID']['input']
}

export type MutationAppendProviderLicensesArgs = {
  content: Array<ProviderLicenseCreateInput>
  providerId: Scalars['ID']['input']
}

export type MutationAppendVerifiedProviderDocumentsArgs = {
  content: Array<CreateProviderDocumentInput>
  providerId: Scalars['ID']['input']
}

export type MutationBulkUpdateInsurancePlansArgs = {
  content: Array<BulkInsurancePlanUpdateInput>
}

export type MutationCompleteFormSubmissionArgs = {
  input: CompleteFormSubmissionInput
}

export type MutationCompletePatientRegistrationSubmissionArgs = {
  input: CompletePatientRegistrationSubmission
}

export type MutationConfirmOtpAndMatchArgs = {
  input: ConfirmOtpAndMatchInput
}

export type MutationCreateAppointmentArgs = {
  content: AppointmentInput
  options?: InputMaybe<AppointmentOptions>
}

export type MutationCreateAppointmentExternalArgs = {
  content: CreateAppointmentExternalInput
}

export type MutationCreateAppointmentV2Args = {
  content: AppointmentInput
  options?: InputMaybe<AppointmentOptions>
}

export type MutationCreateConsentPacketExternalArgs = {
  content: CreateConsentPacketExternalInput
}

export type MutationCreateFormSubmissionArgs = {
  input: CreateFormSubmissionInput
}

export type MutationCreateInsurancePlanArgs = {
  content: InsurancePlanCreateInput
}

export type MutationCreatePatientArgs = {
  input: CreatePatientInput
}

export type MutationCreatePatientRegistrationSubmissionArgs = {
  input: CreatePatientRegistrationSubmission
}

export type MutationCreatePayerEnrollmentsArgs = {
  content: Array<CreatePayerEnrollmentInput>
  providerId: Scalars['ID']['input']
}

export type MutationCreatePayersArgs = {
  content: Array<PayerCreateInput>
}

export type MutationCreateProfessionalHistoryArgs = {
  content: Array<ProfessionalHistoryCreateInput>
  providerId: Scalars['ID']['input']
}

export type MutationCreateProviderArgs = {
  content: ProviderInputCreate
}

export type MutationCreateScheduleArgs = {
  content: ScheduleInput
}

export type MutationCreateTaskArgs = {
  content: CreateTaskInput
}

export type MutationDecryptArgs = {
  input: DecryptInput
}

export type MutationDeleteAppointmentArgs = {
  _id: Scalars['ID']['input']
}

export type MutationDeleteIdentifiersArgs = {
  identifierIds: Array<Scalars['ID']['input']>
  providerId: Scalars['ID']['input']
}

export type MutationDeleteInsurancePlanArgs = {
  _id: Scalars['ID']['input']
}

export type MutationDeleteListItemsArgs = {
  input: Array<Scalars['ID']['input']>
  key: Scalars['String']['input']
}

export type MutationDeletePayerEnrollmentsArgs = {
  enrollmentIds: Array<Scalars['ID']['input']>
  providerId: Scalars['ID']['input']
}

export type MutationDeletePayersArgs = {
  content: Array<Scalars['ID']['input']>
}

export type MutationDeleteProfessionalHistoryArgs = {
  ids: Array<Scalars['ID']['input']>
  providerId: Scalars['ID']['input']
}

export type MutationDeleteProviderArgs = {
  _id: Scalars['ID']['input']
}

export type MutationDeleteProviderExternalAccountsArgs = {
  providerExternalAccountIds: Array<Scalars['ID']['input']>
  providerId: Scalars['ID']['input']
}

export type MutationDeleteScheduleArgs = {
  _id: Scalars['ID']['input']
}

export type MutationDeleteTaskArgs = {
  _id: Scalars['ID']['input']
}

export type MutationEncryptArgs = {
  input: EncryptInput
}

export type MutationGeneratePatientLinkArgs = {
  input: GeneratePatientLinkInput
}

export type MutationPatchSettingArgs = {
  key: Scalars['String']['input']
  value: Scalars['AWSJSON']['input']
}

export type MutationPullSyncArgs = {
  endDate: Scalars['AWSDateTime']['input']
  providerId: Scalars['String']['input']
  startDate: Scalars['AWSDateTime']['input']
}

export type MutationPushSyncArgs = {
  appointmentIds: Array<Scalars['String']['input']>
}

export type MutationRemoveDocumentsArgs = {
  documentIds: Array<Scalars['ID']['input']>
  treatmentId: Scalars['ID']['input']
}

export type MutationRemoveInsurancePlanParticipantsArgs = {
  content?: InputMaybe<Array<InsurancePlanParticipantInput>>
  providerId: Scalars['ID']['input']
}

export type MutationRemoveProviderDocumentsArgs = {
  documentIds: Array<Scalars['ID']['input']>
  providerId: Scalars['ID']['input']
}

export type MutationRemoveProviderLicenseRequestsArgs = {
  licenseIds: Array<Scalars['ID']['input']>
  providerId: Scalars['ID']['input']
}

export type MutationRemoveProviderLicensesArgs = {
  licenseIds: Array<Scalars['ID']['input']>
  providerId: Scalars['ID']['input']
}

export type MutationRemoveUserArgs = {
  _id: Scalars['String']['input']
}

export type MutationRemoveVerifiedProviderDocumentsArgs = {
  documentIds: Array<Scalars['ID']['input']>
  providerId: Scalars['ID']['input']
}

export type MutationResendUserPasswordArgs = {
  cognitoUserId: Scalars['ID']['input']
}

export type MutationRestorePatientArgs = {
  input: RestorePatientInput
}

export type MutationRestoreUserArgs = {
  _id: Scalars['String']['input']
}

export type MutationResyncProviderAvailabilityArgs = {
  requests: Array<ResyncProviderAvailabilityRequest>
}

export type MutationRevokeUserArgs = {
  _id: Scalars['String']['input']
}

export type MutationSavePatientBillingArgs = {
  forceSync?: InputMaybe<Scalars['Boolean']['input']>
  input: UpdatePatientBillingInput
}

export type MutationSavePatientBillingExternalArgs = {
  input: SavePatientBillingExternalInput
}

export type MutationSendConsentPacketArgs = {
  content: SendConsentPacketInput
}

export type MutationSendEligibilityVerificationArgs = {
  input: SendEligibilityVerificationInput
}

export type MutationSendOtpArgs = {
  input: SendOtpInput
}

export type MutationSignUpGoogleUserArgs = {
  content: GoogleSignUpInput
}

export type MutationSignUpUserArgs = {
  content: UserSignUpInput
}

export type MutationSyncInsuranceToEmrArgs = {
  input: SyncInsuranceToEmrInput
}

export type MutationSyncToEmrArgs = {
  input: SyncToEmrInput
}

export type MutationUpdateAppointmentArgs = {
  _id: Scalars['ID']['input']
  content: UpdateAppointmentInput
  options?: InputMaybe<AppointmentOptions>
}

export type MutationUpdateAppointmentExternalArgs = {
  _id: Scalars['ID']['input']
  content: UpdateAppointmentExternalInput
}

export type MutationUpdateDocumentsArgs = {
  content: Array<UpdateDocumentInput>
  treatmentId: Scalars['ID']['input']
}

export type MutationUpdateEmploymentArgs = {
  _id?: InputMaybe<Scalars['ID']['input']>
  content: EmploymentInput
  providerId?: InputMaybe<Scalars['ID']['input']>
}

export type MutationUpdateFormSubmissionArgs = {
  input: UpdateFormSubmissionInput
}

export type MutationUpdateInsurancePlanArgs = {
  _id: Scalars['ID']['input']
  content: InsurancePlanUpdateInput
}

export type MutationUpdateInsurancePlanParticipantArgs = {
  content: InsurancePlanParticipantInput
  providerId: Scalars['ID']['input']
}

export type MutationUpdateListItemsArgs = {
  input: Array<UpdateListItemInput>
  key: Scalars['String']['input']
}

export type MutationUpdatePatientArgs = {
  input: UpdatePatientInput
}

export type MutationUpdatePatientBillingInsuredArgs = {
  input: UpdatePatientBillingInsuredInput
}

export type MutationUpdatePatientIntegrationArgs = {
  content: PatientIntegrationInput
  treatmentId: Scalars['ID']['input']
}

export type MutationUpdatePatientRegistrationSubmissionArgs = {
  input: UpdatePatientRegistrationSubmission
}

export type MutationUpdatePayerEnrollmentsArgs = {
  content: Array<UpdatePayerEnrollmentInput>
  providerId: Scalars['ID']['input']
}

export type MutationUpdatePayersArgs = {
  content: Array<PayerUpdateInput>
}

export type MutationUpdateProfessionalHistoryArgs = {
  content: Array<ProfessionalHistoryUpdateInput>
  providerId: Scalars['ID']['input']
}

export type MutationUpdateProviderArgs = {
  _id: Scalars['ID']['input']
  content: ProviderInputUpdate
}

export type MutationUpdateProviderCredentialingArgs = {
  content: ProviderCredentialingInput
  providerId: Scalars['ID']['input']
}

export type MutationUpdateProviderDocumentsArgs = {
  content: Array<UpdateProviderDocumentInput>
  providerId: Scalars['ID']['input']
}

export type MutationUpdateProviderLicenseRequestsArgs = {
  content: Array<ProviderLicenseRequestUpdateInput>
  providerId: Scalars['ID']['input']
}

export type MutationUpdateProviderLicensesArgs = {
  content: Array<ProviderLicenseUpdateInput>
  providerId: Scalars['ID']['input']
}

export type MutationUpdateReoccuranceTemplateArgs = {
  content: ReoccuranceTemplateInput
  id: Scalars['ID']['input']
}

export type MutationUpdateScheduleArgs = {
  _id: Scalars['ID']['input']
  content: ScheduleInput
}

export type MutationUpdateTaskV2Args = {
  content: UpdateTaskInputV2
}

export type MutationUpdateTasksArgs = {
  content: Array<UpdateTaskInputV2>
}

export type MutationUpdateUserArgs = {
  cognitoUserId: Scalars['ID']['input']
  content: UserUpdateInput
}

export type MutationUpdateVerifiedProviderDocumentsArgs = {
  content: Array<UpdateProviderDocumentInput>
  providerId: Scalars['ID']['input']
}

export type MutationUpsertIdentifiersArgs = {
  content: Array<ProviderIdentifierInput>
  providerId: Scalars['ID']['input']
}

export type MutationUpsertInsurancePlanParticipantsArgs = {
  content: Array<UpsertInsurancePlanParticipantInput>
}

export type MutationUpsertProviderExternalAccountsArgs = {
  content: Array<ProviderExternalAccountInput>
  providerId: Scalars['ID']['input']
}

export type MutationValidateCaptchaAndMatchArgs = {
  input: ValidateCaptchaAndMatchInput
}

export type MutationVerifyEligibilityArgs = {
  input: VerifyEligibilityInputV2
}

export type MutationVerifyEligibilityExternalArgs = {
  input: Array<VerifyEligibilityExternalInput>
}

export type MutationVerifyEligibilityFromEmrArgs = {
  input: VerifyEligibilityFromEmrInput
}

export type NextgenInfo = {
  appointmentId?: Maybe<Scalars['String']['output']>
  personId?: Maybe<Scalars['String']['output']>
  providerId?: Maybe<Scalars['String']['output']>
  resourceId?: Maybe<Scalars['String']['output']>
}

export type Node = {
  _id: Scalars['ID']['output']
}

export enum NoticeCode {
  EligibilityError = 'ELIGIBILITY_ERROR',
  EligibilityInactiveCoverage = 'ELIGIBILITY_INACTIVE_COVERAGE',
  EligibilityNotVerified = 'ELIGIBILITY_NOT_VERIFIED',
  EligibilityUnableToVerify = 'ELIGIBILITY_UNABLE_TO_VERIFY',
  EmrsyncError = 'EMRSYNC__ERROR',
  EmrsyncImportantUnsynced = 'EMRSYNC__IMPORTANT_UNSYNCED',
  EmrsyncInProgress = 'EMRSYNC__IN_PROGRESS',
  EmrsyncPartialUnsynced = 'EMRSYNC__PARTIAL_UNSYNCED',
  EmrsyncSynced = 'EMRSYNC__SYNCED',
  EmrsyncUnknown = 'EMRSYNC__UNKNOWN',
  MissingConsent = 'MISSING_CONSENT',
  MissingCreditCard = 'MISSING_CREDIT_CARD',
  PriorAuthRequired = 'PRIOR_AUTH_REQUIRED',
}

export enum NoticeLevel {
  Error = 'error',
  ErrorDark = 'error_dark',
  ErrorLight = 'error_light',
  Info = 'info',
  InfoDark = 'info_dark',
  InfoLight = 'info_light',
  Primary = 'primary',
  PrimaryDark = 'primary_dark',
  PrimaryLight = 'primary_light',
  Secondary = 'secondary',
  SecondaryDark = 'secondary_dark',
  SecondaryLight = 'secondary_light',
  Success = 'success',
  SuccessDark = 'success_dark',
  SuccessLight = 'success_light',
  Warning = 'warning',
  WarningDark = 'warning_dark',
  WarningLight = 'warning_light',
}

export enum OtpMethod {
  Call = 'CALL',
  Sms = 'SMS',
}

export type OpenSearchRes = {
  aggregations?: Maybe<Scalars['AWSJSON']['output']>
  from?: Maybe<Scalars['Int']['output']>
  resultCount: Scalars['Int']['output']
  searchAfter?: Maybe<Scalars['AWSJSON']['output']>
}

export enum Operator {
  Eq = 'eq',
  Gt = 'gt',
  Gte = 'gte',
  Lt = 'lt',
  Lte = 'lte',
  Neq = 'neq',
}

export type OutOfNetworkPlanInput = {
  name: Scalars['String']['input']
  state: StateInput
}

export type OverlappingInsurancePlan = {
  description?: Maybe<Scalars['String']['output']>
  favoredPlanId?: Maybe<Scalars['ID']['output']>
  id: Scalars['ID']['output']
  planIds: Array<Scalars['ID']['output']>
}

export type Participant = {
  actor: Reference
  required: Scalars['Boolean']['output']
  status?: Maybe<ParticipationStatus>
  type?: Maybe<AppointmentParticipantType>
}

export type ParticipantInput = {
  actor: ReferenceInput
  required: Scalars['Boolean']['input']
  status?: InputMaybe<ParticipationStatus>
  type?: InputMaybe<AppointmentParticipantTypeCode>
}

export enum ParticipationStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  NeedsAction = 'NEEDS_ACTION',
  Tentative = 'TENTATIVE',
}

export type Patient = {
  care?: Maybe<PatientCare>
  demographics?: Maybe<PatientDemographics>
  integration?: Maybe<PatientIntegration>
}

export type PatientAddress = {
  city?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
  zipcode?: Maybe<Scalars['String']['output']>
}

export type PatientBilling = {
  comments?: Maybe<Array<Annotation>>
  consentPacketInfo?: Maybe<ConsentPacketInfo>
  creditCardOnFile?: Maybe<Scalars['Boolean']['output']>
  emrSyncStatistics?: Maybe<EmrSyncStatistics>
  fullConsentPackedSigned?: Maybe<Scalars['Boolean']['output']>
  hasBillableAppointment?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['String']['output']
  idFile?: Maybe<File>
  idRelationship?: Maybe<PatientRelationshipToIdCard>
  idType?: Maybe<IdentificationType>
  idValue?: Maybe<Scalars['String']['output']>
  insurances?: Maybe<Array<BillingInsured>>
  patientId: Scalars['String']['output']
  selfPay?: Maybe<Scalars['Boolean']['output']>
  treatmentId: Scalars['String']['output']
}

export type PatientBillingInsurance = {
  addressComponents?: Maybe<AddressComponents>
  coPay?: Maybe<Scalars['String']['output']>
  dateOfBirth?: Maybe<Scalars['AWSDate']['output']>
  effectiveDate?: Maybe<Scalars['AWSDate']['output']>
  eligibilityReason?: Maybe<Scalars['String']['output']>
  eligibilityVerified?: Maybe<Scalars['Boolean']['output']>
  emrSyncStatus?: Maybe<EmrSyncStatusCode>
  expirationDate?: Maybe<Scalars['AWSDate']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  idNumber?: Maybe<Scalars['String']['output']>
  insurancePlanId?: Maybe<Scalars['ID']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  legalSex?: Maybe<PatientLegalSex>
  medicaidIdNumber?: Maybe<Scalars['String']['output']>
  medicareIdNumber?: Maybe<Scalars['String']['output']>
  middleInitial?: Maybe<Scalars['String']['output']>
  note?: Maybe<Scalars['String']['output']>
  otherPayerInfo?: Maybe<Scalars['String']['output']>
  outOfNetwork?: Maybe<Scalars['Boolean']['output']>
  outOfNetworkPlan?: Maybe<OutOfNetworkPlan>
  phone?: Maybe<Scalars['String']['output']>
  policyGroupFecaNumber?: Maybe<Scalars['String']['output']>
  policyGroupName?: Maybe<Scalars['String']['output']>
  priorAuthRequired?: Maybe<PriorAuthStatus>
  referralRequired?: Maybe<Scalars['Boolean']['output']>
  relationship?: Maybe<PatientRelationshipToInsured>
  type: InsuranceOrdinality
}

export type PatientCare = {
  careTeam?: Maybe<Array<Maybe<CareTeamMember>>>
  device?: Maybe<Device>
  diagnosis?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  disableChat?: Maybe<Scalars['Boolean']['output']>
  hospitalized?: Maybe<Scalars['Boolean']['output']>
  medicalDiagnosis?: Maybe<Array<Maybe<MedicalDiagnosis>>>
  questionnaires?: Maybe<Array<Maybe<Questionnaire>>>
  referralSource?: Maybe<Scalars['String']['output']>
  scaleId?: Maybe<Scalars['String']['output']>
}

export enum PatientContactRelation {
  AdditionalPatientContact = 'Additional Patient Contact',
  MinorPatient = 'Minor Patient',
  Other = 'Other',
  ParentGuardian = 'Parent/Guardian',
  SupportiveContact = 'Supportive Contact',
}

export enum PatientContactUse {
  Emergency = 'emergency',
  Personal = 'personal',
  Work = 'work',
}

export type PatientDemographics = {
  addressComponents?: Maybe<AddressComponents>
  contacts?: Maybe<Array<Contact>>
  dateOfBirth?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  gender?: Maybe<PatientLegalSex>
  genderDetails?: Maybe<Scalars['String']['output']>
  genderIdentity?: Maybe<PatientGenderIdentity>
  languages?: Maybe<Array<Scalars['String']['output']>>
  lastName?: Maybe<Scalars['String']['output']>
  middleName?: Maybe<Scalars['String']['output']>
  mrn?: Maybe<Scalars['String']['output']>
  patientId?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  picture?: Maybe<Scalars['String']['output']>
  preferredLanguage?: Maybe<Scalars['String']['output']>
  preferredName?: Maybe<Scalars['String']['output']>
  primaryEmail?: Maybe<Scalars['String']['output']>
  primaryPhone?: Maybe<Scalars['String']['output']>
  pronouns?: Maybe<Scalars['String']['output']>
  registrationSource?: Maybe<Scalars['String']['output']>
  status?: Maybe<PatientStatus>
  timezone?: Maybe<Scalars['String']['output']>
  username?: Maybe<Scalars['String']['output']>
  videoLink?: Maybe<Scalars['String']['output']>
}

export enum PatientGenderIdentity {
  Female = 'female',
  Genderqueer = 'genderqueer',
  Male = 'male',
  NonBinary = 'nonBinary',
  NoneDisclose = 'noneDisclose',
  Other = 'other',
  TransgenderFemale = 'transgenderFemale',
  TransgenderMale = 'transgenderMale',
}

export type PatientIntegration = {
  emrId?: Maybe<Scalars['ID']['output']>
  isActive: Scalars['Boolean']['output']
  lumaId?: Maybe<Scalars['ID']['output']>
  medplumId?: Maybe<Scalars['ID']['output']>
  mmrId?: Maybe<Scalars['ID']['output']>
  nextgenId?: Maybe<Scalars['ID']['output']>
}

export type PatientIntegrationInput = {
  emrId?: InputMaybe<Scalars['ID']['input']>
  forceOverwrite?: InputMaybe<Scalars['Boolean']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  lumaId?: InputMaybe<Scalars['ID']['input']>
  nextgenId?: InputMaybe<Scalars['ID']['input']>
}

export enum PatientLegalSex {
  F = 'f',
  M = 'm',
  O = 'o',
}

export type PatientLink = {
  fullLink: Scalars['String']['output']
  shortLink: Scalars['String']['output']
}

export type PatientMetaData = {
  display?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  lumaId?: Maybe<Scalars['String']['output']>
  mrn?: Maybe<Scalars['String']['output']>
  nextgenId?: Maybe<Scalars['String']['output']>
}

export type PatientMetaDataInput = {
  display?: InputMaybe<Scalars['String']['input']>
  lumaId?: InputMaybe<Scalars['String']['input']>
  mrn?: InputMaybe<Scalars['String']['input']>
  nextgenId?: InputMaybe<Scalars['String']['input']>
}

export type PatientName = {
  firstName: Scalars['String']['output']
  fullName: Scalars['String']['output']
  lastName: Scalars['String']['output']
  middleName?: Maybe<Scalars['String']['output']>
  preferredName?: Maybe<Scalars['String']['output']>
}

export type PatientNotice = {
  at?: Maybe<Scalars['AWSDateTime']['output']>
  code: NoticeCode
  label: Scalars['String']['output']
  level: NoticeLevel
}

export enum PatientOnboardingTaskType {
  NewPatientReferral = 'NEW_PATIENT_REFERRAL',
  NewPatientSelf = 'NEW_PATIENT_SELF',
  NewPatientToc = 'NEW_PATIENT_TOC',
  NewPatientWaitlist = 'NEW_PATIENT_WAITLIST',
}

export enum PatientRelationshipToIdCard {
  ParentGuardian = 'parent_guardian',
  Self = 'self',
}

export enum PatientRelationshipToInsured {
  Other = 'other',
  ParentGuardian = 'parent_guardian',
  Self = 'self',
  Spouse = 'spouse',
}

export type PatientResponse = {
  patientId: Scalars['ID']['output']
  treatmentId: Scalars['ID']['output']
}

export type PatientSettings = {
  flags?: Maybe<PatientSettingsFlags>
  overlappingInsurancePlans?: Maybe<Array<OverlappingInsurancePlan>>
}

export type PatientSettingsExternal = {
  overlappingInsurancePlans?: Maybe<Array<OverlappingInsurancePlan>>
}

export type PatientSettingsFlags = {
  suppressDischargeNotifications?: Maybe<Scalars['Boolean']['output']>
}

export enum PatientStatus {
  Active = 'active',
  AwaitingInitial = 'awaitingInitial',
  ClosedDischarged = 'closedDischarged',
  Lead = 'lead',
  Pending = 'pending',
  Waitlist = 'waitlist',
}

export type PatientSummary = {
  display: PatientSummaryDisplayNames
  email?: Maybe<Scalars['String']['output']>
  emrId?: Maybe<Scalars['String']['output']>
  lumaId?: Maybe<Scalars['String']['output']>
  nextgenId?: Maybe<Scalars['String']['output']>
  patientId: Scalars['ID']['output']
  phoneNumber?: Maybe<Scalars['String']['output']>
  programId: Scalars['String']['output']
  status: PatientStatus
  timeZone?: Maybe<Scalars['String']['output']>
  treatmentId: Scalars['ID']['output']
  userId: Scalars['ID']['output']
}

export type PatientSummaryDisplayNames = {
  expandedName?: Maybe<Scalars['String']['output']>
  fullName?: Maybe<Scalars['String']['output']>
  legalName?: Maybe<Scalars['String']['output']>
}

export type PatternTemplate = {
  interval: Scalars['Int']['output']
  offset: Scalars['Int']['output']
}

export type Payer = {
  comments?: Maybe<Array<Annotation>>
  delegated?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  identifiers?: Maybe<Array<PayerIdentifier>>
  lineOfBusiness?: Maybe<LineOfBusiness>
  name: Scalars['String']['output']
  note?: Maybe<Scalars['String']['output']>
  stateCode: Scalars['String']['output']
  status: PayerStatus
  tags?: Maybe<Array<PayerTag>>
  taxEntityId?: Maybe<Scalars['String']['output']>
}

export type PayerCreateInput = {
  comment?: InputMaybe<Scalars['String']['input']>
  delegated?: InputMaybe<Scalars['Boolean']['input']>
  identifiers?: InputMaybe<Array<PayerIdentifierInput>>
  lineOfBusiness?: InputMaybe<LineOfBusiness>
  name: Scalars['String']['input']
  note?: InputMaybe<Scalars['String']['input']>
  stateCode: Scalars['String']['input']
  status?: InputMaybe<PayerStatus>
  tags?: InputMaybe<Array<PayerTagInput>>
  taxEntityId?: InputMaybe<Scalars['String']['input']>
}

export type PayerEnrollment = {
  comments?: Maybe<Array<AttachmentAnnotation>>
  created: AuditEntry
  effectiveDate?: Maybe<Scalars['AWSDate']['output']>
  entity?: Maybe<Scalars['String']['output']>
  expirationDate?: Maybe<Scalars['AWSDate']['output']>
  id: Scalars['ID']['output']
  payer: Payer
  payerExternalProviderId?: Maybe<Scalars['String']['output']>
  recredentialingDate?: Maybe<Scalars['AWSDate']['output']>
  status: PayerEnrollmentStatus
  submissionDate?: Maybe<Scalars['AWSDate']['output']>
  terminationDate?: Maybe<Scalars['AWSDate']['output']>
  updated?: Maybe<AuditEntry>
  vendor?: Maybe<Scalars['String']['output']>
}

export enum PayerEnrollmentStatus {
  AwaitingMedicaid = 'AWAITING_MEDICAID',
  AwaitingMedicare = 'AWAITING_MEDICARE',
  AwaitingPrerequisite = 'AWAITING_PREREQUISITE',
  EmailedRequest = 'EMAILED_REQUEST',
  MissingInfo = 'MISSING_INFO',
  Na = 'NA',
  NaNonResident = 'NA_NON_RESIDENT',
  NeedToApply = 'NEED_TO_APPLY',
  OnHold = 'ON_HOLD',
  ParAndLinkedToGroup = 'PAR_AND_LINKED_TO_GROUP',
  PendingReassignment = 'PENDING_REASSIGNMENT',
  SubmittedToPlan = 'SUBMITTED_TO_PLAN',
}

export type PayerIdentifier = {
  type: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type PayerIdentifierInput = {
  type?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Scalars['String']['input']>
}

export enum PayerStatus {
  Active = 'ACTIVE',
  ContractInProgress = 'CONTRACT_IN_PROGRESS',
  GroupInProgress = 'GROUP_IN_PROGRESS',
  Inactive = 'INACTIVE',
  OnHold = 'ON_HOLD',
}

export type PayerTag = {
  value: Scalars['String']['output']
}

export type PayerTagInput = {
  value: Scalars['String']['input']
}

export type PayerUpdateInput = {
  comment?: InputMaybe<Scalars['String']['input']>
  delegated?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['ID']['input']
  identifiers?: InputMaybe<Array<PayerIdentifierInput>>
  lineOfBusiness?: InputMaybe<LineOfBusiness>
  name: Scalars['String']['input']
  note?: InputMaybe<Scalars['String']['input']>
  stateCode?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<PayerStatus>
  tags?: InputMaybe<Array<PayerTagInput>>
  taxEntityId?: InputMaybe<Scalars['String']['input']>
}

export type Period = {
  endDate?: Maybe<Scalars['AWSDateTime']['output']>
  startDate?: Maybe<Scalars['AWSDateTime']['output']>
}

export type PeriodInput = {
  endDate?: InputMaybe<Scalars['AWSDateTime']['input']>
  startDate?: InputMaybe<Scalars['AWSDateTime']['input']>
}

export type PracticeService = {
  appointmentTypeCode?: Maybe<ServiceTypeCode>
  boundaries: Array<PracticeServiceBoundary>
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>
  description?: Maybe<DisplayMessage>
  displayName: DisplayMessage
  id: Scalars['ID']['output']
  modifiedDate?: Maybe<Scalars['AWSDateTime']['output']>
  name: Scalars['String']['output']
  outOfBounds: PracticeServiceBoundaryDisplay
  serviceTypeCode: TaskServiceType
  sort: Scalars['Int']['output']
}

export enum PracticeServiceAvailabilityStatus {
  Closed = 'CLOSED',
  Open = 'OPEN',
}

export type PracticeServiceBoundary = {
  appointmentTypeCode?: Maybe<ServiceTypeCode>
  availabilityStatus: PracticeServiceAvailabilityStatus
  clinicalAges?: Maybe<Array<Scalars['String']['output']>>
  disableScheduling?: Maybe<Scalars['Boolean']['output']>
  disableSchedulingDisplay?: Maybe<DisplayMessage>
  display?: Maybe<PracticeServiceBoundaryDisplay>
  formTypes?: Maybe<Array<Scalars['String']['output']>>
  insurancePlans?: Maybe<Array<Scalars['String']['output']>>
  states?: Maybe<Array<Scalars['String']['output']>>
  tier: Scalars['Int']['output']
}

export type PracticeServiceBoundaryDisplay = {
  displayMessage?: Maybe<DisplayMessage>
  isDisplayed: Scalars['Boolean']['output']
}

export type PracticeState = {
  availabilityStatus: PracticeStateAvailabilityStatus
  entityName: Scalars['String']['output']
  groupNpi: Scalars['String']['output']
  id: Scalars['ID']['output']
  qualifyingPayerLicenseTypes: Array<LicenseType>
  stateCode: Scalars['String']['output']
  taxId: Scalars['String']['output']
}

export enum PracticeStateAvailabilityStatus {
  All = 'ALL',
  ExistingPatientsOnly = 'EXISTING_PATIENTS_ONLY',
}

export type PracticeTaxEntity = {
  entityName: Scalars['String']['output']
  groupNpi: Scalars['String']['output']
  id: Scalars['ID']['output']
  taxId: Scalars['String']['output']
}

export enum PriorAuthStatus {
  NotRequired = 'NOT_REQUIRED',
  Required = 'REQUIRED',
  Satisfied = 'SATISFIED',
  Unknown = 'UNKNOWN',
}

export enum ProfessionCategory {
  Certification = 'CERTIFICATION',
  Education = 'EDUCATION',
  LicensureExam = 'LICENSURE_EXAM',
  Training = 'TRAINING',
  WorkExperience = 'WORK_EXPERIENCE',
}

export enum ProfessionCode {
  Do = 'DO',
  Lcmhc = 'LCMHC',
  Lcmhcs = 'LCMHCS',
  Lcsw = 'LCSW',
  Lcswa = 'LCSWA',
  Licsw = 'LICSW',
  Lmft = 'LMFT',
  Lmhc = 'LMHC',
  Lmhca = 'LMHCA',
  LmhcD = 'LMHC-D',
  Lmsw = 'LMSW',
  Lpc = 'LPC',
  Lsw = 'LSW',
  Lswaic = 'LSWAIC',
  Md = 'MD',
  MhcLp = 'MHC-LP',
  Np = 'NP',
  Other = 'OTHER',
  Phd = 'PHD',
  Pmhnp = 'PMHNP',
  Psyd = 'PSYD',
}

export type ProfessionalHistory = {
  address?: Maybe<InternationalAddress>
  category: ProfessionCategory
  certificationNumber?: Maybe<Scalars['String']['output']>
  completed?: Maybe<Scalars['Boolean']['output']>
  created: AuditEntry
  degree?: Maybe<Scalars['String']['output']>
  endDate?: Maybe<Scalars['AWSDate']['output']>
  examDate?: Maybe<Scalars['AWSDate']['output']>
  examType?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  institutionName?: Maybe<Scalars['String']['output']>
  modified?: Maybe<AuditEntry>
  notes?: Maybe<Scalars['String']['output']>
  numberOfAttempts?: Maybe<Scalars['Int']['output']>
  organizationName?: Maybe<Scalars['String']['output']>
  programType?: Maybe<Scalars['String']['output']>
  recertificationDate?: Maybe<Scalars['AWSDate']['output']>
  specialty?: Maybe<Scalars['String']['output']>
  startDate?: Maybe<Scalars['AWSDate']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type ProfessionalHistoryCreateInput = {
  address?: InputMaybe<InternationalAddressInput>
  category: ProfessionCategory
  certificationNumber?: InputMaybe<Scalars['String']['input']>
  completed?: InputMaybe<Scalars['Boolean']['input']>
  degree?: InputMaybe<Scalars['String']['input']>
  endDate?: InputMaybe<Scalars['AWSDate']['input']>
  examDate?: InputMaybe<Scalars['AWSDate']['input']>
  examType?: InputMaybe<Scalars['String']['input']>
  institutionName?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  numberOfAttempts?: InputMaybe<Scalars['Int']['input']>
  organizationName?: InputMaybe<Scalars['String']['input']>
  programType?: InputMaybe<Scalars['String']['input']>
  recertificationDate?: InputMaybe<Scalars['AWSDate']['input']>
  specialty?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['AWSDate']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ProfessionalHistoryUpdateInput = {
  address?: InputMaybe<InternationalAddressInput>
  certificationNumber?: InputMaybe<Scalars['String']['input']>
  completed?: InputMaybe<Scalars['Boolean']['input']>
  degree?: InputMaybe<Scalars['String']['input']>
  endDate?: InputMaybe<Scalars['AWSDate']['input']>
  examDate?: InputMaybe<Scalars['AWSDate']['input']>
  examType?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  institutionName?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  numberOfAttempts?: InputMaybe<Scalars['Int']['input']>
  organizationName?: InputMaybe<Scalars['String']['input']>
  programType?: InputMaybe<Scalars['String']['input']>
  recertificationDate?: InputMaybe<Scalars['AWSDate']['input']>
  specialty?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['AWSDate']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type ProgramFlags = {
  clinicalNotesActive?: Maybe<Scalars['Boolean']['output']>
  isWellness: Scalars['Boolean']['output']
  oooCoveringProviderActive?: Maybe<Scalars['Boolean']['output']>
}

export type ProgramLayout = {
  careManagerMainNav?: Maybe<Array<LayoutTab>>
  careManagerPatientNav?: Maybe<Array<LayoutTab>>
  hideStartSessionButton?: Maybe<Scalars['Boolean']['output']>
  practiceManagerMainNav?: Maybe<Array<LayoutTab>>
}

export type ProgramSettings = {
  appointmentSettings?: Maybe<AppointmentSettings>
  flags?: Maybe<ProgramFlags>
  layout?: Maybe<ProgramLayout>
  lists?: Maybe<ProgramSettingsLists>
  patientSettings?: Maybe<PatientSettings>
  providerSettings?: Maybe<ProviderSettings>
}

export type ProgramSettingsExternal = {
  patientSettings?: Maybe<PatientSettingsExternal>
}

export type ProgramSettingsLists = {
  contactTypes?: Maybe<Array<StandardListItem>>
  dischargeReasons?: Maybe<Array<StandardListItem>>
  goalReminderTemplates?: Maybe<Array<StandardListItem>>
  taxonomyCodes?: Maybe<Array<StandardListItem>>
}

export type Provider = {
  _id: Scalars['ID']['output']
  ages?: Maybe<Array<Scalars['String']['output']>>
  availability: Availability
  availabilityNotes?: Maybe<Scalars['String']['output']>
  bio?: Maybe<Scalars['String']['output']>
  careCoordinator?: Maybe<Reference>
  careManagerId?: Maybe<Scalars['ID']['output']>
  clinicalAges?: Maybe<Array<Scalars['String']['output']>>
  clinicalModalities?: Maybe<Array<Scalars['String']['output']>>
  clinicalSpecialties?: Maybe<Array<Scalars['String']['output']>>
  communityIdentity?: Maybe<Array<CommunityIdentity>>
  display?: Maybe<UserSummaryDisplayNames>
  email?: Maybe<Scalars['String']['output']>
  employment?: Maybe<Employment>
  ethnicity?: Maybe<Ethnicity>
  expectedHours?: Maybe<Array<ExpectedHours>>
  firstName?: Maybe<Scalars['String']['output']>
  genderIdentity?: Maybe<GenderIdentity>
  identifiers?: Maybe<Array<ProviderIdentifier>>
  insurancePlans?: Maybe<Array<InsurancePlanParticipant>>
  languages?: Maybe<Array<Scalars['String']['output']>>
  lastName?: Maybe<Scalars['String']['output']>
  licenseRequests?: Maybe<Array<ProviderLicenseRequest>>
  licenses?: Maybe<Array<ProviderLicense>>
  modalities?: Maybe<Array<Scalars['String']['output']>>
  nextgenTimezone?: Maybe<Scalars['String']['output']>
  race?: Maybe<Array<Race>>
  serviceTypes?: Maybe<Array<ProviderServiceType>>
  sort?: Maybe<Scalars['AWSJSON']['output']>
  specialties?: Maybe<Array<Scalars['String']['output']>>
  spirituality?: Maybe<Array<Scalars['String']['output']>>
  status: ProviderStatus
  supervisees?: Maybe<Array<Reference>>
  supervisor?: Maybe<Reference>
  tags?: Maybe<Array<ProviderTag>>
  teamLead?: Maybe<Reference>
}

export type ProviderChatSettings = {
  disablePatientChatToggleActive?: Maybe<Scalars['Boolean']['output']>
  highlightedWords?: Maybe<Array<Scalars['String']['output']>>
  patientChatDisabledByDefault?: Maybe<Scalars['Boolean']['output']>
  unreadChatActive?: Maybe<Scalars['Boolean']['output']>
  unreadEvents?: Maybe<Array<Scalars['String']['output']>>
}

export type ProviderCredentialing = {
  address?: Maybe<InternationalAddress>
  birthCountry?: Maybe<Scalars['String']['output']>
  currentCredentialingDate?: Maybe<Scalars['AWSDate']['output']>
  dateOfBirth?: Maybe<Scalars['AWSDate']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  initialCredentialingDate?: Maybe<Scalars['AWSDate']['output']>
  isUSCitizen?: Maybe<Scalars['Boolean']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  lastRecredentialingDate?: Maybe<Scalars['AWSDate']['output']>
  middleName?: Maybe<Scalars['String']['output']>
  personalEmail?: Maybe<Scalars['String']['output']>
  primaryPhone?: Maybe<Scalars['String']['output']>
  priorLastName?: Maybe<Scalars['String']['output']>
  recredentialingDate?: Maybe<Scalars['AWSDate']['output']>
  ssn?: Maybe<EncryptedValue>
  suffix?: Maybe<Scalars['String']['output']>
}

export type ProviderCredentialingInput = {
  birthCountry?: InputMaybe<Scalars['String']['input']>
  currentCredentialingDate?: InputMaybe<Scalars['AWSDate']['input']>
  initialCredentialingDate?: InputMaybe<Scalars['AWSDate']['input']>
  isUSCitizen?: InputMaybe<Scalars['Boolean']['input']>
  lastRecredentialingDate?: InputMaybe<Scalars['AWSDate']['input']>
  recredentialingDate?: InputMaybe<Scalars['AWSDate']['input']>
  ssn?: InputMaybe<Scalars['String']['input']>
  suffix?: InputMaybe<Scalars['String']['input']>
}

export type ProviderDocument = {
  created: AuditEntry
  documentCategory: DocumentCategory
  file: File
  id: Scalars['ID']['output']
  modified?: Maybe<AuditEntry>
  stateCode?: Maybe<Scalars['String']['output']>
  status?: Maybe<DocumentVerificationStatus>
  statusUpdated?: Maybe<AuditEntry>
}

export type ProviderExternalAccount = {
  id: Scalars['String']['output']
  note?: Maybe<Scalars['String']['output']>
  password?: Maybe<EncryptedValue>
  type: Scalars['String']['output']
  username: Scalars['String']['output']
}

export type ProviderExternalAccountInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  note?: InputMaybe<Scalars['String']['input']>
  password?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  username?: InputMaybe<Scalars['String']['input']>
}

export type ProviderFlags = {
  sessionTimeout?: Maybe<Scalars['Float']['output']>
  vaultActive?: Maybe<Scalars['Boolean']['output']>
}

export type ProviderIdentifier = {
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>
  effectiveDate?: Maybe<Scalars['AWSDate']['output']>
  expirationDate?: Maybe<Scalars['AWSDate']['output']>
  id: Scalars['ID']['output']
  lastModified?: Maybe<Scalars['AWSDateTime']['output']>
  type: ProviderIdentifierType
  value: Scalars['String']['output']
}

export type ProviderIdentifierInput = {
  effectiveDate?: InputMaybe<Scalars['AWSDate']['input']>
  expirationDate?: InputMaybe<Scalars['AWSDate']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  type?: InputMaybe<ProviderIdentifierType>
  value?: InputMaybe<Scalars['String']['input']>
}

export enum ProviderIdentifierType {
  CandidId = 'CANDID_ID',
  CaqhId = 'CAQH_ID',
  HrId = 'HR_ID',
  LumaId = 'LUMA_ID',
  MedplumId = 'MEDPLUM_ID',
  MedtrainerId = 'MEDTRAINER_ID',
  MmrId = 'MMR_ID',
  NextgenId = 'NEXTGEN_ID',
  NextgenResourceId = 'NEXTGEN_RESOURCE_ID',
  Npi = 'NPI',
  PrimaryCmsTaxonomy = 'PRIMARY_CMS_TAXONOMY',
  SecondaryCmsTaxonomy = 'SECONDARY_CMS_TAXONOMY',
}

export type ProviderInputCreate = {
  ages?: InputMaybe<Array<Scalars['String']['input']>>
  availability: Availability
  availabilityNotes?: InputMaybe<Scalars['String']['input']>
  bio?: InputMaybe<Scalars['String']['input']>
  careCoordinatorId?: InputMaybe<Scalars['ID']['input']>
  careManagerId: Scalars['ID']['input']
  clinicalAges?: InputMaybe<Array<Scalars['String']['input']>>
  clinicalModalities?: InputMaybe<Array<Scalars['String']['input']>>
  clinicalSpecialties?: InputMaybe<Array<Scalars['String']['input']>>
  communityIdentity?: InputMaybe<Array<CommunityIdentity>>
  email?: InputMaybe<Scalars['String']['input']>
  employment?: InputMaybe<EmploymentInput>
  ethnicity?: InputMaybe<Ethnicity>
  expectedHours?: InputMaybe<Array<ExpectedHoursInput>>
  firstName?: InputMaybe<Scalars['String']['input']>
  genderIdentity?: InputMaybe<GenderIdentity>
  identifiers?: InputMaybe<Array<ProviderIdentifierInput>>
  insurancePlans?: InputMaybe<Array<InsurancePlanParticipantInput>>
  languages?: InputMaybe<Array<Scalars['String']['input']>>
  lastName?: InputMaybe<Scalars['String']['input']>
  modalities?: InputMaybe<Array<Scalars['String']['input']>>
  race?: InputMaybe<Array<Race>>
  serviceTypes?: InputMaybe<Array<ProviderServiceType>>
  specialties?: InputMaybe<Array<Scalars['String']['input']>>
  spirituality?: InputMaybe<Array<Scalars['String']['input']>>
  status?: InputMaybe<ProviderStatus>
  supervisorId?: InputMaybe<Scalars['ID']['input']>
}

export type ProviderInputUpdate = {
  ages?: InputMaybe<Array<Scalars['String']['input']>>
  availability?: InputMaybe<Availability>
  availabilityNotes?: InputMaybe<Scalars['String']['input']>
  bio?: InputMaybe<Scalars['String']['input']>
  careCoordinatorId?: InputMaybe<Scalars['ID']['input']>
  clinicalAges?: InputMaybe<Array<Scalars['String']['input']>>
  clinicalModalities?: InputMaybe<Array<Scalars['String']['input']>>
  clinicalSpecialties?: InputMaybe<Array<Scalars['String']['input']>>
  communityIdentity?: InputMaybe<Array<CommunityIdentity>>
  email?: InputMaybe<Scalars['String']['input']>
  employment?: InputMaybe<EmploymentInput>
  ethnicity?: InputMaybe<Ethnicity>
  expectedHours?: InputMaybe<Array<ExpectedHoursInput>>
  firstName?: InputMaybe<Scalars['String']['input']>
  genderIdentity?: InputMaybe<GenderIdentity>
  identifiers?: InputMaybe<Array<ProviderIdentifierInput>>
  insurancePlans?: InputMaybe<Array<InsurancePlanParticipantInput>>
  languages?: InputMaybe<Array<Scalars['String']['input']>>
  lastName?: InputMaybe<Scalars['String']['input']>
  modalities?: InputMaybe<Array<Scalars['String']['input']>>
  nextgenTimezone?: InputMaybe<Scalars['String']['input']>
  race?: InputMaybe<Array<Race>>
  serviceTypes?: InputMaybe<Array<ProviderServiceType>>
  specialties?: InputMaybe<Array<Scalars['String']['input']>>
  spirituality?: InputMaybe<Array<Scalars['String']['input']>>
  status?: InputMaybe<ProviderStatus>
  supervisorId?: InputMaybe<Scalars['ID']['input']>
  tags?: InputMaybe<Array<ProviderTagInput>>
}

export type ProviderLicense = {
  created: AuditEntry
  durationType?: Maybe<LicenseDurationType>
  excludeFromPayerEnrollment: Scalars['Boolean']['output']
  expirationDate?: Maybe<Scalars['AWSDate']['output']>
  id: Scalars['ID']['output']
  issueDate?: Maybe<Scalars['AWSDate']['output']>
  licenseType: LicenseType
  modified?: Maybe<AuditEntry>
  number: Scalars['String']['output']
  stateCode: Scalars['String']['output']
  status: ActiveStatus
}

export type ProviderLicenseCreateInput = {
  durationType?: InputMaybe<LicenseDurationType>
  excludeFromPayerEnrollment?: InputMaybe<Scalars['Boolean']['input']>
  expirationDate?: InputMaybe<Scalars['AWSDate']['input']>
  issueDate?: InputMaybe<Scalars['AWSDate']['input']>
  licenseType: LicenseType
  number: Scalars['String']['input']
  stateCode: Scalars['String']['input']
  status: ActiveStatus
}

export type ProviderLicenseRequest = {
  comments?: Maybe<Array<Annotation>>
  completeDate?: Maybe<Scalars['AWSDate']['output']>
  created: AuditEntry
  durationType?: Maybe<LicenseDurationType>
  id: Scalars['ID']['output']
  licenseType: LicenseType
  modified?: Maybe<AuditEntry>
  psvSubmitDate?: Maybe<Scalars['AWSDate']['output']>
  requestType: LicenseRequestType
  stateCode: Scalars['String']['output']
  status: LicenseRequestStatus
  submitDate?: Maybe<Scalars['AWSDate']['output']>
}

export type ProviderLicenseRequestCreateInput = {
  comment?: InputMaybe<Scalars['String']['input']>
  completeDate?: InputMaybe<Scalars['AWSDate']['input']>
  durationType?: InputMaybe<LicenseDurationType>
  licenseType: LicenseType
  psvSubmitDate?: InputMaybe<Scalars['AWSDate']['input']>
  requestType: LicenseRequestType
  stateCode: Scalars['String']['input']
  status: LicenseRequestStatus
  submitDate?: InputMaybe<Scalars['AWSDate']['input']>
}

export type ProviderLicenseRequestUpdateInput = {
  comment?: InputMaybe<Scalars['String']['input']>
  completeDate?: InputMaybe<Scalars['AWSDate']['input']>
  durationType?: InputMaybe<LicenseDurationType>
  id: Scalars['ID']['input']
  licenseType?: InputMaybe<LicenseType>
  psvSubmitDate?: InputMaybe<Scalars['AWSDate']['input']>
  requestType?: InputMaybe<LicenseRequestType>
  stateCode?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<LicenseRequestStatus>
  submitDate?: InputMaybe<Scalars['AWSDate']['input']>
}

export type ProviderLicenseUpdateInput = {
  durationType?: InputMaybe<LicenseDurationType>
  excludeFromPayerEnrollment?: InputMaybe<Scalars['Boolean']['input']>
  expirationDate?: InputMaybe<Scalars['AWSDate']['input']>
  id: Scalars['ID']['input']
  issueDate?: InputMaybe<Scalars['AWSDate']['input']>
  licenseType?: InputMaybe<LicenseType>
  number?: InputMaybe<Scalars['String']['input']>
  stateCode?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<ActiveStatus>
}

export type ProviderPlanParticipant = {
  _id: Scalars['ID']['output']
  billingRelationship: InsurancePlanBillingRelationship
  effectiveDate?: Maybe<Scalars['AWSDate']['output']>
  insurancePlan: InsurancePlanPartial
  participatingProvider: Reference
  status?: Maybe<ActiveStatus>
  terminationDate?: Maybe<Scalars['AWSDate']['output']>
}

export enum ProviderServiceType {
  Dbt = 'DBT',
  Emdr = 'EMDR',
  GroupTherapy = 'GROUP_THERAPY',
  MedMgmt = 'MED_MGMT',
  SuicideCare = 'SUICIDE_CARE',
  Therapy = 'THERAPY',
  Yst = 'YST',
}

export type ProviderSettings = {
  chat?: Maybe<ProviderChatSettings>
  flags?: Maybe<ProviderFlags>
  languages?: Maybe<Array<StandardListItem>>
  modalities?: Maybe<Array<StandardListItem>>
  sessionTimeout?: Maybe<Scalars['Float']['output']>
  specialties?: Maybe<Array<StandardListItem>>
  spirituality?: Maybe<Array<StandardListItem>>
  tags?: Maybe<Array<StandardListItem>>
}

export enum ProviderStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export type ProviderTag = {
  value: Scalars['String']['output']
}

export type ProviderTagInput = {
  value: Scalars['String']['input']
}

export type ProvisionedUser = {
  careManager: CareManagerUser
  cognito: Cognito
  permitRoles?: Maybe<Array<Scalars['ID']['output']>>
}

export type PullResponse = {
  results?: Maybe<Array<SyncResponse>>
}

export type PushResponse = {
  results?: Maybe<Array<SyncResponse>>
}

export type Query = {
  _placeholder?: Maybe<Scalars['String']['output']>
  checkEmrAvailability?: Maybe<AvailabilityResponse>
  describePatientsById: Array<PatientSummary>
  describePatientsByTreatmentId: Array<PatientSummary>
  describePatientsByUserId: Array<PatientSummary>
  describeUsersByCareManagerId: Array<UserSummary>
  describeUsersByCognitoUserId: Array<UserSummary>
  describeUsersByEmrId: Array<UserSummary>
  describeUsersById: Array<UserSummary>
  describeUsersByProviderId: Array<UserSummary>
  getAppointment?: Maybe<Appointment>
  getConfig: Array<ConfigItem>
  getDocument: Document
  getDocumentsByTreatmentId: Array<Document>
  getEmployment: Employment
  getEmploymentByProviderId: Employment
  getEmployments: Array<Employment>
  getExternalInsurancePlans: Array<InsurancePlanExternal>
  getExternalLanguages: Array<Language>
  getExternalLocations: Array<Location>
  getExternalPracticeServices: Array<PracticeService>
  getExternalPracticeStates: Array<PracticeState>
  getInheritingProviders: Array<ProviderPlanParticipant>
  getInsurancePlans: Array<InsurancePlanFull>
  getList: Array<ListResponse>
  getLocations: Array<Location>
  getOutOfNetworkInsurancePlans: Array<InsurancePlanFull>
  getOutstandingTasks: TaskResponse
  getPatientByTreatmentId: Patient
  getPayerEnrollmentsByProviderId: Array<PayerEnrollment>
  getPayers: Array<Payer>
  getPracticeStates: Array<PracticeState>
  getPracticeTaxEntities: Array<PracticeTaxEntity>
  getProfessionalHistory: Array<ProfessionalHistory>
  getProfessionalHistoryById: ProfessionalHistory
  getProgramSettings: ProgramSettings
  getProgramSettingsExternal: ProgramSettingsExternal
  getProvider: Provider
  getProviderByCareManagerId: Provider
  getProviderCredentialing: ProviderCredentialing
  getProviderDocument: ProviderDocument
  getProviderDocumentsByProviderId: Array<ProviderDocument>
  getProviderExternalAccounts: Array<ProviderExternalAccount>
  getProviders: Array<Provider>
  getSchedule?: Maybe<Schedule>
  getSigningUrlExternal: GetSigningUrlExternalResponse
  getSyncHistory?: Maybe<Array<SyncHistory>>
  getTask: Task
  getTasks: Array<Task>
  getTasksByTreatmentIds: Array<Task>
  getUser: User
  getUserById: User
  getUsers?: Maybe<Array<User>>
  getVerifiedProviderDocument: ProviderDocument
  getVerifiedProviderDocumentsByProviderId: Array<ProviderDocument>
  listEligibilityVerifications: Array<EligibilityVerification>
  listPatientEligibilityVerifications: Array<EligibilityVerification>
  listSecurityRoles: Array<SecurityRoleResponse>
  listStates?: Maybe<Array<Maybe<State>>>
  loadEligibilityVerification?: Maybe<EligibilityVerification>
  loadPatientBilling?: Maybe<PatientBilling>
  loadPatientBillingExternal?: Maybe<PatientBilling>
  searchAppointments?: Maybe<AppointmentResponse>
  searchAuditEvents: SearchAuditEntryResponse
  searchPatients: SearchPatientsResponse
  searchProviderEvents: SearchProviderEventsResponse
  searchProviders: SearchProvidersResponse
  searchReadEvents: SearchAuditEntryResponse
  searchSchedules?: Maybe<ScheduleResponse>
  searchTasks: TaskResponse
  searchWriteEvents: SearchAuditEntryResponse
  timeSlotSearch: TimeSlotSearchRes
}

export type QueryCheckEmrAvailabilityArgs = {
  content?: InputMaybe<AvailabilityRequest>
}

export type QueryDescribePatientsByIdArgs = {
  forceInvalidate?: InputMaybe<Scalars['Boolean']['input']>
  patientIds: Array<Scalars['String']['input']>
}

export type QueryDescribePatientsByTreatmentIdArgs = {
  forceInvalidate?: InputMaybe<Scalars['Boolean']['input']>
  treatmentIds: Array<Scalars['String']['input']>
}

export type QueryDescribePatientsByUserIdArgs = {
  forceInvalidate?: InputMaybe<Scalars['Boolean']['input']>
  userIds: Array<Scalars['String']['input']>
}

export type QueryDescribeUsersByCareManagerIdArgs = {
  careManagerIds: Array<Scalars['String']['input']>
  forceInvalidate?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryDescribeUsersByCognitoUserIdArgs = {
  cognitoUserIds: Array<Scalars['String']['input']>
  forceInvalidate?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryDescribeUsersByEmrIdArgs = {
  emrIds: Array<Scalars['String']['input']>
  forceInvalidate?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryDescribeUsersByIdArgs = {
  forceInvalidate?: InputMaybe<Scalars['Boolean']['input']>
  userIds: Array<Scalars['String']['input']>
}

export type QueryDescribeUsersByProviderIdArgs = {
  forceInvalidate?: InputMaybe<Scalars['Boolean']['input']>
  providerIds: Array<Scalars['String']['input']>
}

export type QueryGetAppointmentArgs = {
  _id: Scalars['ID']['input']
}

export type QueryGetConfigArgs = {
  forceInvalidate?: InputMaybe<Scalars['Boolean']['input']>
  keys: Array<Scalars['String']['input']>
}

export type QueryGetDocumentArgs = {
  documentId: Scalars['ID']['input']
  treatmentId: Scalars['ID']['input']
}

export type QueryGetDocumentsByTreatmentIdArgs = {
  treatmentId: Scalars['ID']['input']
}

export type QueryGetEmploymentArgs = {
  _id: Scalars['ID']['input']
}

export type QueryGetEmploymentByProviderIdArgs = {
  providerId: Scalars['ID']['input']
}

export type QueryGetExternalLocationsArgs = {
  input?: InputMaybe<GetExternalLocationsInput>
}

export type QueryGetExternalPracticeServicesArgs = {
  input: GetExternalPracticeServicesInput
}

export type QueryGetExternalPracticeStatesArgs = {
  input: GetExternalPracticeStatesInput
}

export type QueryGetInheritingProvidersArgs = {
  insurancePlanIds: Array<Scalars['ID']['input']>
  providerId: Scalars['ID']['input']
}

export type QueryGetListArgs = {
  forceInvalidate?: InputMaybe<Scalars['Boolean']['input']>
  keys: Array<Scalars['String']['input']>
}

export type QueryGetOutstandingTasksArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>
  query: Scalars['AWSJSON']['input']
}

export type QueryGetPatientByTreatmentIdArgs = {
  treatmentId: Scalars['ID']['input']
}

export type QueryGetPayerEnrollmentsByProviderIdArgs = {
  providerId: Scalars['ID']['input']
}

export type QueryGetProfessionalHistoryArgs = {
  providerId: Scalars['ID']['input']
}

export type QueryGetProfessionalHistoryByIdArgs = {
  id: Scalars['ID']['input']
}

export type QueryGetProgramSettingsArgs = {
  forceInvalidate?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryGetProviderArgs = {
  _id: Scalars['ID']['input']
}

export type QueryGetProviderByCareManagerIdArgs = {
  careManagerId: Scalars['ID']['input']
}

export type QueryGetProviderCredentialingArgs = {
  providerId: Scalars['ID']['input']
}

export type QueryGetProviderDocumentArgs = {
  documentId: Scalars['ID']['input']
  providerId: Scalars['ID']['input']
}

export type QueryGetProviderDocumentsByProviderIdArgs = {
  providerId: Scalars['ID']['input']
}

export type QueryGetProviderExternalAccountsArgs = {
  providerId: Scalars['ID']['input']
}

export type QueryGetProvidersArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>
  searchAfter?: InputMaybe<Scalars['AWSJSON']['input']>
}

export type QueryGetScheduleArgs = {
  _id: Scalars['ID']['input']
}

export type QueryGetSigningUrlExternalArgs = {
  input?: InputMaybe<GetSigningUrlExternalInput>
}

export type QueryGetSyncHistoryArgs = {
  providerId: Scalars['String']['input']
}

export type QueryGetTaskArgs = {
  _id: Scalars['ID']['input']
}

export type QueryGetTasksByTreatmentIdsArgs = {
  treatmentIds: Array<Scalars['ID']['input']>
}

export type QueryGetUserArgs = {
  email: Scalars['String']['input']
}

export type QueryGetUserByIdArgs = {
  content: GetUserByIdInput
}

export type QueryGetVerifiedProviderDocumentArgs = {
  documentId: Scalars['ID']['input']
  providerId: Scalars['ID']['input']
}

export type QueryGetVerifiedProviderDocumentsByProviderIdArgs = {
  providerId: Scalars['ID']['input']
}

export type QueryListEligibilityVerificationsArgs = {
  input: ListEligibilityVerificationInput
}

export type QueryListPatientEligibilityVerificationsArgs = {
  input: ListPatientEligibilityVerificationInput
}

export type QueryLoadEligibilityVerificationArgs = {
  input: LoadEligibilityVerificationInput
}

export type QueryLoadPatientBillingArgs = {
  input: LoadPatientBillingInput
}

export type QuerySearchAppointmentsArgs = {
  content?: InputMaybe<Array<SearchFilter>>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  searchAfter?: InputMaybe<Scalars['AWSJSON']['input']>
  sort?: InputMaybe<Array<SortParam>>
}

export type QuerySearchAuditEventsArgs = {
  aggregations?: InputMaybe<Scalars['AWSJSON']['input']>
  from?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  query: Scalars['AWSJSON']['input']
  searchAfter?: InputMaybe<Scalars['AWSJSON']['input']>
  sort?: InputMaybe<Scalars['AWSJSON']['input']>
}

export type QuerySearchPatientsArgs = {
  aggregations?: InputMaybe<Scalars['AWSJSON']['input']>
  from?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  query: Scalars['AWSJSON']['input']
  searchAfter?: InputMaybe<Scalars['AWSJSON']['input']>
  sort?: InputMaybe<Scalars['AWSJSON']['input']>
}

export type QuerySearchProviderEventsArgs = {
  aggregations?: InputMaybe<Scalars['AWSJSON']['input']>
  from?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  query: Scalars['AWSJSON']['input']
  searchAfter?: InputMaybe<Scalars['AWSJSON']['input']>
  sort?: InputMaybe<Scalars['AWSJSON']['input']>
}

export type QuerySearchProvidersArgs = {
  aggregations?: InputMaybe<Scalars['AWSJSON']['input']>
  from?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  query: Scalars['AWSJSON']['input']
  searchAfter?: InputMaybe<Scalars['AWSJSON']['input']>
  sort?: InputMaybe<Scalars['AWSJSON']['input']>
}

export type QuerySearchReadEventsArgs = {
  aggregations?: InputMaybe<Scalars['AWSJSON']['input']>
  from?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  query: Scalars['AWSJSON']['input']
  searchAfter?: InputMaybe<Scalars['AWSJSON']['input']>
  sort?: InputMaybe<Scalars['AWSJSON']['input']>
}

export type QuerySearchSchedulesArgs = {
  content?: InputMaybe<Array<SearchFilter>>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  searchAfter?: InputMaybe<Scalars['AWSJSON']['input']>
  sort?: InputMaybe<Array<SortParam>>
}

export type QuerySearchTasksArgs = {
  aggregations?: InputMaybe<Scalars['AWSJSON']['input']>
  from?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  query: Scalars['AWSJSON']['input']
  searchAfter?: InputMaybe<Scalars['AWSJSON']['input']>
  sort?: InputMaybe<Scalars['AWSJSON']['input']>
}

export type QuerySearchWriteEventsArgs = {
  aggregations?: InputMaybe<Scalars['AWSJSON']['input']>
  from?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  query: Scalars['AWSJSON']['input']
  searchAfter?: InputMaybe<Scalars['AWSJSON']['input']>
  sort?: InputMaybe<Scalars['AWSJSON']['input']>
}

export type QueryTimeSlotSearchArgs = {
  aggregations?: InputMaybe<Scalars['AWSJSON']['input']>
  from?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  query: Scalars['AWSJSON']['input']
  searchAfter?: InputMaybe<Scalars['AWSJSON']['input']>
  sort?: InputMaybe<Scalars['AWSJSON']['input']>
}

export type Questionnaire = {
  name?: Maybe<Scalars['String']['output']>
  score?: Maybe<Scalars['Int']['output']>
}

export type QuestionnaireInput = {
  name: Scalars['String']['input']
  score: Scalars['Int']['input']
}

export enum QuestionnaireName {
  Gad7 = 'GAD7',
  Phq = 'PHQ',
}

export enum Race {
  Asian = 'ASIAN',
  Black = 'BLACK',
  Native = 'NATIVE',
  PacificIslander = 'PACIFIC_ISLANDER',
  White = 'WHITE',
}

export type Reference = {
  _id?: Maybe<Scalars['ID']['output']>
  active?: Maybe<Scalars['Boolean']['output']>
  display?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  reference?: Maybe<Scalars['String']['output']>
  type: ResourceType
}

export type ReferenceInput = {
  _id: Scalars['String']['input']
  type: ResourceType
}

export type ReferrerInformation = {
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  phoneNumber: Scalars['String']['input']
}

export type ReferrerInformationInput = {
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  phoneNumber: Scalars['String']['input']
}

export type ReoccuranceTemplate = {
  id: Scalars['ID']['output']
  lastOccuranceIndex?: Maybe<Scalars['Int']['output']>
  monthlyTemplate?: Maybe<Array<MonthlyTemplate>>
  occuranceCount?: Maybe<Scalars['Int']['output']>
  planningHorizon: Period
  reoccuranceType: ReoccuranceType
  timezone: Scalars['String']['output']
  weeklyTemplate?: Maybe<Array<WeeklyTemplate>>
}

export type ReoccuranceTemplateInput = {
  monthlyTemplate?: InputMaybe<Array<MonthlyTemplateInput>>
  occuranceCount?: InputMaybe<Scalars['Int']['input']>
  planningHorizon: PeriodInput
  reoccuranceType: ReoccuranceType
  timezone: Scalars['String']['input']
  weeklyTemplate?: InputMaybe<Array<WeeklyTemplateInput>>
}

export type ReoccuranceTemplateSummary = {
  planningHorizon: Period
  timezone: Scalars['String']['output']
}

export enum ReoccuranceType {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
}

export type ResendUserPasswordRes = {
  isSuccess: Scalars['Boolean']['output']
}

export enum ResourceType {
  Caremanager = 'CAREMANAGER',
  Cognito = 'COGNITO',
  Email = 'EMAIL',
  Location = 'LOCATION',
  Patient = 'PATIENT',
  Practitioner = 'PRACTITIONER',
}

export type RestorePatientInput = {
  notifyPatient?: InputMaybe<Scalars['Boolean']['input']>
  patientId: Scalars['String']['input']
  patientStatus?: InputMaybe<PatientStatus>
}

export type ResyncProviderAvailabilityRequest = {
  careManagerId?: InputMaybe<Scalars['ID']['input']>
  providerId?: InputMaybe<Scalars['ID']['input']>
}

export type ResyncResponse = {
  message?: Maybe<Scalars['String']['output']>
}

export type SavePatientBillingExternalInput = {
  idFile?: InputMaybe<FileCreate>
  insurances?: InputMaybe<Array<UpdateBillingExternalInput>>
}

export type SavePatientBillingExternalOutput = {
  id: Scalars['String']['output']
  success: Scalars['Boolean']['output']
}

export type Schedule = Node & {
  _id: Scalars['ID']['output']
  active: Scalars['Boolean']['output']
  actors: Array<Reference>
  name?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Array<Annotation>>
  reoccuranceTemplate: ReoccuranceTemplate
  serviceCategory: ServiceCategory
  serviceType: ServiceType
  subjectLimit: Scalars['Int']['output']
}

export type ScheduleInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>
  actors?: InputMaybe<Array<ReferenceInput>>
  name?: InputMaybe<Scalars['String']['input']>
  note?: InputMaybe<Scalars['String']['input']>
  reoccuranceTemplate?: InputMaybe<ReoccuranceTemplateInput>
  serviceCategory?: InputMaybe<ServiceCategoryCode>
  serviceType?: InputMaybe<ServiceTypeCode>
  subjectLimit?: InputMaybe<Scalars['Int']['input']>
}

export type ScheduleResponse = {
  results: Array<Schedule>
  searchAfter?: Maybe<Scalars['AWSJSON']['output']>
  totalCount?: Maybe<Scalars['Int']['output']>
}

export type ScheduleSummary = {
  active: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  locations?: Maybe<Array<LocationSummary>>
  reoccuranceTemplate: ReoccuranceTemplateSummary
  serviceCategory: ServiceCategory
  serviceType: ServiceType
}

export type SearchAuditEntryResponse = {
  aggregations?: Maybe<Scalars['AWSJSON']['output']>
  audits: Array<ApiAuditEntry>
  from?: Maybe<Scalars['Int']['output']>
  resultCount: Scalars['Int']['output']
  searchAfter?: Maybe<Scalars['AWSJSON']['output']>
}

export type SearchFilter = {
  filter: SearchFilterEnum
  operator?: InputMaybe<Operator>
  value: Scalars['String']['input']
}

export enum SearchFilterEnum {
  ApptStatus = 'APPT_STATUS',
  CategoryCode = 'CATEGORY_CODE',
  EndDate = 'END_DATE',
  ParticipantTypeCode = 'PARTICIPANT_TYPE_CODE',
  PatientId = 'PATIENT_ID',
  ProviderId = 'PROVIDER_ID',
  StartDate = 'START_DATE',
}

export type SearchPatientsResponse = {
  aggregations?: Maybe<Scalars['AWSJSON']['output']>
  from?: Maybe<Scalars['Int']['output']>
  patients: Array<SearchablePatient>
  resultCount: Scalars['Int']['output']
  searchAfter?: Maybe<Scalars['AWSJSON']['output']>
  tracks?: Maybe<Array<Track>>
}

export type SearchProvider = {
  ages?: Maybe<Array<Scalars['String']['output']>>
  availability?: Maybe<Scalars['String']['output']>
  availabilityNotes?: Maybe<Scalars['String']['output']>
  bio?: Maybe<Scalars['String']['output']>
  careCoordinator?: Maybe<Reference>
  careManagerId: Scalars['ID']['output']
  clinicalAges?: Maybe<Array<Scalars['String']['output']>>
  clinicalModalities?: Maybe<Array<Scalars['String']['output']>>
  clinicalSpecialties?: Maybe<Array<Scalars['String']['output']>>
  communityIdentity?: Maybe<Array<CommunityIdentity>>
  email: Scalars['String']['output']
  employment?: Maybe<Employment>
  ethnicity?: Maybe<Ethnicity>
  expectedHours?: Maybe<Array<ExpectedHours>>
  firstName: Scalars['String']['output']
  genderIdentity?: Maybe<GenderIdentity>
  id: Scalars['ID']['output']
  identifiers?: Maybe<Array<ProviderIdentifier>>
  insurancePlans?: Maybe<Array<SearchableInsurancePlanParticipant>>
  languages?: Maybe<Array<Scalars['String']['output']>>
  lastName: Scalars['String']['output']
  licenses?: Maybe<Array<ProviderLicense>>
  modalities?: Maybe<Array<Scalars['String']['output']>>
  nextgenTimezone?: Maybe<Scalars['String']['output']>
  payerEnrollments?: Maybe<Array<PayerEnrollment>>
  race?: Maybe<Array<Race>>
  schedules?: Maybe<Array<ScheduleSummary>>
  serviceTypes?: Maybe<Array<ProviderServiceType>>
  specialties?: Maybe<Array<Scalars['String']['output']>>
  spirituality?: Maybe<Array<Scalars['String']['output']>>
  status: Scalars['String']['output']
  supervisees?: Maybe<Array<Reference>>
  supervisor?: Maybe<Reference>
  tags?: Maybe<Array<ProviderTag>>
  teamLead?: Maybe<Reference>
}

export type SearchProviderEventsResponse = {
  status?: Maybe<Scalars['Boolean']['output']>
}

export type SearchProvidersResponse = {
  aggregations?: Maybe<Scalars['AWSJSON']['output']>
  from?: Maybe<Scalars['Int']['output']>
  resultCount: Scalars['Int']['output']
  results: Array<SearchProvider>
  searchAfter?: Maybe<Scalars['AWSJSON']['output']>
}

export type SearchableInsurancePlanPartial = {
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  payerCode?: Maybe<Scalars['String']['output']>
  stateCode: Scalars['String']['output']
  stateName?: Maybe<Scalars['String']['output']>
  status: InsurancePlanStatus
}

export type SearchableInsurancePlanParticipant = {
  billingRelationship?: Maybe<InsurancePlanBillingRelationship>
  effectiveDate?: Maybe<Scalars['AWSDate']['output']>
  id: Scalars['ID']['output']
  insurancePlan: SearchableInsurancePlanPartial
  status: InsurancePlanParticipantStatus
  terminationDate?: Maybe<Scalars['AWSDate']['output']>
}

export type SearchablePatient = {
  address?: Maybe<PatientAddress>
  billingInsurances?: Maybe<Array<PatientBillingInsurance>>
  careTeam?: Maybe<Array<CareTeamSearchMember>>
  dateOfBirth?: Maybe<Scalars['AWSDate']['output']>
  dischargeReason?: Maybe<Scalars['String']['output']>
  emrId?: Maybe<Scalars['String']['output']>
  gender?: Maybe<Scalars['String']['output']>
  genderDetails?: Maybe<Scalars['String']['output']>
  genderIdentity?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isIntegrationActive?: Maybe<Scalars['Boolean']['output']>
  lumaId?: Maybe<Scalars['String']['output']>
  medPlumPatientId?: Maybe<Scalars['String']['output']>
  mmrPatientId?: Maybe<Scalars['String']['output']>
  mrn?: Maybe<Scalars['String']['output']>
  name: PatientName
  nextgenId?: Maybe<Scalars['String']['output']>
  notices?: Maybe<Array<PatientNotice>>
  preferredLanguage?: Maybe<Scalars['String']['output']>
  primaryEmail?: Maybe<Scalars['String']['output']>
  primaryPhone?: Maybe<Scalars['String']['output']>
  pronouns?: Maybe<Scalars['String']['output']>
  selfPay: Scalars['Boolean']['output']
  signInPhone?: Maybe<Scalars['String']['output']>
  status: PatientStatus
  tags?: Maybe<Array<Scalars['String']['output']>>
  timeZone?: Maybe<Scalars['String']['output']>
  tracks?: Maybe<Array<Maybe<Track>>>
  treatmentId: Scalars['ID']['output']
  upcomingAppointments?: Maybe<Array<AppointmentDisplay>>
  videoRoomId?: Maybe<Scalars['String']['output']>
}

export type SearchableReference = {
  active?: Maybe<Scalars['Boolean']['output']>
  display?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  reference?: Maybe<Scalars['String']['output']>
}

export type SearchableTask = {
  assignee: SearchableReference
  assigneeId: Scalars['ID']['output']
  createdBy: SearchableReference
  createdById: Scalars['ID']['output']
  createdDate: Scalars['AWSDateTime']['output']
  description: Scalars['String']['output']
  dueDate: Scalars['AWSDate']['output']
  id: Scalars['ID']['output']
  lastUpdatedDate: Scalars['AWSDateTime']['output']
  patient?: Maybe<PatientMetaData>
  patientId: Scalars['ID']['output']
  patientPreferences?: Maybe<Scalars['AWSJSON']['output']>
  recentComments: Array<Annotation>
  referralSource?: Maybe<Scalars['String']['output']>
  serviceType?: Maybe<TaskServiceType>
  status: TaskStatus
  treatmentId: Scalars['ID']['output']
  type: TaskType
}

export type SecurityRoleResponse = {
  key: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type SendConsentPacketInput = {
  /** If true sends new agreement even if fullConsentPacketSigned is true */
  checkIfAlreadySigned?: InputMaybe<Scalars['Boolean']['input']>
  /** If there is already an agreement sent out for signature, this will cancel it and send a new, otherwise only a reminder email will be sent */
  forceNew?: InputMaybe<Scalars['Boolean']['input']>
  treatmentId: Scalars['ID']['input']
  /** Whether to send from the service user account or send agreement with the api callers email (person who sent the consent packet will get emails of sign events) */
  usingServiceUser?: InputMaybe<Scalars['Boolean']['input']>
}

export type SendConsentPacketResponse = {
  code?: Maybe<Scalars['String']['output']>
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type SendEligibilityVerificationInput = {
  billingInsuranceId?: InputMaybe<Scalars['ID']['input']>
  billingInsuranceType?: InputMaybe<Scalars['String']['input']>
  eligibilityVerificationId?: InputMaybe<Scalars['ID']['input']>
  medium: CommunicationMedium
  treatmentId: Scalars['ID']['input']
}

export type SendOtpInput = {
  method?: InputMaybe<OtpMethod>
  phoneNumber: Scalars['String']['input']
}

export type SendOtpResponse = {
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type ServiceCategory = ICodeableConcept & {
  code: ServiceCategoryCode
  coding?: Maybe<Array<Coding>>
  text?: Maybe<Scalars['String']['output']>
}

export enum ServiceCategoryCode {
  Admin = 'ADMIN',
  Break = 'BREAK',
  Cap = 'CAP',
  Group = 'GROUP',
  Intake = 'INTAKE',
  OutOfOffice = 'OUT_OF_OFFICE',
  Patient = 'PATIENT',
  Toc = 'TOC',
}

export type ServiceType = ICodeableConcept & {
  code: ServiceTypeCode
  coding?: Maybe<Array<Coding>>
  text?: Maybe<Scalars['String']['output']>
}

export enum ServiceTypeCode {
  Adm = 'ADM',
  Brk = 'BRK',
  Dbt = 'DBT',
  DbtInt = 'DBT_INT',
  Emdr = 'EMDR',
  EmdrInt = 'EMDR_INT',
  F30 = 'F30',
  F45 = 'F45',
  F60 = 'F60',
  FspFup = 'FSP_FUP',
  FspInt = 'FSP_INT',
  Grp = 'GRP',
  GrpInt = 'GRP_INT',
  Holiday = 'HOLIDAY',
  Int = 'INT',
  Int45 = 'INT45',
  LocInt = 'LOC_INT',
  Medrec = 'MEDREC',
  Other = 'OTHER',
  PsyCapInt = 'PSY_CAP_INT',
  PsyF20 = 'PSY_F20',
  PsyF30 = 'PSY_F30',
  PsyF45 = 'PSY_F45',
  PsyF60 = 'PSY_F60',
  PsyInc = 'PSY_INC',
  PsyInt = 'PSY_INT',
  PsyTocInt = 'PSY_TOC_INT',
  PsyTrf = 'PSY_TRF',
  Pto = 'PTO',
  ScpFup = 'SCP_FUP',
  ScpInt = 'SCP_INT',
  ScpPt = 'SCP_PT',
  Tif = 'TIF',
  TocInt = 'TOC_INT',
  Trf = 'TRF',
  YstFup = 'YST_FUP',
  YstInt = 'YST_INT',
}

export enum SessionType {
  GoogleMeet = 'GOOGLE_MEET',
  InPerson = 'IN_PERSON',
  Other = 'OTHER',
  ValeraVideo = 'VALERA_VIDEO',
  VirtualVisit = 'VIRTUAL_VISIT',
  Zoom = 'ZOOM',
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc',
}

export type SortParam = {
  field: SearchFilterEnum
  order: SortOrder
}

export type StandardListItem = IListItem & {
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  label: Scalars['String']['output']
  sortOrder?: Maybe<Scalars['Int']['output']>
  value: Scalars['String']['output']
}

export type State = {
  code?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type StateInput = {
  code: Scalars['String']['input']
  name: Scalars['String']['input']
}

export type SubmissionMetaData = {
  pendingVerificationOrdinalities?: Maybe<Array<InsuranceOrdinality>>
}

export type SubmissionResponse = {
  message?: Maybe<Scalars['String']['output']>
  metaData?: Maybe<SubmissionMetaData>
  submissionId: Scalars['ID']['output']
  success: Scalars['Boolean']['output']
}

export type SyncHistory = {
  action?: Maybe<Scalars['String']['output']>
  applicationName: Scalars['String']['output']
  appointmentDate?: Maybe<Scalars['String']['output']>
  appointmentId?: Maybe<Scalars['String']['output']>
  dateTime: Scalars['String']['output']
  direction: Scalars['String']['output']
  id: Scalars['String']['output']
  message?: Maybe<Scalars['String']['output']>
  nextgen?: Maybe<NextgenInfo>
  programId?: Maybe<Scalars['String']['output']>
  providerId?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
}

export type SyncInsuranceToEmrInput = {
  treatmentId: Scalars['ID']['input']
}

export type SyncResponse = {
  appointmentId?: Maybe<Scalars['ID']['output']>
  message?: Maybe<Scalars['String']['output']>
  status?: Maybe<SyncStatus>
}

export enum SyncStatus {
  Error = 'error',
  Initalized = 'initalized',
  Skipped = 'skipped',
  Success = 'success',
  Warning = 'warning',
}

export type SyncToEmrInput = {
  emrTarget?: InputMaybe<EmrTarget>
  syncPatientInsurance?: InputMaybe<Scalars['Boolean']['input']>
  treatmentId: Scalars['ID']['input']
}

export type Task = {
  _id: Scalars['ID']['output']
  assignee: Reference
  comments?: Maybe<Array<Annotation>>
  createdBy: Reference
  createdDate: Scalars['AWSDateTime']['output']
  description: Scalars['String']['output']
  dueDate: Scalars['AWSDate']['output']
  lastUpdatedDate: Scalars['AWSDateTime']['output']
  patient?: Maybe<PatientMetaData>
  patientId: Scalars['ID']['output']
  patientPreferences?: Maybe<Scalars['AWSJSON']['output']>
  referralSource?: Maybe<Scalars['String']['output']>
  serviceType?: Maybe<TaskServiceType>
  status: TaskStatus
  treatmentId: Scalars['ID']['output']
  type: TaskType
}

export type TaskReferenceInput = {
  _id: Scalars['ID']['input']
  type: ResourceType
}

export type TaskResponse = {
  aggregations?: Maybe<Scalars['AWSJSON']['output']>
  from?: Maybe<Scalars['Int']['output']>
  resultCount: Scalars['Int']['output']
  searchAfter?: Maybe<Scalars['AWSJSON']['output']>
  tasks: Array<SearchableTask>
}

export enum TaskServiceType {
  Dbt = 'DBT',
  Emdr = 'EMDR',
  GroupTherapy = 'GROUP_THERAPY',
  MedMgmt = 'MED_MGMT',
  SuicideCare = 'SUICIDE_CARE',
  Therapy = 'THERAPY',
  Yst = 'YST',
}

export enum TaskStatus {
  Completed = 'COMPLETED',
  Overdue = 'OVERDUE',
  ToDo = 'TO_DO',
  Void = 'VOID',
}

export enum TaskType {
  ApptCancelation = 'APPT_CANCELATION',
  ApptRequest = 'APPT_REQUEST',
  ApptReschedule = 'APPT_RESCHEDULE',
  AttendanceAgreement = 'ATTENDANCE_AGREEMENT',
  Billing = 'BILLING',
  CaseTransfer = 'CASE_TRANSFER',
  DeaClearance = 'DEA_CLEARANCE',
  Discharge = 'DISCHARGE',
  Grievance = 'GRIEVANCE',
  InsuranceVerification = 'INSURANCE_VERIFICATION',
  MedRecordRequest = 'MED_RECORD_REQUEST',
  MissingInfo = 'MISSING_INFO',
  NewPatientCallCenter = 'NEW_PATIENT_CALL_CENTER',
  NewPatientCallReferral = 'NEW_PATIENT_CALL_REFERRAL',
  NewPatientReferral = 'NEW_PATIENT_REFERRAL',
  NewPatientSelf = 'NEW_PATIENT_SELF',
  NewPatientToc = 'NEW_PATIENT_TOC',
  NewPatientWaitlist = 'NEW_PATIENT_WAITLIST',
  Other = 'OTHER',
  PatientTransfer = 'PATIENT_TRANSFER',
  PriorAuthorization = 'PRIOR_AUTHORIZATION',
  ReferralToExternal = 'REFERRAL_TO_EXTERNAL',
  ReferralToInternal = 'REFERRAL_TO_INTERNAL',
  RefillRequest = 'REFILL_REQUEST',
  TechIssue = 'TECH_ISSUE',
  TransitionsOfCare = 'TRANSITIONS_OF_CARE',
}

export type TimeSlot = {
  dayOfWeek: DayOfWeek
  durationMinutes: Scalars['Int']['output']
  endDate: Scalars['AWSDateTime']['output']
  endTime: Scalars['AWSTime']['output']
  id: Scalars['ID']['output']
  locations?: Maybe<Array<Scalars['ID']['output']>>
  provider: TimeSlotProvider
  scheduleId: Scalars['ID']['output']
  serviceCategoryCode: Scalars['String']['output']
  startDate: Scalars['AWSDateTime']['output']
  startTime: Scalars['AWSTime']['output']
}

export type TimeSlotLicense = {
  licenseType: LicenseType
  stateCode: Scalars['String']['output']
}

export type TimeSlotProvider = {
  availabilityNotes?: Maybe<Scalars['String']['output']>
  availabilityStatus: Availability
  bio?: Maybe<Scalars['String']['output']>
  careCoordinatorId?: Maybe<Scalars['ID']['output']>
  clinicalAges?: Maybe<Array<Scalars['String']['output']>>
  clinicalModalities?: Maybe<Array<Scalars['String']['output']>>
  clinicalSpecialties?: Maybe<Array<Scalars['String']['output']>>
  communityIdentity?: Maybe<Array<CommunityIdentity>>
  ethnicity?: Maybe<Ethnicity>
  genderIdentity?: Maybe<GenderIdentity>
  id: Scalars['ID']['output']
  identifiers?: Maybe<Array<ProviderIdentifier>>
  insurancePlans?: Maybe<Array<Scalars['ID']['output']>>
  languages?: Maybe<Array<Scalars['String']['output']>>
  legalSex?: Maybe<LegalSex>
  licenses?: Maybe<Array<TimeSlotLicense>>
  name: Scalars['String']['output']
  profession: ProfessionCode
  race?: Maybe<Array<Race>>
  serviceType?: Maybe<Array<ProviderServiceType>>
  spirituality?: Maybe<Array<Scalars['String']['output']>>
  supervisorId?: Maybe<Scalars['ID']['output']>
  tags?: Maybe<Array<ProviderTag>>
}

export type TimeSlotSearchRes = OpenSearchRes & {
  aggregations?: Maybe<Scalars['AWSJSON']['output']>
  from?: Maybe<Scalars['Int']['output']>
  resultCount: Scalars['Int']['output']
  results: Array<TimeSlot>
  searchAfter?: Maybe<Scalars['AWSJSON']['output']>
}

export type TocConfiguration = {
  fuh7: Scalars['Boolean']['output']
  fuh30: Scalars['Boolean']['output']
  fum7: Scalars['Boolean']['output']
  fum30: Scalars['Boolean']['output']
  referralSourceFilter?: Maybe<Scalars['String']['output']>
}

export type TocConfigurationInput = {
  fuh7: Scalars['Boolean']['input']
  fuh30: Scalars['Boolean']['input']
  fum7: Scalars['Boolean']['input']
  fum30: Scalars['Boolean']['input']
  referralSourceFilter?: InputMaybe<Scalars['String']['input']>
}

export enum TokenType {
  Bearer = 'Bearer',
}

export type Track = {
  name: Scalars['String']['output']
  planId: Scalars['ID']['output']
  templateId: Scalars['ID']['output']
  type: Scalars['String']['output']
}

export enum TrainingProgramType {
  Fellowship = 'FELLOWSHIP',
  Internship = 'INTERNSHIP',
  Residency = 'RESIDENCY',
}

export type UpdateAppointmentExternalInput = {
  cancelationReason?: InputMaybe<Scalars['String']['input']>
  endDate?: InputMaybe<Scalars['AWSDateTime']['input']>
  minutesDuration?: InputMaybe<Scalars['Float']['input']>
  startDate?: InputMaybe<Scalars['AWSDateTime']['input']>
  status?: InputMaybe<AppointmentStatus>
}

export type UpdateAppointmentInput = {
  appointmentType?: InputMaybe<AppointmentType>
  cancelationReason?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  endDate?: InputMaybe<Scalars['AWSDateTime']['input']>
  fulfilledStatus?: InputMaybe<FulfilledAppointmentStatisticsInput>
  identifiers?: InputMaybe<Array<AppointmentIdentifierInput>>
  minutesDuration?: InputMaybe<Scalars['Float']['input']>
  note?: InputMaybe<Scalars['String']['input']>
  occuranceChanged?: InputMaybe<Scalars['Boolean']['input']>
  participants?: InputMaybe<Array<ParticipantInput>>
  replacesAppointmentId?: InputMaybe<Scalars['String']['input']>
  serviceCategory?: InputMaybe<ServiceCategoryCode>
  serviceType?: InputMaybe<ServiceTypeCode>
  startDate?: InputMaybe<Scalars['AWSDateTime']['input']>
  status?: InputMaybe<AppointmentStatus>
  syncMessage?: InputMaybe<Scalars['String']['input']>
  virtualService?: InputMaybe<VirtualServiceInput>
}

export type UpdateBillingExternalInput = {
  cardBack?: InputMaybe<FileCreate>
  cardFront?: InputMaybe<FileCreate>
  type: InsuranceOrdinality
}

export type UpdateBillingInput = {
  comment?: InputMaybe<CommentAnnotationInput>
  consentPacketSignedDate?: InputMaybe<Scalars['AWSDateTime']['input']>
  creditCardOnFile?: InputMaybe<Scalars['Boolean']['input']>
  fullConsentPackedSigned?: InputMaybe<Scalars['Boolean']['input']>
  idFile?: InputMaybe<FileUpdate>
  idRelationship?: InputMaybe<PatientRelationshipToIdCard>
  idType?: InputMaybe<IdentificationType>
  idValue?: InputMaybe<Scalars['String']['input']>
  insurances?: InputMaybe<Array<BillingInsuredInput>>
  selfPay?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpdateBillingInsuredInput = {
  data: BillingInsuredInput
  id: Scalars['String']['input']
  type?: InputMaybe<Scalars['String']['input']>
}

export type UpdateCareTeamInput = {
  forcePctmOOO?: InputMaybe<Scalars['Boolean']['input']>
  members?: InputMaybe<Array<UpdateCareTeamMemberInput>>
  pctmId?: InputMaybe<Scalars['ID']['input']>
}

export type UpdateCareTeamMemberInput = {
  action: CareTeamMemberAction
  ctmId: Scalars['ID']['input']
}

export type UpdateDocumentInput = {
  file: FileUpdate
  id: Scalars['ID']['input']
}

export type UpdateFormSubmissionInput = {
  address?: InputMaybe<AddressComponentsInput>
  appointmentId?: InputMaybe<Scalars['String']['input']>
  billing?: InputMaybe<BillingInput>
  conditionInterferingWithVirtualTreatment?: InputMaybe<
    Scalars['Boolean']['input']
  >
  contacts?: InputMaybe<Array<ContactInput>>
  dischargeDate?: InputMaybe<Scalars['AWSDate']['input']>
  dischargeType?: InputMaybe<Scalars['String']['input']>
  dob?: InputMaybe<Scalars['AWSDate']['input']>
  documents?: InputMaybe<Array<CreateDocumentInput>>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  gender?: InputMaybe<PatientGenderIdentity>
  genderDetails?: InputMaybe<Scalars['String']['input']>
  hospitalized?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  legalSex?: InputMaybe<PatientLegalSex>
  meta?: InputMaybe<Scalars['AWSJSON']['input']>
  patientTimeZone?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  preferredContactDaysOfWeek?: InputMaybe<Array<DayOfWeek>>
  preferredContactTimes?: InputMaybe<Array<Scalars['String']['input']>>
  preferredLanguage?: InputMaybe<Scalars['String']['input']>
  preferredName?: InputMaybe<Scalars['String']['input']>
  pronouns?: InputMaybe<Scalars['String']['input']>
  referralSource?: InputMaybe<Scalars['String']['input']>
  referralSourceOther?: InputMaybe<Scalars['String']['input']>
  referrer?: InputMaybe<ReferrerInformationInput>
  serviceType?: InputMaybe<Array<Scalars['String']['input']>>
  specialty?: InputMaybe<Array<Scalars['String']['input']>>
  submissionId: Scalars['ID']['input']
  tellUsMore?: InputMaybe<Scalars['String']['input']>
  treatmentHistory?: InputMaybe<Scalars['String']['input']>
}

export type UpdateListItemInput = {
  description?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  label?: InputMaybe<Scalars['String']['input']>
  sortOrder?: InputMaybe<Scalars['Int']['input']>
}

export type UpdatePatientBillingInput = {
  data: UpdateBillingInput
  id?: InputMaybe<Scalars['ID']['input']>
  treatmentId?: InputMaybe<Scalars['ID']['input']>
}

export type UpdatePatientBillingInsuredInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  insurances: Array<InputMaybe<UpdateBillingInsuredInput>>
  treatmentId?: InputMaybe<Scalars['ID']['input']>
}

export type UpdatePatientCareInput = {
  careTeam?: InputMaybe<UpdateCareTeamInput>
  device?: InputMaybe<DeviceInput>
  disableChat?: InputMaybe<Scalars['Boolean']['input']>
  hospitalized?: InputMaybe<Scalars['Boolean']['input']>
  questionnaires?: InputMaybe<Array<QuestionnaireInput>>
  referralSource?: InputMaybe<Scalars['String']['input']>
  scaleId?: InputMaybe<Scalars['String']['input']>
}

export type UpdatePatientConfigurationInput = {
  forceMultiPhone?: InputMaybe<Scalars['Boolean']['input']>
  modifyUsername?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpdatePatientDemographicsInput = {
  addressComponents?: InputMaybe<AddressComponentsInput>
  contacts?: InputMaybe<Array<ContactInput>>
  dateOfBirth?: InputMaybe<Scalars['AWSDate']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  gender?: InputMaybe<PatientLegalSex>
  genderDetails?: InputMaybe<Scalars['String']['input']>
  genderIdentity?: InputMaybe<PatientGenderIdentity>
  hospitalized?: InputMaybe<Scalars['String']['input']>
  languages?: InputMaybe<Array<Scalars['String']['input']>>
  lastName?: InputMaybe<Scalars['String']['input']>
  middleName?: InputMaybe<Scalars['String']['input']>
  mrn?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  picture?: InputMaybe<Scalars['String']['input']>
  preferredLanguage?: InputMaybe<Scalars['String']['input']>
  preferredName?: InputMaybe<Scalars['String']['input']>
  primaryEmail?: InputMaybe<Scalars['String']['input']>
  primaryPhone?: InputMaybe<Scalars['String']['input']>
  pronouns?: InputMaybe<Scalars['String']['input']>
  referralSource?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<PatientStatus>
  tags?: InputMaybe<Array<Scalars['String']['input']>>
  timezone?: InputMaybe<Scalars['String']['input']>
  username?: InputMaybe<Scalars['String']['input']>
}

export type UpdatePatientInput = {
  care?: InputMaybe<UpdatePatientCareInput>
  configuration?: InputMaybe<UpdatePatientConfigurationInput>
  demographics?: InputMaybe<UpdatePatientDemographicsInput>
  patientId: Scalars['String']['input']
}

export type UpdatePatientRegistrationSubmission = {
  additionalTaskDescription?: InputMaybe<Scalars['AWSJSON']['input']>
  address?: InputMaybe<AddressComponentsInput>
  appointmentId?: InputMaybe<Scalars['ID']['input']>
  billing?: InputMaybe<UpdateBillingInput>
  conditionInterferingWithVirtualTreatment?: InputMaybe<
    Scalars['Boolean']['input']
  >
  contacts?: InputMaybe<Array<ContactInput>>
  dischargeDate?: InputMaybe<Scalars['AWSDate']['input']>
  dischargeType?: InputMaybe<Scalars['String']['input']>
  dob?: InputMaybe<Scalars['AWSDate']['input']>
  documents?: InputMaybe<Array<CreateDocumentInput>>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  gender?: InputMaybe<PatientGenderIdentity>
  genderDetails?: InputMaybe<Scalars['String']['input']>
  hospitalized?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  legalSex?: InputMaybe<PatientLegalSex>
  meta?: InputMaybe<Scalars['AWSJSON']['input']>
  patientTimeZone?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  preferredContactDaysOfWeek?: InputMaybe<Array<DayOfWeek>>
  preferredContactTimes?: InputMaybe<Array<Scalars['String']['input']>>
  preferredLanguage?: InputMaybe<Scalars['String']['input']>
  preferredName?: InputMaybe<Scalars['String']['input']>
  referralSource?: InputMaybe<Scalars['String']['input']>
  referralSourceOther?: InputMaybe<Scalars['String']['input']>
  referrer?: InputMaybe<ReferrerInformation>
  serviceType?: InputMaybe<Array<Scalars['String']['input']>>
  specialty?: InputMaybe<Array<Scalars['String']['input']>>
  submissionId: Scalars['String']['input']
  taskAssigneeOverride?: InputMaybe<Scalars['String']['input']>
  taskDueDateOverride?: InputMaybe<Scalars['AWSDate']['input']>
  taskPatientPreferencesOverride?: InputMaybe<Scalars['AWSJSON']['input']>
  taskTypeOverride?: InputMaybe<PatientOnboardingTaskType>
  tellUsMore?: InputMaybe<Scalars['String']['input']>
  treatmentHistory?: InputMaybe<Scalars['String']['input']>
}

export type UpdatePayerEnrollmentInput = {
  comment?: InputMaybe<AttachmentAnnotationInput>
  effectiveDate?: InputMaybe<Scalars['AWSDate']['input']>
  entity?: InputMaybe<Scalars['String']['input']>
  expirationDate?: InputMaybe<Scalars['AWSDate']['input']>
  id: Scalars['ID']['input']
  payerExternalProviderId?: InputMaybe<Scalars['String']['input']>
  payerId?: InputMaybe<Scalars['ID']['input']>
  recredentialingDate?: InputMaybe<Scalars['AWSDate']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  submissionDate?: InputMaybe<Scalars['AWSDate']['input']>
  terminationDate?: InputMaybe<Scalars['AWSDate']['input']>
  vendor?: InputMaybe<Scalars['String']['input']>
}

export type UpdateProviderDocumentInput = {
  documentCategory?: InputMaybe<DocumentCategory>
  file?: InputMaybe<FileUpdate>
  id: Scalars['ID']['input']
  stateCode?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<DocumentVerificationStatus>
}

export type UpdateReoccuranceTemplateResponse = {
  reoccuranceTemplate: ReoccuranceTemplate
  warnings: Array<AppointmentWarning>
}

export type UpdateTaskInputV2 = {
  assignee?: InputMaybe<Scalars['ID']['input']>
  comment?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  dueDate?: InputMaybe<Scalars['AWSDate']['input']>
  id: Scalars['ID']['input']
  patientPreferences?: InputMaybe<Scalars['AWSJSON']['input']>
  referralSource?: InputMaybe<Scalars['String']['input']>
  serviceType?: InputMaybe<TaskServiceType>
  status?: InputMaybe<TaskStatus>
  type?: InputMaybe<TaskType>
}

export type UpsertInsurancePlanParticipantInput = {
  _id?: InputMaybe<Scalars['ID']['input']>
  billingRelationship: InsurancePlanBillingRelationshipInput
  comment?: InputMaybe<AttachmentAnnotationInput>
  effectiveDate?: InputMaybe<Scalars['AWSDate']['input']>
  insurancePlanId: Scalars['ID']['input']
  providerId: Scalars['ID']['input']
  status?: InputMaybe<InsurancePlanParticipantStatus>
  terminationDate?: InputMaybe<Scalars['AWSDate']['input']>
}

export type User = {
  careManager: CareManagerUser
  cognito?: Maybe<Cognito>
  permitRoles?: Maybe<Array<Scalars['ID']['output']>>
}

export type UserSignUpInput = {
  careManagerPermissions?: InputMaybe<CareManagerPermissionsInput>
  email: Scalars['String']['input']
  emrId?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  isProvider?: InputMaybe<Scalars['Boolean']['input']>
  lastName: Scalars['String']['input']
  permitRoles: Array<Scalars['ID']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  preferredName?: InputMaybe<Scalars['String']['input']>
  pronouns?: InputMaybe<Scalars['String']['input']>
}

export type UserSummary = {
  careManagerId?: Maybe<Scalars['String']['output']>
  cognitoUserId?: Maybe<Scalars['String']['output']>
  display: UserSummaryDisplayNames
  email?: Maybe<Scalars['String']['output']>
  emrId?: Maybe<Scalars['String']['output']>
  identifiers?: Maybe<UserSummaryIdentifiers>
  isEnabled?: Maybe<Scalars['Boolean']['output']>
  picture?: Maybe<Scalars['String']['output']>
  providerId?: Maybe<Scalars['String']['output']>
  publicRole?: Maybe<Scalars['String']['output']>
  userId?: Maybe<Scalars['String']['output']>
}

export type UserSummaryDisplayNames = {
  expandedName?: Maybe<Scalars['String']['output']>
  fullName?: Maybe<Scalars['String']['output']>
  legalName?: Maybe<Scalars['String']['output']>
  legalQualifiedName?: Maybe<Scalars['String']['output']>
  publicName?: Maybe<Scalars['String']['output']>
  qualifiedName?: Maybe<Scalars['String']['output']>
}

export type UserSummaryIdentifiers = {
  type: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type UserUpdateInput = {
  careManagerPermissions?: InputMaybe<CareManagerPermissionsInput>
  email?: InputMaybe<Scalars['String']['input']>
  emrId?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  isProvider?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  permitRoles?: InputMaybe<Array<Scalars['ID']['input']>>
  phone?: InputMaybe<Scalars['String']['input']>
  preferredName?: InputMaybe<Scalars['String']['input']>
  pronouns?: InputMaybe<Scalars['String']['input']>
}

export type ValidateCaptchaAndMatchInput = {
  captchaToken: Scalars['String']['input']
  dateOfBirth: Scalars['AWSDate']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  phoneNumber: Scalars['String']['input']
  publicCode?: InputMaybe<Scalars['String']['input']>
}

export type ValidateCaptchaInput = {
  captchaToken: Scalars['String']['input']
  dateOfBirth: Scalars['AWSDate']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  phoneNumber: Scalars['String']['input']
  publicCode?: InputMaybe<Scalars['String']['input']>
}

export type ValidateOtpInput = {
  dateOfBirth: Scalars['AWSDate']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  otpToken: Scalars['String']['input']
  phoneNumber: Scalars['String']['input']
  publicCode?: InputMaybe<Scalars['String']['input']>
}

export enum VerificationVendor {
  PVerify = 'pVerify',
}

export type VerifyEligibilityExternalInput = {
  billingInsuranceType?: InputMaybe<Scalars['String']['input']>
  insurancePlanId?: InputMaybe<Scalars['String']['input']>
  insured: EligibilityInsuredInputV2
  location?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<EligibilityPatientInputV2>
}

export type VerifyEligibilityFlags = {
  generateEligibilityPdfAsync?: InputMaybe<Scalars['Boolean']['input']>
  populateInsurance?: InputMaybe<Scalars['Boolean']['input']>
  syncToEmr?: InputMaybe<Scalars['Boolean']['input']>
}

export type VerifyEligibilityFromEmrInput = {
  dateOfServiceEnd?: InputMaybe<Scalars['String']['input']>
  dateOfServiceStart: Scalars['String']['input']
  forceBillingSync?: InputMaybe<Scalars['Boolean']['input']>
  nextGenId?: InputMaybe<Scalars['String']['input']>
  ordinality?: InputMaybe<Scalars['String']['input']>
  saveToEmr?: InputMaybe<Scalars['Boolean']['input']>
  saveToValera?: InputMaybe<Scalars['Boolean']['input']>
  treatmentId: Scalars['ID']['input']
}

export type VerifyEligibilityInput = {
  billingInsuranceId: Scalars['String']['input']
  insured: EligibilityInsuredInput
  location?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<EligibilityPatientInput>
  payerId: Scalars['String']['input']
  providerName: Scalars['String']['input']
  providerNpi: Scalars['String']['input']
  treatmentId: Scalars['String']['input']
}

export type VerifyEligibilityInputV2 = {
  billingInsuranceId?: InputMaybe<Scalars['String']['input']>
  billingInsuranceType?: InputMaybe<Scalars['String']['input']>
  flags?: InputMaybe<VerifyEligibilityFlags>
  insurancePlanId?: InputMaybe<Scalars['String']['input']>
  insured: EligibilityInsuredInputV2
  location?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<EligibilityPatientInputV2>
  payerId?: InputMaybe<Scalars['String']['input']>
  providerName?: InputMaybe<Scalars['String']['input']>
  providerNpi?: InputMaybe<Scalars['String']['input']>
  treatmentId: Scalars['String']['input']
}

export type VirtualService = {
  addressUrl?: Maybe<Scalars['String']['output']>
  channelType: SessionType
  phoneNumber?: Maybe<Scalars['String']['output']>
  sessionKey?: Maybe<Scalars['String']['output']>
}

export type VirtualServiceInput = {
  addressUrl?: InputMaybe<Scalars['String']['input']>
  channelType: Scalars['String']['input']
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  sessionKey?: InputMaybe<Scalars['String']['input']>
}

export enum WeekOfMonth {
  First = 'FIRST',
  Fourth = 'FOURTH',
  Last = 'LAST',
  Second = 'SECOND',
  Third = 'THIRD',
}

export type WeeklyTemplate = PatternTemplate & {
  dayTimes: Array<DayTime>
  interval: Scalars['Int']['output']
  offset: Scalars['Int']['output']
}

export type WeeklyTemplateInput = {
  dayTimes: Array<DayTimeInput>
  interval: Scalars['Int']['input']
  offset: Scalars['Int']['input']
}

export type FulfilledAppointmentStatistics = {
  endDate: Scalars['AWSDateTime']['output']
  minutesDuration: Scalars['Float']['output']
  startDate: Scalars['AWSDateTime']['output']
}

export type FulfilledAppointmentStatisticsInput = {
  endDate: Scalars['AWSDateTime']['input']
  minutesDuration: Scalars['Float']['input']
  startDate: Scalars['AWSDateTime']['input']
}

export type OutOfNetworkPlan = {
  name?: Maybe<Scalars['String']['output']>
  state?: Maybe<State>
}

export type AvailabilityResponseFragment = {
  providerIsAvailable: boolean
  patientIsAvailable?: boolean | null
}

export type PushSyncVariables = Exact<{
  appointmentIds: Array<Scalars['String']['input']>
}>

export type PushSync = {
  pushSync?: {
    results?: Array<{
      appointmentId?: string | null
      status?: SyncStatus | null
    }> | null
  } | null
}

export type PullSyncVariables = Exact<{
  providerId: Scalars['String']['input']
  startDate: Scalars['AWSDateTime']['input']
  endDate: Scalars['AWSDateTime']['input']
}>

export type PullSync = {
  pullSync?: {
    results?: Array<{
      appointmentId?: string | null
      status?: SyncStatus | null
    }> | null
  } | null
}

export type CheckEmrAvailabilityVariables = Exact<{
  content?: InputMaybe<AvailabilityRequest>
}>

export type CheckEmrAvailability = {
  checkEmrAvailability?: AvailabilityResponseFragment | null
}

export type GetSyncHistoryVariables = Exact<{
  providerId: Scalars['String']['input']
}>

export type GetSyncHistory = {
  getSyncHistory?: Array<{
    id: string
    applicationName: string
    direction: string
    dateTime: string
    providerId?: string | null
    appointmentId?: string | null
    programId?: string | null
    action?: string | null
    appointmentDate?: string | null
    status?: string | null
    message?: string | null
    nextgen?: {
      appointmentId?: string | null
      providerId?: string | null
      resourceId?: string | null
      personId?: string | null
    } | null
  }> | null
}

export type AuditRecordCallerFragment = {
  cognitoId?: string | null
  treatmentId?: string | null
}

export type AuditRecordFragment = {
  requestTimestamp: string
  apiName: string
  endpoint: string
  endpointMethod: string
  responseStatus?: string | null
  caller: AuditRecordCallerFragment
}

export type SearchWriteEventsVariables = Exact<{
  query: Scalars['AWSJSON']['input']
  sort?: InputMaybe<Scalars['AWSJSON']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Scalars['Int']['input']>
  searchAfter?: InputMaybe<Scalars['AWSJSON']['input']>
  aggregations?: InputMaybe<Scalars['AWSJSON']['input']>
}>

export type SearchWriteEvents = {
  searchWriteEvents: {
    resultCount: number
    from?: number | null
    searchAfter?: string | null
    aggregations?: string | null
    audits: Array<AuditRecordFragment>
  }
}

export type SearchCreatedLastModifiedVariables = Exact<{
  queryCreated: Scalars['AWSJSON']['input']
  queryModified: Scalars['AWSJSON']['input']
  sort: Scalars['AWSJSON']['input']
  modifiedPageSize?: InputMaybe<Scalars['Int']['input']>
}>

export type SearchCreatedLastModified = {
  createdEvents: { audits: Array<AuditRecordFragment> }
  updatedEvents: { audits: Array<AuditRecordFragment> }
}

export type TimeSlotExternalFrag = {
  id: string
  scheduleId: string
  startDate: string
  endDate: string
  startTime: string
  endTime: string
  dayOfWeek: DayOfWeek
  durationMinutes: number
  serviceCategoryCode: string
  locations?: Array<string> | null
  provider: {
    id: string
    name: string
    serviceType?: Array<ProviderServiceType> | null
    availabilityStatus: Availability
    availabilityNotes?: string | null
    insurancePlans?: Array<string> | null
    careCoordinatorId?: string | null
    supervisorId?: string | null
    genderIdentity?: GenderIdentity | null
    race?: Array<Race> | null
    ethnicity?: Ethnicity | null
    languages?: Array<string> | null
    spirituality?: Array<string> | null
    communityIdentity?: Array<CommunityIdentity> | null
    clinicalAges?: Array<string> | null
    clinicalModalities?: Array<string> | null
    clinicalSpecialties?: Array<string> | null
    bio?: string | null
    legalSex?: LegalSex | null
    profession: ProfessionCode
    licenses?: Array<{ licenseType: LicenseType; stateCode: string }> | null
  }
}

export type TimeSlotSearchExternalResFrag = {
  resultCount: number
  from?: number | null
  searchAfter?: string | null
  aggregations?: string | null
  results: Array<TimeSlotExternalFrag>
}

export type TimeSlotSearchExternalVariables = Exact<{
  query: Scalars['AWSJSON']['input']
  aggregations?: InputMaybe<Scalars['AWSJSON']['input']>
  sort?: InputMaybe<Scalars['AWSJSON']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Scalars['Int']['input']>
  searchAfter?: InputMaybe<Scalars['AWSJSON']['input']>
}>

export type TimeSlotSearchExternal = {
  timeSlotSearch: TimeSlotSearchExternalResFrag
}

export type TimeslotProviderIdentifierFragment = {
  id: string
  type: ProviderIdentifierType
  value: string
}

export type TimeSlotProviderFrag = {
  id: string
  name: string
  serviceType?: Array<ProviderServiceType> | null
  availabilityStatus: Availability
  availabilityNotes?: string | null
  insurancePlans?: Array<string> | null
  careCoordinatorId?: string | null
  supervisorId?: string | null
  genderIdentity?: GenderIdentity | null
  race?: Array<Race> | null
  ethnicity?: Ethnicity | null
  languages?: Array<string> | null
  spirituality?: Array<string> | null
  communityIdentity?: Array<CommunityIdentity> | null
  clinicalAges?: Array<string> | null
  clinicalModalities?: Array<string> | null
  clinicalSpecialties?: Array<string> | null
  bio?: string | null
  legalSex?: LegalSex | null
  profession: ProfessionCode
  licenses?: Array<{ licenseType: LicenseType; stateCode: string }> | null
  identifiers?: Array<TimeslotProviderIdentifierFragment> | null
  tags?: Array<{ value: string }> | null
}

export type TimeSlotFrag = {
  id: string
  scheduleId: string
  startDate: string
  endDate: string
  startTime: string
  endTime: string
  dayOfWeek: DayOfWeek
  durationMinutes: number
  serviceCategoryCode: string
  locations?: Array<string> | null
  provider: TimeSlotProviderFrag
}

export type TimeSlotSearchResFrag = {
  resultCount: number
  from?: number | null
  searchAfter?: string | null
  aggregations?: string | null
  results: Array<TimeSlotFrag>
}

export type TimeSlotSearchVariables = Exact<{
  query: Scalars['AWSJSON']['input']
  aggregations?: InputMaybe<Scalars['AWSJSON']['input']>
  sort?: InputMaybe<Scalars['AWSJSON']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Scalars['Int']['input']>
  searchAfter?: InputMaybe<Scalars['AWSJSON']['input']>
}>

export type TimeSlotSearch = { timeSlotSearch: TimeSlotSearchResFrag }

export type ProgramSettingsExternalFrag = {
  patientSettings?: {
    overlappingInsurancePlans?: Array<{
      id: string
      description?: string | null
      planIds: Array<string>
      favoredPlanId?: string | null
    }> | null
  } | null
}

export type GetProgramSettingsExternalVariables = Exact<{
  [key: string]: never
}>

export type GetProgramSettingsExternal = {
  getProgramSettingsExternal: ProgramSettingsExternalFrag
}

export type StandardListItemFrag = {
  id: string
  value: string
  label: string
  description?: string | null
}

export type ListResponseFrag = {
  key: string
  list?: Array<StandardListItemFrag> | null
}

export type ProgramSettingsFrag = {
  lists?: { goalReminderTemplates?: Array<StandardListItemFrag> | null } | null
  flags?: {
    isWellness: boolean
    clinicalNotesActive?: boolean | null
    oooCoveringProviderActive?: boolean | null
  } | null
  appointmentSettings?: {
    flags?: { useSchedulingAppt?: boolean | null } | null
  } | null
  layout?: {
    hideStartSessionButton?: boolean | null
    careManagerMainNav?: Array<{ id: string; hidden: boolean }> | null
    careManagerPatientNav?: Array<{ id: string; hidden: boolean }> | null
    practiceManagerMainNav?: Array<{ id: string; hidden: boolean }> | null
  } | null
  providerSettings?: {
    specialties?: Array<StandardListItemFrag> | null
    languages?: Array<StandardListItemFrag> | null
    modalities?: Array<StandardListItemFrag> | null
    spirituality?: Array<StandardListItemFrag> | null
    tags?: Array<StandardListItemFrag> | null
    chat?: {
      disablePatientChatToggleActive?: boolean | null
      patientChatDisabledByDefault?: boolean | null
      unreadChatActive?: boolean | null
      unreadEvents?: Array<string> | null
      highlightedWords?: Array<string> | null
    } | null
    flags?: { sessionTimeout?: number | null } | null
  } | null
}

export type AppendListItemsVariables = Exact<{
  key: Scalars['String']['input']
  input: Array<AppendListItemInput>
}>

export type AppendListItems = { appendListItems: Array<StandardListItemFrag> }

export type UpdateListItemsVariables = Exact<{
  key: Scalars['String']['input']
  input: Array<UpdateListItemInput>
}>

export type UpdateListItems = { updateListItems: Array<StandardListItemFrag> }

export type DeleteListItemsVariables = Exact<{
  key: Scalars['String']['input']
  input: Array<Scalars['ID']['input']>
}>

export type DeleteListItems = { deleteListItems: Array<StandardListItemFrag> }

export type GetListVariables = Exact<{
  keys: Array<Scalars['String']['input']>
  forceInvalidate?: InputMaybe<Scalars['Boolean']['input']>
}>

export type GetList = { getList: Array<ListResponseFrag> }

export type GetProgramSettingsVariables = Exact<{
  forceInvalidate?: InputMaybe<Scalars['Boolean']['input']>
}>

export type GetProgramSettings = { getProgramSettings: ProgramSettingsFrag }

export type CreateFormSubmissionVariables = Exact<{
  input: CreateFormSubmissionInput
}>

export type CreateFormSubmission = {
  createFormSubmission: {
    submissionId: string
    success: boolean
    message?: string | null
    metaData?: {
      pendingVerificationOrdinalities?: Array<InsuranceOrdinality> | null
    } | null
  }
}

export type UpdateFormSubmissionVariables = Exact<{
  input: UpdateFormSubmissionInput
}>

export type UpdateFormSubmission = {
  updateFormSubmission: {
    submissionId: string
    success: boolean
    message?: string | null
    metaData?: {
      pendingVerificationOrdinalities?: Array<InsuranceOrdinality> | null
    } | null
  }
}

export type CompleteFormSubmissionVariables = Exact<{
  input: CompleteFormSubmissionInput
}>

export type CompleteFormSubmission = {
  completeFormSubmission: {
    submissionId: string
    success: boolean
    message?: string | null
  }
}

export type CreateConsentPacketExternalVariables = Exact<{
  content: CreateConsentPacketExternalInput
}>

export type CreateConsentPacketExternal = {
  createConsentPacketExternal: {
    success: boolean
    code?: string | null
    message?: string | null
  }
}

export type GetSigningUrlExternalVariables = Exact<{
  input: GetSigningUrlExternalInput
}>

export type GetSigningUrlExternal = {
  getSigningUrlExternal: {
    code?: ConsentPacketSigningUrlStatus | null
    message?: string | null
    signingUrl?: string | null
    shouldEmbed?: boolean | null
  }
}

export type AuditEntryFragment = {
  date: string
  reference: { id?: string | null; type: ResourceType; display?: string | null }
}

export type FileFragment = { mimeType: string; name: string; url: string }

export type EmploymentFragment = {
  _id: string
  type?: EmploymentType | null
  status?: EmploymentStatus | null
  title?: string | null
  role?: EmploymentRole | null
  hireDate?: string | null
  startDate?: string | null
  terminationDate?: string | null
  profession?: ProfessionCode | null
  legalSex?: LegalSex | null
  stateOfResidence?: string | null
  onboardingCompleteDate?: string | null
}

export type ProviderIdentifierFragment = {
  id: string
  type: ProviderIdentifierType
  value: string
  createdDate?: string | null
  lastModified?: string | null
}

export type PractMgrReferenceFragment = {
  id?: string | null
  display?: string | null
}

export type ExpectedHoursFragment = {
  weeklyMinutesTotal: number
  startDate?: string | null
  endDate?: string | null
  serviceCategory: { code: ServiceCategoryCode }
}

export type PayerSummaryFrag = {
  id: string
  name: string
  stateCode: string
  status: PayerStatus
}

export type MatchedTokenResponseFragment = {
  access_token: string
  id_token: string
  token_type: TokenType
  expires_in: number
}

export type ExternalResponseFragment = {
  success: boolean
  message?: string | null
}

export type ValidateCaptchaAndMatchVariables = Exact<{
  input: ValidateCaptchaAndMatchInput
}>

export type ValidateCaptchaAndMatch = {
  validateCaptchaAndMatch?: MatchedTokenResponseFragment | null
}

export type SendOtpVariables = Exact<{
  input: SendOtpInput
}>

export type SendOtp = { sendOTP?: ExternalResponseFragment | null }

export type ConfirmOtpAndMatchVariables = Exact<{
  input: ConfirmOtpAndMatchInput
}>

export type ConfirmOtpAndMatch = {
  confirmOTPAndMatch?: MatchedTokenResponseFragment | null
}

export type EmrSyncStatisticsResponseFragment = {
  emrSyncStatus: EmrSyncStatusCode
  message?: string | null
  lastSynced?: { date: string } | null
}

export type SyncToEmrVariables = Exact<{
  input: SyncToEmrInput
}>

export type SyncToEmr = { syncToEmr: EmrSyncStatisticsResponseFragment }

export type SyncInsuranceToEmrVariables = Exact<{
  input: SyncInsuranceToEmrInput
}>

export type SyncInsuranceToEmr = {
  syncInsuranceToEmr: EmrSyncStatisticsResponseFragment
}

export type TokenResponse = { access_token: string; expires_in: number }

export type EligibilityVerificationFragment = {
  ts?: string | null
  isActive?: boolean | null
  insurancePlanId?: string | null
}

export type BillingInsuredExternalFragment = {
  id?: string | null
  type?: InsuranceOrdinality | null
  eligibilityVerified?: boolean | null
  insurancePlanId?: string | null
  outOfNetwork?: boolean | null
  idNumber?: string | null
  coPay?: string | null
  deductible?: number | null
  familyDeductible?: number | null
  coinsurance?: number | null
  eligibilityVerification?: EligibilityVerificationFragment | null
  outOfNetworkPlan?: {
    name?: string | null
    state?: { code?: string | null; name?: string | null } | null
  } | null
}

export type BillingExternalFragment = {
  id: string
  treatmentId: string
  patientId: string
  insurances?: Array<BillingInsuredExternalFragment> | null
}

export type DisplayMessageFragment = {
  en?: string | null
  es?: string | null
  zh_chs?: string | null
  zh_tw?: string | null
}

export type PracticeServiceBoundaryDisplayFragment = {
  isDisplayed: boolean
  displayMessage?: DisplayMessageFragment | null
}

export type PracticeServiceBoundaryFragment = {
  tier: number
  availabilityStatus: PracticeServiceAvailabilityStatus
  states?: Array<string> | null
  formTypes?: Array<string> | null
  appointmentTypeCode?: ServiceTypeCode | null
  insurancePlans?: Array<string> | null
  clinicalAges?: Array<string> | null
  disableScheduling?: boolean | null
  display?: PracticeServiceBoundaryDisplayFragment | null
  disableSchedulingDisplay?: DisplayMessageFragment | null
}

export type PracticeServiceFragment = {
  id: string
  name: string
  serviceTypeCode: TaskServiceType
  sort: number
  createdDate?: string | null
  modifiedDate?: string | null
  appointmentTypeCode?: ServiceTypeCode | null
  displayName: DisplayMessageFragment
  description?: DisplayMessageFragment | null
  outOfBounds: PracticeServiceBoundaryDisplayFragment
  boundaries: Array<PracticeServiceBoundaryFragment>
}

export type ExternalLocationFragment = {
  id: string
  address: { state: string }
  physicalType: { code?: string | null }
}

export type SavePatientBillingExternalVariables = Exact<{
  input: SavePatientBillingExternalInput
}>

export type SavePatientBillingExternal = {
  savePatientBillingExternal: { success: boolean }
}

export type CreatePatientSubmissionVariables = Exact<{
  input: CreatePatientRegistrationSubmission
}>

export type CreatePatientSubmission = {
  createPatientRegistrationSubmission: {
    submissionId: string
    success: boolean
    message?: string | null
    metaData?: {
      pendingVerificationOrdinalities?: Array<InsuranceOrdinality> | null
    } | null
  }
}

export type UpdatePatientSubmissionVariables = Exact<{
  input: UpdatePatientRegistrationSubmission
}>

export type UpdatePatientSubmission = {
  updatePatientRegistrationSubmission: {
    submissionId: string
    success: boolean
    message?: string | null
    metaData?: {
      pendingVerificationOrdinalities?: Array<InsuranceOrdinality> | null
    } | null
  }
}

export type CompletePatientSubmissionVariables = Exact<{
  input: CompletePatientRegistrationSubmission
}>

export type CompletePatientSubmission = {
  completePatientRegistrationSubmission: {
    submissionId: string
    success: boolean
    message?: string | null
  }
}

export type GetExternalLanguagesVariables = Exact<{ [key: string]: never }>

export type GetExternalLanguages = {
  getExternalLanguages: Array<{ code?: string | null; display: string }>
}

export type GetExternalInsurancePlansVariables = Exact<{ [key: string]: never }>

export type GetExternalInsurancePlans = {
  getExternalInsurancePlans: Array<{
    _id: string
    name: string
    stateCode?: string | null
    payerId?: string | null
    payerName?: string | null
    verificationPayerId?: string | null
    verificationPayerName?: string | null
    companyName?: string | null
    tocConfiguration?: Array<{
      referralSourceFilter?: string | null
      fuh7: boolean
      fuh30: boolean
      fum7: boolean
      fum30: boolean
    }> | null
  }>
}

export type GetExternalPracticeStatesVariables = Exact<{
  programCode?: InputMaybe<Scalars['String']['input']>
}>

export type GetExternalPracticeStates = {
  getExternalPracticeStates: Array<{
    stateCode: string
    availabilityStatus: PracticeStateAvailabilityStatus
  }>
}

export type LoadPatientBillingExternalVariables = Exact<{
  [key: string]: never
}>

export type LoadPatientBillingExternal = {
  loadPatientBillingExternal?: BillingExternalFragment | null
}

export type GetExternalPracticeServicesVariables = Exact<{
  input: GetExternalPracticeServicesInput
}>

export type GetExternalPracticeServices = {
  getExternalPracticeServices: Array<PracticeServiceFragment>
}

export type GetExternalLocationsVariables = Exact<{
  programCode?: InputMaybe<Scalars['String']['input']>
}>

export type GetExternalLocations = {
  getExternalLocations: Array<ExternalLocationFragment>
}

export type CheckEligibilityFragment = {
  id: string
  isActive?: boolean | null
  benefitSummaryPdfFile?: string | null
  generatingBenefitSummaryPdfFile?: boolean | null
  billingInsuranceId?: string | null
  ts?: string | null
  insurancePlanId?: string | null
  requestId?: number | null
  actionLog: Array<ActionEntryFragment>
}

export type ConsentPacketInfoFragment = {
  signedDate?: string | null
  agreementId?: string | null
  sent?: AuditEntryFragment | null
}

export type BillingFullFragment = {
  id: string
  treatmentId: string
  patientId: string
  idRelationship?: PatientRelationshipToIdCard | null
  idType?: IdentificationType | null
  idValue?: string | null
  fullConsentPackedSigned?: boolean | null
  creditCardOnFile?: boolean | null
  selfPay?: boolean | null
  hasBillableAppointment?: boolean | null
  idFile?: FileFragment | null
  consentPacketInfo?: ConsentPacketInfoFragment | null
  insurances?: Array<BillingInsuredFragment> | null
  emrSyncStatistics?: {
    emrSyncStatus: EmrSyncStatusCode
    lastSynced?: AuditEntryFragment | null
  } | null
  comments?: Array<{
    time: string
    text: string
    authorReference: { id?: string | null; display?: string | null }
  }> | null
}

export type BillingInsuredFragment = {
  id?: string | null
  type?: InsuranceOrdinality | null
  eligibilityVerified?: boolean | null
  eligibilityReason?: string | null
  relationship?: PatientRelationshipToInsured | null
  firstName?: string | null
  lastName?: string | null
  middleInitial?: string | null
  dateOfBirth?: string | null
  legalSex?: PatientLegalSex | null
  phone?: string | null
  insurancePlanId?: string | null
  outOfNetwork?: boolean | null
  note?: string | null
  idNumber?: string | null
  policyGroupFecaNumber?: string | null
  policyGroupName?: string | null
  effectiveDate?: string | null
  expirationDate?: string | null
  coPay?: string | null
  medicaidIdNumber?: string | null
  medicareIdNumber?: string | null
  emrSyncStatus?: EmrSyncStatusCode | null
  priorAuthRequired?: PriorAuthStatus | null
  payerPlanName?: string | null
  payerPlanType?: string | null
  deductible?: number | null
  familyDeductible?: number | null
  coinsurance?: number | null
  otherPayerInfo?: string | null
  referralRequired?: boolean | null
  addressComponents?: {
    street?: string | null
    city?: string | null
    state?: string | null
    zipcode?: string | null
  } | null
  outOfNetworkPlan?: {
    name?: string | null
    state?: { code?: string | null; name?: string | null } | null
  } | null
  cardFront?: FileFragment | null
  cardBack?: FileFragment | null
  medicaidCard?: FileFragment | null
  medicareCard?: FileFragment | null
}

export type DocumentFragment = {
  id: string
  file: FileFragment
  created: AuditEntryFragment
  modified?: AuditEntryFragment | null
}

export type ContactFragment = {
  id?: string | null
  firstName?: string | null
  lastName?: string | null
  relation?: string | null
  phone?: string | null
  email?: string | null
  use?: string | null
  primary?: boolean | null
}

export type PatientIntegrationFragment = {
  emrId?: string | null
  lumaId?: string | null
  nextgenId?: string | null
  medplumId?: string | null
  mmrId?: string | null
  isActive: boolean
}

export type PatientDemographicsFragment = {
  patientId?: string | null
  firstName?: string | null
  middleName?: string | null
  lastName?: string | null
  username?: string | null
  preferredName?: string | null
  pronouns?: string | null
  mrn?: string | null
  gender?: PatientLegalSex | null
  genderIdentity?: PatientGenderIdentity | null
  genderDetails?: string | null
  phone?: string | null
  primaryPhone?: string | null
  email?: string | null
  primaryEmail?: string | null
  status?: PatientStatus | null
  dateOfBirth?: string | null
  timezone?: string | null
  picture?: string | null
  languages?: Array<string> | null
  preferredLanguage?: string | null
  registrationSource?: string | null
  videoLink?: string | null
  addressComponents?: {
    street?: string | null
    city?: string | null
    state?: string | null
    zipcode?: string | null
  } | null
  contacts?: Array<ContactFragment> | null
}

export type CareTeamMemberFragment = {
  id: string
  role?: string | null
  isEnabled?: boolean | null
  displayName?: string | null
  isPctm?: boolean | null
}

export type PatientCareFragment = {
  scaleId?: string | null
  referralSource?: string | null
  hospitalized?: boolean | null
  disableChat?: boolean | null
  diagnosis?: Array<string | null> | null
  device?: { type?: string | null; useMobileApp?: boolean | null } | null
  careTeam?: Array<CareTeamMemberFragment | null> | null
  medicalDiagnosis?: Array<{
    code?: string | null
    name?: string | null
  } | null> | null
  questionnaires?: Array<{
    name?: string | null
    score?: number | null
  } | null> | null
}

export type PatientFragment = {
  integration?: PatientIntegrationFragment | null
  demographics?: PatientDemographicsFragment | null
  care?: PatientCareFragment | null
}

export type ActionEntryFragment = {
  code: ActionEntryCode
  description: string
  author: AuditEntryFragment
}

export type PatientResponseFragment = { patientId: string; treatmentId: string }

export type SavePatientBillingVariables = Exact<{
  input: UpdatePatientBillingInput
}>

export type SavePatientBilling = {
  savePatientBilling?: BillingFullFragment | null
}

export type GeneratePatientLinkVariables = Exact<{
  input: GeneratePatientLinkInput
}>

export type GeneratePatientLink = {
  generatePatientLink: { shortLink: string; fullLink: string }
}

export type AppendDocumentsVariables = Exact<{
  treatmentId: Scalars['ID']['input']
  content: Array<CreateDocumentInput>
}>

export type AppendDocuments = { appendDocuments: Array<DocumentFragment> }

export type UpdateDocumentsVariables = Exact<{
  treatmentId: Scalars['ID']['input']
  content: Array<UpdateDocumentInput>
}>

export type UpdateDocuments = { updateDocuments: Array<DocumentFragment> }

export type RemoveDocumentsVariables = Exact<{
  treatmentId: Scalars['ID']['input']
  documentIds: Array<Scalars['ID']['input']>
}>

export type RemoveDocuments = { removeDocuments: Array<DocumentFragment> }

export type SendConsentPacketVariables = Exact<{
  treatmentId: Scalars['ID']['input']
}>

export type SendConsentPacket = {
  sendConsentPacket: {
    success: boolean
    code?: string | null
    message?: string | null
  }
}

export type UpdatePatientIntegrationVariables = Exact<{
  treatmentId: Scalars['ID']['input']
  content: PatientIntegrationInput
}>

export type UpdatePatientIntegration = {
  updatePatientIntegration: PatientIntegrationFragment
}

export type SendEligibilityVerificationVariables = Exact<{
  input: SendEligibilityVerificationInput
}>

export type SendEligibilityVerification = {
  sendEligibilityVerification: ActionEntryFragment
}

export type UpdatePatientVariables = Exact<{
  input: UpdatePatientInput
}>

export type UpdatePatient = { updatePatient?: PatientResponseFragment | null }

export type CreatePatientVariables = Exact<{
  input: CreatePatientInput
}>

export type CreatePatient = { createPatient?: PatientResponseFragment | null }

export type RestorePatientVariables = Exact<{
  input: RestorePatientInput
}>

export type RestorePatient = { restorePatient?: PatientResponseFragment | null }

export type LoadPatientBillingVariables = Exact<{
  input: LoadPatientBillingInput
}>

export type LoadPatientBilling = {
  loadPatientBilling?: BillingFullFragment | null
}

export type LoadEligibilityVerificationVariables = Exact<{
  input: LoadEligibilityVerificationInput
}>

export type LoadEligibilityVerification = {
  loadEligibilityVerification?: CheckEligibilityFragment | null
}

export type GetDocumentVariables = Exact<{
  treatmentId: Scalars['ID']['input']
  documentId: Scalars['ID']['input']
}>

export type GetDocument = { getDocument: DocumentFragment }

export type GetDocumentsByTreatmentIdVariables = Exact<{
  treatmentId: Scalars['ID']['input']
}>

export type GetDocumentsByTreatmentId = {
  getDocumentsByTreatmentId: Array<DocumentFragment>
}

export type GetPatientByTreatmentIdVariables = Exact<{
  treatmentId: Scalars['ID']['input']
}>

export type GetPatientByTreatmentId = {
  getPatientByTreatmentId: PatientFragment
}

export type ListEligibilityVerificationsVariables = Exact<{
  input: ListEligibilityVerificationInput
}>

export type ListEligibilityVerifications = {
  listEligibilityVerifications: Array<CheckEligibilityFragment>
}

export type ListPatientEligibilityVerificationsVariables = Exact<{
  input: ListPatientEligibilityVerificationInput
}>

export type ListPatientEligibilityVerifications = {
  listPatientEligibilityVerifications: Array<CheckEligibilityFragment>
}

export type PatientAddressFrag = {
  street?: string | null
  city?: string | null
  state?: string | null
  zipcode?: string | null
}

export type PatientNameFrag = {
  firstName: string
  middleName?: string | null
  lastName: string
  preferredName?: string | null
  fullName: string
}

export type AppointmentDisplayFrag = {
  startDateTime: string
  endDateTime: string
  type?: string | null
  careManagerId?: string | null
  careManagerDisplay?: string | null
  serviceType?: string | null
}

export type PatientSummaryDisplayNamesFrag = {
  fullName?: string | null
  legalName?: string | null
  expandedName?: string | null
}

export type PatientSummaryFrag = {
  patientId: string
  userId: string
  treatmentId: string
  status: PatientStatus
  programId: string
  email?: string | null
  phoneNumber?: string | null
  timeZone?: string | null
  emrId?: string | null
  lumaId?: string | null
  nextgenId?: string | null
  display: PatientSummaryDisplayNamesFrag
}

export type SearchablePatientFrag = {
  id: string
  treatmentId: string
  mrn?: string | null
  emrId?: string | null
  lumaId?: string | null
  nextgenId?: string | null
  medPlumPatientId?: string | null
  mmrPatientId?: string | null
  isIntegrationActive?: boolean | null
  status: PatientStatus
  dischargeReason?: string | null
  dateOfBirth?: string | null
  primaryPhone?: string | null
  primaryEmail?: string | null
  signInPhone?: string | null
  gender?: string | null
  genderIdentity?: string | null
  genderDetails?: string | null
  preferredLanguage?: string | null
  pronouns?: string | null
  timeZone?: string | null
  tags?: Array<string> | null
  videoRoomId?: string | null
  selfPay: boolean
  name: PatientNameFrag
  upcomingAppointments?: Array<AppointmentDisplayFrag> | null
  careTeam?: Array<{
    careManagerId: string
    display?: string | null
    isPrimary: boolean
  }> | null
  address?: PatientAddressFrag | null
  notices?: Array<{
    label: string
    level: NoticeLevel
    code: NoticeCode
    at?: string | null
  }> | null
  billingInsurances?: Array<SearchablePatientInsuranceFrag> | null
  tracks?: Array<TrackFrag | null> | null
}

export type MinimalCareTeamSearchMemberFrag = {
  careManagerId: string
  isPrimary: boolean
}

export type MinimalSearchablePatientFrag = {
  id: string
  treatmentId: string
  emrId?: string | null
  lumaId?: string | null
  nextgenId?: string | null
  mrn?: string | null
  status: PatientStatus
  timeZone?: string | null
  videoRoomId?: string | null
  dateOfBirth?: string | null
  primaryPhone?: string | null
  primaryEmail?: string | null
  name: { fullName: string }
  address?: { state?: string | null } | null
  notices?: Array<{
    label: string
    level: NoticeLevel
    code: NoticeCode
    at?: string | null
  }> | null
  careTeam?: Array<{ careManagerId: string; isPrimary: boolean }> | null
  tracks?: Array<{
    planId: string
    name: string
    templateId: string
    type: string
  } | null> | null
}

export type SearchPatientsResponseFrag = {
  resultCount: number
  from?: number | null
  searchAfter?: string | null
  aggregations?: string | null
  patients: Array<SearchablePatientFrag>
}

export type SearchablePatientInsuranceFrag = {
  type: InsuranceOrdinality
  insurancePlanId?: string | null
  outOfNetwork?: boolean | null
  otherPayerInfo?: string | null
  outOfNetworkPlan?: {
    name?: string | null
    state?: { code?: string | null } | null
  } | null
}

export type TrackFrag = {
  planId: string
  name: string
  templateId: string
  type: string
}

export type SearchPatientsVariables = Exact<{
  query: Scalars['AWSJSON']['input']
  sort?: InputMaybe<Scalars['AWSJSON']['input']>
  aggregations?: InputMaybe<Scalars['AWSJSON']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Scalars['Int']['input']>
}>

export type SearchPatients = { searchPatients: SearchPatientsResponseFrag }

export type GetAggregatesVariables = Exact<{
  aggregations: Scalars['AWSJSON']['input']
}>

export type GetAggregates = { searchPatients: { aggregations?: string | null } }

export type PatientTypeAheadVariables = Exact<{
  query: Scalars['AWSJSON']['input']
  sort?: InputMaybe<Scalars['AWSJSON']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}>

export type PatientTypeAhead = {
  searchPatients: {
    resultCount: number
    patients: Array<MinimalSearchablePatientFrag>
  }
}

export type SearchPatientByTreatmentIdVariables = Exact<{
  query: Scalars['AWSJSON']['input']
}>

export type SearchPatientByTreatmentId = {
  searchPatients: { patients: Array<MinimalSearchablePatientFrag> }
}

export type DescribePatientsByIdVariables = Exact<{
  patientIds: Array<Scalars['String']['input']>
  forceInvalidate?: InputMaybe<Scalars['Boolean']['input']>
}>

export type DescribePatientsById = {
  describePatientsById: Array<PatientSummaryFrag>
}

export type DescribePatientsByUserIdVariables = Exact<{
  userIds: Array<Scalars['String']['input']>
  forceInvalidate?: InputMaybe<Scalars['Boolean']['input']>
}>

export type DescribePatientsByUserId = {
  describePatientsByUserId: Array<PatientSummaryFrag>
}

export type DescribePatientsByTreatmentIdVariables = Exact<{
  treatmentIds: Array<Scalars['String']['input']>
  forceInvalidate?: InputMaybe<Scalars['Boolean']['input']>
}>

export type DescribePatientsByTreatmentId = {
  describePatientsByTreatmentId: Array<PatientSummaryFrag>
}

export type CodeableConceptFragment = {
  code?: string | null
  text?: string | null
  coding?: Array<{
    system?: string | null
    code: string
    display?: string | null
  }> | null
}

export type PracticeMgrAnnotationFragment = {
  time: string
  text: string
  authorReference: PractMgrReferenceFragment
}

export type TocConfigurationFragment = {
  referralSourceFilter?: string | null
  fuh7: boolean
  fuh30: boolean
  fum7: boolean
  fum30: boolean
}

export type InsurancePlanFullFragment = {
  _id: string
  payerCode?: string | null
  name: string
  stateName?: string | null
  stateCode?: string | null
  status: InsurancePlanStatus
  isInNetwork: boolean
  inNetworkBenefitTerms?: string | null
  outOfNetworkBenefitTerms?: string | null
  payerId?: string | null
  entityName?: string | null
  taxId?: string | null
  groupNpi?: string | null
  payerName?: string | null
  vendorName?: string | null
  notes?: string | null
  lineOfBusiness?: InsurancePlanLineOfBusiness | null
  verificationPayerId?: string | null
  verificationPayerName?: string | null
  verificationDefaultProviderName?: string | null
  verificationDefaultProviderNpi?: string | null
  verificationDefaultLocation?: string | null
  groupId?: string | null
  planId?: string | null
  planType?: string | null
  effectiveDate?: string | null
  recredentialingDate?: string | null
  expirationDate?: string | null
  isDelegated: boolean
  delegatedEffectiveDate?: string | null
  delegatedAuditDate?: string | null
  billingPayerName?: string | null
  credentialingPayerId?: string | null
  credentialingPayerName?: string | null
  isInheritanceDisabled?: boolean | null
  companyName?: string | null
  comments?: Array<PracticeMgrAnnotationFragment> | null
  tocConfiguration?: Array<TocConfigurationFragment> | null
  identifiers: Array<{ type: string; value: string }>
}

export type VerificationInsurancePlanFragment = {
  _id: string
  payerCode?: string | null
  payerName?: string | null
  payerId?: string | null
  name: string
  stateName?: string | null
  stateCode?: string | null
  isInNetwork: boolean
  inNetworkBenefitTerms?: string | null
  outOfNetworkBenefitTerms?: string | null
  lineOfBusiness?: InsurancePlanLineOfBusiness | null
  verificationPayerId?: string | null
  verificationDefaultProviderName?: string | null
  verificationDefaultProviderNpi?: string | null
  verificationDefaultLocation?: string | null
  planType?: string | null
  billingPayerName?: string | null
  isInheritanceDisabled?: boolean | null
  credentialingPayerId?: string | null
  credentialingPayerName?: string | null
}

export type FullInsurancePlanPartialFragment = {
  _id: string
  payerCode?: string | null
  name: string
  stateName?: string | null
  stateCode?: string | null
  status?: InsurancePlanStatus | null
  isInheritanceDisabled?: boolean | null
  credentialingPayerId?: string | null
  credentialingPayerName?: string | null
  isDelegated?: boolean | null
}

export type FullInsurancePlanParticipantFragment = {
  _id: string
  effectiveDate?: string | null
  terminationDate?: string | null
  status?: InsurancePlanParticipantStatus | null
  insurancePlan: FullInsurancePlanPartialFragment
  billingRelationship: {
    type: BillingRelationshipType
    reference?: PractMgrReferenceFragment | null
  }
  comments?: Array<AttachmentAnnotationFragment> | null
}

export type MinimalInsurancePlanParticipantFragment = {
  insurancePlan: {
    _id: string
    name: string
    stateCode?: string | null
    status?: InsurancePlanStatus | null
  }
  billingRelationship: { reference?: { display?: string | null } | null }
}

export type BaseProviderFragment = {
  _id: string
  careManagerId?: string | null
  status: ProviderStatus
  firstName?: string | null
  lastName?: string | null
  email?: string | null
  genderIdentity?: GenderIdentity | null
  communityIdentity?: Array<CommunityIdentity> | null
  race?: Array<Race> | null
  ethnicity?: Ethnicity | null
  languages?: Array<string> | null
  spirituality?: Array<string> | null
  ages?: Array<string> | null
  modalities?: Array<string> | null
  specialties?: Array<string> | null
  bio?: string | null
  clinicalAges?: Array<string> | null
  clinicalModalities?: Array<string> | null
  clinicalSpecialties?: Array<string> | null
  availability: Availability
  availabilityNotes?: string | null
  serviceTypes?: Array<ProviderServiceType> | null
  nextgenTimezone?: string | null
  expectedHours?: Array<ExpectedHoursFragment> | null
  supervisor?: PractMgrReferenceFragment | null
  supervisees?: Array<PractMgrReferenceFragment> | null
  careCoordinator?: PractMgrReferenceFragment | null
  teamLead?: PractMgrReferenceFragment | null
  employment?: EmploymentFragment | null
  identifiers?: Array<ProviderIdentifierFragment> | null
}

export type ProviderMinimalFragment = {
  _id: string
  careManagerId?: string | null
  firstName?: string | null
  lastName?: string | null
  status: ProviderStatus
  availability: Availability
  display?: {
    expandedName?: string | null
    legalName?: string | null
    qualifiedName?: string | null
  } | null
  employment?: {
    _id: string
    profession?: ProfessionCode | null
    role?: EmploymentRole | null
    status?: EmploymentStatus | null
  } | null
  licenses?: Array<MinimalProviderLicenseFragment> | null
}

export type ProviderFragment = {
  insurancePlans?: Array<FullInsurancePlanParticipantFragment> | null
  licenses?: Array<ProviderLicenseFragment> | null
  display?: UserSummaryDisplayNamesFragment | null
  tags?: Array<ProviderTagFragment> | null
} & BaseProviderFragment

export type SearchInsurancePlanFragment = {
  _id: string
  payerCode?: string | null
  name: string
  stateName?: string | null
  stateCode?: string | null
}

export type AllInsurancePlansMinimalFragment = {
  _id: string
  name: string
  stateCode?: string | null
  status: InsurancePlanStatus
  isInNetwork: boolean
  payerCode?: string | null
}

export type SearchProviderFragment = {
  sort?: string | null
  insurancePlans?: Array<MinimalInsurancePlanParticipantFragment> | null
  licenses?: Array<MinimalProviderLicenseFragment> | null
} & BaseProviderFragment

export type MinimalProviderLicenseFragment = {
  licenseType: LicenseType
  stateCode: string
  status: ActiveStatus
}

export type ProviderLicenseFragment = {
  id: string
  licenseType: LicenseType
  stateCode: string
  status: ActiveStatus
  number: string
  durationType?: LicenseDurationType | null
  issueDate?: string | null
  expirationDate?: string | null
  excludeFromPayerEnrollment: boolean
  created: AuditEntryFragment
  modified?: AuditEntryFragment | null
}

export type ProviderTagFragment = { value: string }

export type ProviderLicenseRequestFragment = {
  id: string
  licenseType: LicenseType
  stateCode: string
  status: LicenseRequestStatus
  durationType?: LicenseDurationType | null
  requestType: LicenseRequestType
  submitDate?: string | null
  psvSubmitDate?: string | null
  completeDate?: string | null
  created: AuditEntryFragment
  modified?: AuditEntryFragment | null
  comments?: Array<PracticeMgrAnnotationFragment> | null
}

export type AddressFragment = {
  text?: string | null
  line: Array<string>
  city: string
  state: string
  postalCode: string
  countryCode?: string | null
}

export type InternationalAddressFragment = {
  line?: Array<string | null> | null
  city?: string | null
  state?: string | null
  postalCode?: string | null
  countryCode?: string | null
}

export type IdentifierFragment = {
  value: string
  type: CodeableConceptFragment
  period?: { startDate?: string | null; endDate?: string | null } | null
}

export type LocationFragment = {
  id: string
  name: string
  physicalType: CodeableConceptFragment
  address: { state: string }
}

export type ProviderDocumentFragment = {
  id: string
  documentCategory: DocumentCategory
  stateCode?: string | null
  status?: DocumentVerificationStatus | null
  file: FileFragment
  created: AuditEntryFragment
  modified?: AuditEntryFragment | null
  statusUpdated?: AuditEntryFragment | null
}

export type UserSummaryDisplayNamesFragment = {
  fullName?: string | null
  qualifiedName?: string | null
  legalName?: string | null
  legalQualifiedName?: string | null
  expandedName?: string | null
  publicName?: string | null
}

export type PayerEnrollmentFragment = {
  id: string
  status: PayerEnrollmentStatus
  vendor?: string | null
  payerExternalProviderId?: string | null
  submissionDate?: string | null
  effectiveDate?: string | null
  recredentialingDate?: string | null
  expirationDate?: string | null
  terminationDate?: string | null
  payer: PayerSummaryFrag
  comments?: Array<AttachmentAnnotationFragment> | null
  created: AuditEntryFragment
  updated?: AuditEntryFragment | null
}

export type PayerFragment = {
  id: string
  name: string
  stateCode: string
  status: PayerStatus
  note?: string | null
  taxEntityId?: string | null
  lineOfBusiness?: LineOfBusiness | null
  delegated?: boolean | null
  comments?: Array<PracticeMgrAnnotationFragment> | null
  identifiers?: Array<{ type: string; value: string }> | null
  tags?: Array<{ value: string }> | null
}

export type AttachmentAnnotationFragment = {
  time: string
  text: string
  authorReference: PractMgrReferenceFragment
  attachments?: Array<FileFragment> | null
}

export type ProfessionalHistoryFragment = {
  id: string
  category: ProfessionCategory
  programType?: string | null
  institutionName?: string | null
  degree?: string | null
  startDate?: string | null
  endDate?: string | null
  completed?: boolean | null
  notes?: string | null
  organizationName?: string | null
  certificationNumber?: string | null
  recertificationDate?: string | null
  examType?: string | null
  examDate?: string | null
  numberOfAttempts?: number | null
  specialty?: string | null
  title?: string | null
  address?: InternationalAddressFragment | null
  created: AuditEntryFragment
  modified?: AuditEntryFragment | null
}

export type EncryptedValueFragment = {
  display?: string | null
  cipherText: string
  algorithm: string
}

export type ProviderCredentialingFragment = {
  firstName?: string | null
  middleName?: string | null
  lastName?: string | null
  suffix?: string | null
  priorLastName?: string | null
  dateOfBirth?: string | null
  birthCountry?: string | null
  isUSCitizen?: boolean | null
  personalEmail?: string | null
  primaryPhone?: string | null
  initialCredentialingDate?: string | null
  currentCredentialingDate?: string | null
  recredentialingDate?: string | null
  lastRecredentialingDate?: string | null
  address?: InternationalAddressFragment | null
  ssn?: EncryptedValueFragment | null
}

export type ProviderExternalAccountFragment = {
  id: string
  type: string
  username: string
  note?: string | null
  password?: EncryptedValueFragment | null
}

export type PracticeStateFragment = {
  id: string
  stateCode: string
  entityName: string
  taxId: string
  groupNpi: string
  qualifyingPayerLicenseTypes: Array<LicenseType>
  availabilityStatus: PracticeStateAvailabilityStatus
}

export type PracticeTaxEntityFragment = {
  id: string
  entityName: string
  taxId: string
  groupNpi: string
}

export type ProviderPlanParticipantFragment = {
  _id: string
  status?: ActiveStatus | null
  insurancePlan: FullInsurancePlanPartialFragment
  participatingProvider: PractMgrReferenceFragment
  billingRelationship: {
    type: BillingRelationshipType
    reference?: PractMgrReferenceFragment | null
  }
}

export type UpdateProviderVariables = Exact<{
  id: Scalars['ID']['input']
  content: ProviderInputUpdate
}>

export type UpdateProvider = { updateProvider: ProviderFragment }

export type AppendInsurancePlanParticipantsVariables = Exact<{
  providerId: Scalars['ID']['input']
  content?: InputMaybe<Array<InsurancePlanParticipantInput>>
}>

export type AppendInsurancePlanParticipants = {
  appendInsurancePlanParticipants: Array<{ _id: string }>
}

export type UpdateInsurancePlanParticipantVariables = Exact<{
  providerId: Scalars['ID']['input']
  content: InsurancePlanParticipantInput
}>

export type UpdateInsurancePlanParticipant = {
  updateInsurancePlanParticipant: { _id: string }
}

export type RemoveInsurancePlanParticipantsVariables = Exact<{
  providerId: Scalars['ID']['input']
  content?: InputMaybe<Array<InsurancePlanParticipantInput>>
}>

export type RemoveInsurancePlanParticipants = {
  removeInsurancePlanParticipants: Array<{ _id: string }>
}

export type UpsertInsurancePlanParticipantsVariables = Exact<{
  content: Array<UpsertInsurancePlanParticipantInput>
}>

export type UpsertInsurancePlanParticipants = {
  upsertInsurancePlanParticipants: Array<{ _id: string }>
}

export type CreateInsurancePlanVariables = Exact<{
  content: InsurancePlanCreateInput
}>

export type CreateInsurancePlan = {
  createInsurancePlan: InsurancePlanFullFragment
}

export type UpdateInsurancePlanVariables = Exact<{
  id: Scalars['ID']['input']
  content: InsurancePlanUpdateInput
}>

export type UpdateInsurancePlan = {
  updateInsurancePlan: InsurancePlanFullFragment
}

export type DeleteInsurancePlanVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteInsurancePlan = {
  deleteInsurancePlan: InsurancePlanFullFragment
}

export type AppendProviderLicensesVariables = Exact<{
  providerId: Scalars['ID']['input']
  content: Array<ProviderLicenseCreateInput>
}>

export type AppendProviderLicenses = {
  appendProviderLicenses: Array<ProviderLicenseFragment>
}

export type UpdateProviderLicensesVariables = Exact<{
  providerId: Scalars['ID']['input']
  content: Array<ProviderLicenseUpdateInput>
}>

export type UpdateProviderLicenses = {
  updateProviderLicenses: Array<ProviderLicenseFragment>
}

export type RemoveProviderLicensesVariables = Exact<{
  providerId: Scalars['ID']['input']
  licenseIds: Array<Scalars['ID']['input']>
}>

export type RemoveProviderLicenses = {
  removeProviderLicenses: Array<ProviderLicenseFragment>
}

export type AddProviderLicenseRequestsVariables = Exact<{
  providerId: Scalars['ID']['input']
  content: Array<ProviderLicenseRequestCreateInput>
}>

export type AddProviderLicenseRequests = {
  addProviderLicenseRequests: Array<ProviderLicenseRequestFragment>
}

export type UpdateProviderLicenseRequestsVariables = Exact<{
  providerId: Scalars['ID']['input']
  content: Array<ProviderLicenseRequestUpdateInput>
}>

export type UpdateProviderLicenseRequests = {
  updateProviderLicenseRequests: Array<ProviderLicenseRequestFragment>
}

export type RemoveProviderLicenseRequestsVariables = Exact<{
  providerId: Scalars['ID']['input']
  licenseIds: Array<Scalars['ID']['input']>
}>

export type RemoveProviderLicenseRequests = {
  removeProviderLicenseRequests: Array<ProviderLicenseRequestFragment>
}

export type AppendProviderDocumentsVariables = Exact<{
  providerId: Scalars['ID']['input']
  content: Array<CreateProviderDocumentInput>
}>

export type AppendProviderDocuments = {
  appendProviderDocuments: Array<ProviderDocumentFragment>
}

export type UpdateProviderDocumentsVariables = Exact<{
  providerId: Scalars['ID']['input']
  content: Array<UpdateProviderDocumentInput>
}>

export type UpdateProviderDocuments = {
  updateProviderDocuments: Array<ProviderDocumentFragment>
}

export type RemoveProviderDocumentsVariables = Exact<{
  providerId: Scalars['ID']['input']
  documentIds: Array<Scalars['ID']['input']>
}>

export type RemoveProviderDocuments = {
  removeProviderDocuments: Array<ProviderDocumentFragment>
}

export type AppendVerifiedProviderDocumentsVariables = Exact<{
  providerId: Scalars['ID']['input']
  content: Array<CreateProviderDocumentInput>
}>

export type AppendVerifiedProviderDocuments = {
  appendVerifiedProviderDocuments: Array<ProviderDocumentFragment>
}

export type UpdateVerifiedProviderDocumentsVariables = Exact<{
  providerId: Scalars['ID']['input']
  content: Array<UpdateProviderDocumentInput>
}>

export type UpdateVerifiedProviderDocuments = {
  updateVerifiedProviderDocuments: Array<ProviderDocumentFragment>
}

export type RemoveVerifiedProviderDocumentsVariables = Exact<{
  providerId: Scalars['ID']['input']
  documentIds: Array<Scalars['ID']['input']>
}>

export type RemoveVerifiedProviderDocuments = {
  removeVerifiedProviderDocuments: Array<ProviderDocumentFragment>
}

export type CreatePayerEnrollmentsVariables = Exact<{
  providerId: Scalars['ID']['input']
  content: Array<CreatePayerEnrollmentInput>
}>

export type CreatePayerEnrollments = {
  createPayerEnrollments: Array<PayerEnrollmentFragment>
}

export type UpdatePayerEnrollmentsVariables = Exact<{
  providerId: Scalars['ID']['input']
  content: Array<UpdatePayerEnrollmentInput>
}>

export type UpdatePayerEnrollments = {
  updatePayerEnrollments: Array<PayerEnrollmentFragment>
}

export type DeletePayerEnrollmentsVariables = Exact<{
  providerId: Scalars['ID']['input']
  enrollmentIds: Array<Scalars['ID']['input']>
}>

export type DeletePayerEnrollments = {
  deletePayerEnrollments: Array<PayerEnrollmentFragment>
}

export type CreatePayersVariables = Exact<{
  content: Array<PayerCreateInput>
}>

export type CreatePayers = { createPayers: Array<PayerFragment> }

export type UpdatePayersVariables = Exact<{
  content: Array<PayerUpdateInput>
}>

export type UpdatePayers = { updatePayers: Array<PayerFragment> }

export type DeletePayersVariables = Exact<{
  content: Array<Scalars['ID']['input']>
}>

export type DeletePayers = { deletePayers: Array<PayerFragment> }

export type CreateProfessionalHistoryVariables = Exact<{
  providerId: Scalars['ID']['input']
  content: Array<ProfessionalHistoryCreateInput>
}>

export type CreateProfessionalHistory = {
  createProfessionalHistory: Array<ProfessionalHistoryFragment>
}

export type UpdateProfessionalHistoryVariables = Exact<{
  providerId: Scalars['ID']['input']
  content: Array<ProfessionalHistoryUpdateInput>
}>

export type UpdateProfessionalHistory = {
  updateProfessionalHistory: Array<ProfessionalHistoryFragment>
}

export type DeleteProfessionalHistoryVariables = Exact<{
  providerId: Scalars['ID']['input']
  ids: Array<Scalars['ID']['input']>
}>

export type DeleteProfessionalHistory = {
  deleteProfessionalHistory: Array<ProfessionalHistoryFragment>
}

export type UpsertIdentifiersVariables = Exact<{
  providerId: Scalars['ID']['input']
  content: Array<ProviderIdentifierInput>
}>

export type UpsertIdentifiers = {
  upsertIdentifiers: Array<ProviderIdentifierFragment>
}

export type DeleteIdentifiersVariables = Exact<{
  providerId: Scalars['ID']['input']
  identifierIds: Array<Scalars['ID']['input']>
}>

export type DeleteIdentifiers = {
  deleteIdentifiers: Array<ProviderIdentifierFragment>
}

export type UpdateProviderCredentialingVariables = Exact<{
  providerId: Scalars['ID']['input']
  content: ProviderCredentialingInput
}>

export type UpdateProviderCredentialing = {
  updateProviderCredentialing: ProviderCredentialingFragment
}

export type UpsertProviderExternalAccountsVariables = Exact<{
  providerId: Scalars['ID']['input']
  content: Array<ProviderExternalAccountInput>
}>

export type UpsertProviderExternalAccounts = {
  upsertProviderExternalAccounts: Array<ProviderExternalAccountFragment>
}

export type DeleteProviderExternalAccountsVariables = Exact<{
  providerId: Scalars['ID']['input']
  providerExternalAccountIds: Array<Scalars['ID']['input']>
}>

export type DeleteProviderExternalAccounts = {
  deleteProviderExternalAccounts: Array<ProviderExternalAccountFragment>
}

export type BulkUpdateInsurancePlansVariables = Exact<{
  content: Array<BulkInsurancePlanUpdateInput>
}>

export type BulkUpdateInsurancePlans = {
  bulkUpdateInsurancePlans: Array<InsurancePlanFullFragment>
}

export type GetProvidersMinimalVariables = Exact<{ [key: string]: never }>

export type GetProvidersMinimal = {
  getProviders: Array<ProviderMinimalFragment>
}

export type GetProvidersVariables = Exact<{ [key: string]: never }>

export type GetProviders = { getProviders: Array<SearchProviderFragment> }

export type GetProvidersPagedVariables = Exact<{
  searchAfter?: InputMaybe<Scalars['AWSJSON']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}>

export type GetProvidersPaged = { getProviders: Array<SearchProviderFragment> }

export type GetProviderVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GetProvider = { getProvider: ProviderFragment }

export type GetProviderLicenseRequestsVariables = Exact<{
  providerId: Scalars['ID']['input']
}>

export type GetProviderLicenseRequests = {
  getProvider: {
    _id: string
    licenseRequests?: Array<ProviderLicenseRequestFragment> | null
  }
}

export type GetProviderByCareManagerIdVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GetProviderByCareManagerId = {
  getProviderByCareManagerId: ProviderFragment
}

export type GetEmploymentByProviderIdVariables = Exact<{
  providerId: Scalars['ID']['input']
}>

export type GetEmploymentByProviderId = {
  getEmploymentByProviderId: EmploymentFragment
}

export type GetInsurancePlansVariables = Exact<{ [key: string]: never }>

export type GetInsurancePlans = {
  getInsurancePlans: Array<InsurancePlanFullFragment>
}

export type GetAllInsurancePlansVariables = Exact<{ [key: string]: never }>

export type GetAllInsurancePlans = {
  getInsurancePlans: Array<InsurancePlanFullFragment>
  getOutOfNetworkInsurancePlans: Array<InsurancePlanFullFragment>
}

export type GetInsuranceForVerificationVariables = Exact<{
  [key: string]: never
}>

export type GetInsuranceForVerification = {
  getInsurancePlans: Array<VerificationInsurancePlanFragment>
  getOutOfNetworkInsurancePlans: Array<
    { status: InsurancePlanStatus } & VerificationInsurancePlanFragment
  >
}

export type GetAllInsuranceMinimalVariables = Exact<{ [key: string]: never }>

export type GetAllInsuranceMinimal = {
  getInsurancePlans: Array<AllInsurancePlansMinimalFragment>
  getOutOfNetworkInsurancePlans: Array<AllInsurancePlansMinimalFragment>
}

export type GetActiveInsurancePlansVariables = Exact<{ [key: string]: never }>

export type GetActiveInsurancePlans = {
  getInsurancePlans: Array<SearchInsurancePlanFragment>
}

export type GetInheritingProvidersVariables = Exact<{
  providerId: Scalars['ID']['input']
  insurancePlanIds: Array<Scalars['ID']['input']>
}>

export type GetInheritingProviders = {
  getInheritingProviders: Array<ProviderPlanParticipantFragment>
}

export type GetLocationsVariables = Exact<{ [key: string]: never }>

export type GetLocations = { getLocations: Array<LocationFragment> }

export type GetLocationsWhDetailsVariables = Exact<{ [key: string]: never }>

export type GetLocationsWhDetails = {
  getLocations: Array<{
    id: string
    name: string
    description?: string | null
    physicalType: CodeableConceptFragment
    address: AddressFragment
    identifiers?: Array<IdentifierFragment> | null
  }>
}

export type GetPmAggregatesVariables = Exact<{ [key: string]: never }>

export type GetPmAggregates = {
  getLocations: Array<LocationFragment>
  getInsurancePlans: Array<AllInsurancePlansMinimalFragment>
}

export type GetProviderDocumentVariables = Exact<{
  providerId: Scalars['ID']['input']
  documentId: Scalars['ID']['input']
}>

export type GetProviderDocument = {
  getProviderDocument: ProviderDocumentFragment
}

export type GetProviderDocumentsByProviderIdVariables = Exact<{
  providerId: Scalars['ID']['input']
}>

export type GetProviderDocumentsByProviderId = {
  getProviderDocumentsByProviderId: Array<ProviderDocumentFragment>
}

export type GetVerifiedProviderDocumentVariables = Exact<{
  providerId: Scalars['ID']['input']
  documentId: Scalars['ID']['input']
}>

export type GetVerifiedProviderDocument = {
  getVerifiedProviderDocument: ProviderDocumentFragment
}

export type GetVerifiedProviderDocumentsByProviderIdVariables = Exact<{
  providerId: Scalars['ID']['input']
}>

export type GetVerifiedProviderDocumentsByProviderId = {
  getVerifiedProviderDocumentsByProviderId: Array<ProviderDocumentFragment>
}

export type GetPayerEnrollmentsByProviderIdVariables = Exact<{
  providerId: Scalars['ID']['input']
}>

export type GetPayerEnrollmentsByProviderId = {
  getPayerEnrollmentsByProviderId: Array<PayerEnrollmentFragment>
}

export type GetPayersVariables = Exact<{ [key: string]: never }>

export type GetPayers = { getPayers: Array<PayerFragment> }

export type GetPayersSummaryVariables = Exact<{ [key: string]: never }>

export type GetPayersSummary = { getPayers: Array<PayerSummaryFrag> }

export type GetProfessionalHistoryVariables = Exact<{
  providerId: Scalars['ID']['input']
}>

export type GetProfessionalHistory = {
  getProfessionalHistory: Array<ProfessionalHistoryFragment>
}

export type GetProfessionalHistoryByIdVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GetProfessionalHistoryById = {
  getProfessionalHistoryById: ProfessionalHistoryFragment
}

export type GetProviderCredentialingVariables = Exact<{
  providerId: Scalars['ID']['input']
}>

export type GetProviderCredentialing = {
  getProviderCredentialing: ProviderCredentialingFragment
}

export type GetProviderExternalAccountsVariables = Exact<{
  providerId: Scalars['ID']['input']
}>

export type GetProviderExternalAccounts = {
  getProviderExternalAccounts: Array<ProviderExternalAccountFragment>
}

export type GetPracticeStatesVariables = Exact<{ [key: string]: never }>

export type GetPracticeStates = {
  getPracticeStates: Array<PracticeStateFragment>
}

export type GetPracticeTaxEntitiesVariables = Exact<{ [key: string]: never }>

export type GetPracticeTaxEntities = {
  getPracticeTaxEntities: Array<PracticeTaxEntityFragment>
}

export type ReoccuranceTemplateSummaryFrag = {
  timezone: string
  planningHorizon: { startDate?: string | null; endDate?: string | null }
}

export type SearchProviderIdentifierFragment = {
  type: ProviderIdentifierType
  value: string
}

export type LocationSummaryFrag = {
  id: string
  name: string
  stateCode?: string | null
}

export type ScheduleSummaryFrag = {
  id: string
  active: boolean
  serviceCategory: { code: ServiceCategoryCode }
  reoccuranceTemplate: ReoccuranceTemplateSummaryFrag
  locations?: Array<LocationSummaryFrag> | null
}

export type SearchProviderMinimalFrag = {
  id: string
  careManagerId: string
  firstName: string
  lastName: string
  email: string
  employment?: {
    status?: EmploymentStatus | null
    profession?: ProfessionCode | null
  } | null
}

export type SearchProviderInsuranceMinimalFrag = {
  id: string
  insurancePlans?: Array<{ insurancePlan: { id: string } }> | null
}

export type SearchProviderLicenseFrag = {
  id: string
  licenseType: LicenseType
  stateCode: string
  status: ActiveStatus
  number: string
  durationType?: LicenseDurationType | null
  issueDate?: string | null
  expirationDate?: string | null
  created: { date: string }
}

export type SearchProviderPayerEnrollmentFrag = {
  id: string
  careManagerId: string
  firstName: string
  lastName: string
  email: string
  employment?: {
    status?: EmploymentStatus | null
    stateOfResidence?: string | null
    profession?: ProfessionCode | null
    hireDate?: string | null
    onboardingCompleteDate?: string | null
  } | null
  licenses?: Array<SearchProviderLicenseFrag> | null
  payerEnrollments?: Array<SearchPayerEnrollmentFrag> | null
  schedules?: Array<ScheduleSummaryFrag> | null
  identifiers?: Array<SearchProviderIdentifierFragment> | null
}

export type SearchPayerEnrollmentFrag = {
  id: string
  status: PayerEnrollmentStatus
  payer: { id: string; status: PayerStatus }
}

export type SearchProviderFrag = {
  id: string
  careManagerId: string
  firstName: string
  lastName: string
  status: string
  email: string
  availability?: string | null
  availabilityNotes?: string | null
  genderIdentity?: GenderIdentity | null
  communityIdentity?: Array<CommunityIdentity> | null
  race?: Array<Race> | null
  ethnicity?: Ethnicity | null
  languages?: Array<string> | null
  spirituality?: Array<string> | null
  ages?: Array<string> | null
  modalities?: Array<string> | null
  specialties?: Array<string> | null
  bio?: string | null
  clinicalAges?: Array<string> | null
  clinicalModalities?: Array<string> | null
  clinicalSpecialties?: Array<string> | null
  serviceTypes?: Array<ProviderServiceType> | null
  nextgenTimezone?: string | null
  employment?: EmploymentFragment | null
  identifiers?: Array<SearchProviderIdentifierFragment> | null
  supervisor?: PractMgrReferenceFragment | null
  careCoordinator?: PractMgrReferenceFragment | null
  supervisees?: Array<PractMgrReferenceFragment> | null
  teamLead?: PractMgrReferenceFragment | null
  expectedHours?: Array<ExpectedHoursFragment> | null
  licenses?: Array<{
    id: string
    licenseType: LicenseType
    durationType?: LicenseDurationType | null
    stateCode: string
    status: ActiveStatus
    number: string
    issueDate?: string | null
    expirationDate?: string | null
    excludeFromPayerEnrollment: boolean
    created: { date: string }
  }> | null
  payerEnrollments?: Array<SearchPayerEnrollmentFrag> | null
  schedules?: Array<ScheduleSummaryFrag> | null
  insurancePlans?: Array<{
    id: string
    status: InsurancePlanParticipantStatus
    effectiveDate?: string | null
    terminationDate?: string | null
    billingRelationship?: {
      type: BillingRelationshipType
      reference?: { id?: string | null; display?: string | null } | null
    } | null
    insurancePlan: { id: string }
  }> | null
  tags?: Array<{ value: string }> | null
}

export type SearchProvidersVariables = Exact<{
  query: Scalars['AWSJSON']['input']
  sort?: InputMaybe<Scalars['AWSJSON']['input']>
  aggregations?: InputMaybe<Scalars['AWSJSON']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Scalars['Int']['input']>
}>

export type SearchProviders = {
  searchProviders: {
    resultCount: number
    from?: number | null
    searchAfter?: string | null
    aggregations?: string | null
    results: Array<SearchProviderFrag>
  }
}

export type SearchPayerEnrollmentsVariables = Exact<{
  query: Scalars['AWSJSON']['input']
  sort?: InputMaybe<Scalars['AWSJSON']['input']>
  aggregations?: InputMaybe<Scalars['AWSJSON']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Scalars['Int']['input']>
}>

export type SearchPayerEnrollments = {
  searchProviders: {
    resultCount: number
    from?: number | null
    searchAfter?: string | null
    aggregations?: string | null
    results: Array<SearchProviderPayerEnrollmentFrag>
  }
}

export type ProviderTypeAheadVariables = Exact<{
  query: Scalars['AWSJSON']['input']
  sort?: InputMaybe<Scalars['AWSJSON']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}>

export type ProviderTypeAhead = {
  searchProviders: {
    resultCount: number
    results: Array<SearchProviderMinimalFrag>
  }
}

export type GetProviderAggregatesVariables = Exact<{
  aggregations: Scalars['AWSJSON']['input']
}>

export type GetProviderAggregates = {
  searchProviders: { aggregations?: string | null }
}

export type SearchProvidersInsuranceVariables = Exact<{
  query: Scalars['AWSJSON']['input']
  pageSize?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Scalars['Int']['input']>
}>

export type SearchProvidersInsurance = {
  searchProviders: {
    resultCount: number
    results: Array<SearchProviderInsuranceMinimalFrag>
  }
}

export type ReferenceFragment = {
  _id?: string | null
  type: ResourceType
  display?: string | null
}

export type AnnotationFragment = {
  time: string
  text: string
  authorReference: ReferenceFragment
}

export type ServiceCategoryFragment = { code: ServiceCategoryCode }

export type ServiceTypeFragment = { code: ServiceTypeCode }

export type ScheduleFragment = {
  _id: string
  active: boolean
  serviceCategory: ServiceCategoryFragment
  actors: Array<{
    _id?: string | null
    type: ResourceType
    display?: string | null
  }>
  reoccuranceTemplate: {
    timezone: string
    reoccuranceType: ReoccuranceType
    occuranceCount?: number | null
    planningHorizon: { startDate?: string | null; endDate?: string | null }
    weeklyTemplate?: Array<{
      offset: number
      interval: number
      dayTimes: Array<{
        startTime: string
        endTime: string
        dayOfWeek: DayOfWeek
      }>
    }> | null
  }
  notes?: Array<AnnotationFragment> | null
}

export type VirtualServiceFragment = {
  channelType: SessionType
  addressUrl?: string | null
  phoneNumber?: string | null
  sessionKey?: string | null
}

export type ReoccuranceTemplateFragment = {
  id: string
  timezone: string
  reoccuranceType: ReoccuranceType
  occuranceCount?: number | null
  lastOccuranceIndex?: number | null
  planningHorizon: { startDate?: string | null; endDate?: string | null }
  weeklyTemplate?: Array<{
    offset: number
    interval: number
    dayTimes: Array<{
      startTime: string
      endTime: string
      dayOfWeek: DayOfWeek
    }>
  }> | null
}

export type AppointmentFragment = {
  _id: string
  status: AppointmentStatus
  appointmentType: AppointmentType
  description?: string | null
  startDate: string
  endDate: string
  minutesDuration?: number | null
  occuranceChanged?: boolean | null
  occuranceIndex?: number | null
  cancelationReason?: string | null
  replacesAppointmentId?: string | null
  createdDate: string
  syncMessage?: string | null
  reoccuranceTemplate?: ReoccuranceTemplateFragment | null
  serviceCategory: ServiceCategoryFragment
  serviceType?: ServiceTypeFragment | null
  notes?: Array<AnnotationFragment> | null
  virtualService?: VirtualServiceFragment | null
  participants: Array<{
    required: boolean
    status?: ParticipationStatus | null
    actor: ReferenceFragment
    type?: { code: AppointmentParticipantTypeCode } | null
  }>
  identifiers?: Array<{
    source: AppointmentIdentifierSource
    value?: string | null
  }> | null
}

export type CreateAppointmentResponseFragment = {
  appointment: AppointmentFragment
  warnings: Array<AppointmentWarningFragment>
}

export type AppointmentWarningFragment = {
  startDate: string
  endDate: string
  message?: string | null
  code?: AppointmentWarningCode | null
}

export type CreateAppointmentExternalVariables = Exact<{
  content: CreateAppointmentExternalInput
}>

export type CreateAppointmentExternal = {
  createAppointmentExternal: CreateAppointmentResponseFragment
}

export type UpdateAppointmentExternalVariables = Exact<{
  id: Scalars['ID']['input']
  content: UpdateAppointmentExternalInput
}>

export type UpdateAppointmentExternal = {
  updateAppointmentExternal: AppointmentFragment
}

export type UpdateReoccuranceTemplateResponseFragment = {
  reoccuranceTemplate: ReoccuranceTemplateFragment
  warnings: Array<AppointmentWarningFragment>
}

export type CreateScheduleVariables = Exact<{
  content: ScheduleInput
}>

export type CreateSchedule = { createSchedule: ScheduleFragment }

export type UpdateScheduleVariables = Exact<{
  id: Scalars['ID']['input']
  content: ScheduleInput
}>

export type UpdateSchedule = { updateSchedule: ScheduleFragment }

export type DeleteScheduleVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteSchedule = { deleteSchedule: { _id: string } }

export type CreateAppointmentVariables = Exact<{
  content: AppointmentInput
  options?: InputMaybe<AppointmentOptions>
}>

export type CreateAppointment = { createAppointment: AppointmentFragment }

export type UpdateAppointmentVariables = Exact<{
  id: Scalars['ID']['input']
  content: UpdateAppointmentInput
  options?: InputMaybe<AppointmentOptions>
}>

export type UpdateAppointment = { updateAppointment: AppointmentFragment }

export type DeleteAppointmentVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type DeleteAppointment = { deleteAppointment: { _id: string } }

export type CreateAppointmentV2Variables = Exact<{
  content: AppointmentInput
  options?: InputMaybe<AppointmentOptions>
}>

export type CreateAppointmentV2 = {
  createAppointmentV2: CreateAppointmentResponseFragment
}

export type UpdateReoccuranceTemplateVariables = Exact<{
  id: Scalars['ID']['input']
  content: ReoccuranceTemplateInput
}>

export type UpdateReoccuranceTemplate = {
  updateReoccuranceTemplate: UpdateReoccuranceTemplateResponseFragment
}

export type GetScheduleVariables = Exact<{
  _id: Scalars['ID']['input']
}>

export type GetSchedule = { getSchedule?: ScheduleFragment | null }

export type SearchSchedulesVariables = Exact<{
  content?: InputMaybe<Array<SearchFilter>>
  sort?: InputMaybe<Array<SortParam>>
  searchAfter?: InputMaybe<Scalars['AWSJSON']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}>

export type SearchSchedules = {
  searchSchedules?: {
    searchAfter?: string | null
    results: Array<ScheduleFragment>
  } | null
}

export type GetSchedulesByProviderIdVariables = Exact<{
  id: Scalars['String']['input']
}>

export type GetSchedulesByProviderId = {
  searchSchedules?: { results: Array<ScheduleFragment> } | null
}

export type GetAppointmentVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GetAppointment = { getAppointment?: AppointmentFragment | null }

export type SearchAppointmentsVariables = Exact<{
  content?: InputMaybe<Array<SearchFilter>>
  sort?: InputMaybe<Array<SortParam>>
  searchAfter?: InputMaybe<Scalars['AWSJSON']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
}>

export type SearchAppointments = {
  searchAppointments?: {
    searchAfter?: string | null
    results: Array<AppointmentFragment>
  } | null
}

export type GetPatientAppointmentsByDateRangeVariables = Exact<{
  treatmentId: Scalars['String']['input']
  from: Scalars['String']['input']
  to: Scalars['String']['input']
  pageSize?: InputMaybe<Scalars['Int']['input']>
}>

export type GetPatientAppointmentsByDateRange = {
  searchAppointments?: {
    searchAfter?: string | null
    results: Array<AppointmentFragment>
  } | null
}

export type GetAppointmentsByProviderIdVariables = Exact<{
  id: Scalars['String']['input']
}>

export type GetAppointmentsByProviderId = {
  searchAppointments?: { results: Array<AppointmentFragment> } | null
}

export type GetNextLastApptByTreatmentIdVariables = Exact<{
  id: Scalars['String']['input']
  now: Scalars['String']['input']
}>

export type GetNextLastApptByTreatmentId = {
  getNextApptByPatientId?: {
    results: Array<{
      _id: string
      startDate: string
      endDate: string
      status: AppointmentStatus
      serviceCategory: { code: ServiceCategoryCode }
      serviceType?: { code: ServiceTypeCode } | null
    }>
  } | null
  getLastApptByPatientId?: {
    results: Array<{
      _id: string
      startDate: string
      endDate: string
      status: AppointmentStatus
      serviceCategory: { code: ServiceCategoryCode }
      serviceType?: { code: ServiceTypeCode } | null
    }>
  } | null
}

export type TaskReferenceFragment = {
  _id?: string | null
  type: ResourceType
  display?: string | null
  reference?: string | null
  active?: boolean | null
}

export type SearchableReferenceFragment = {
  id?: string | null
  display?: string | null
  reference?: string | null
  active?: boolean | null
}

export type TaskAnnotationFragment = {
  time: string
  text: string
  authorReference: TaskReferenceFragment
}

export type TaskFragment = {
  _id: string
  type: TaskType
  status: TaskStatus
  patientId: string
  patientPreferences?: string | null
  treatmentId: string
  description: string
  dueDate: string
  referralSource?: string | null
  serviceType?: TaskServiceType | null
  createdDate: string
  lastUpdatedDate: string
  patient?: {
    id?: string | null
    display?: string | null
    mrn?: string | null
    nextgenId?: string | null
    lumaId?: string | null
  } | null
  comments?: Array<TaskAnnotationFragment> | null
  assignee: TaskReferenceFragment
  createdBy: TaskReferenceFragment
}

export type SearchableTaskFragment = {
  id: string
  type: TaskType
  status: TaskStatus
  patientPreferences?: string | null
  treatmentId: string
  description: string
  dueDate: string
  referralSource?: string | null
  serviceType?: TaskServiceType | null
  createdDate: string
  lastUpdatedDate: string
  patient?: {
    id?: string | null
    display?: string | null
    mrn?: string | null
    lumaId?: string | null
    nextgenId?: string | null
  } | null
  assignee: SearchableReferenceFragment
  createdBy: SearchableReferenceFragment
  recentComments: Array<{ text: string; time: string }>
}

export type CreateTaskVariables = Exact<{
  content: CreateTaskInput
}>

export type CreateTask = { createTask: TaskFragment }

export type UpdateTaskVariables = Exact<{
  content: UpdateTaskInputV2
}>

export type UpdateTask = { updateTaskV2: TaskFragment }

export type UpdateTasksVariables = Exact<{
  content: Array<UpdateTaskInputV2>
}>

export type UpdateTasks = { updateTasks: Array<TaskFragment> }

export type DeleteTaskVariables = Exact<{
  _id: Scalars['ID']['input']
}>

export type DeleteTask = { deleteTask: TaskFragment }

export type GetTasksByTreatmentIdVariables = Exact<{
  treatmentId: Scalars['ID']['input']
}>

export type GetTasksByTreatmentId = {
  getTasksByTreatmentIds: Array<TaskFragment>
}

export type GetTasksVariables = Exact<{ [key: string]: never }>

export type GetTasks = { getTasks: Array<TaskFragment> }

export type GetTaskVariables = Exact<{
  _id: Scalars['ID']['input']
}>

export type GetTask = { getTask: TaskFragment }

export type SearchTasksVariables = Exact<{
  query: Scalars['AWSJSON']['input']
  sort?: InputMaybe<Scalars['AWSJSON']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Scalars['Int']['input']>
  searchAfter?: InputMaybe<Scalars['AWSJSON']['input']>
  aggregations?: InputMaybe<Scalars['AWSJSON']['input']>
}>

export type SearchTasks = {
  searchTasks: {
    resultCount: number
    from?: number | null
    searchAfter?: string | null
    aggregations?: string | null
    tasks: Array<SearchableTaskFragment>
  }
}

export type GetOutstandingTasksVariables = Exact<{
  query: Scalars['AWSJSON']['input']
  pageSize?: InputMaybe<Scalars['Int']['input']>
}>

export type GetOutstandingTasks = {
  searchTasks: {
    resultCount: number
    from?: number | null
    searchAfter?: string | null
    aggregations?: string | null
    tasks: Array<SearchableTaskFragment>
  }
}

export type GetSearchTasksAggregatesVariables = Exact<{
  query: Scalars['AWSJSON']['input']
  aggregations: Scalars['AWSJSON']['input']
}>

export type GetSearchTasksAggregates = {
  searchTasks: { aggregations?: string | null }
}

export type CareManagerFragment = {
  id: string
  careManagerId: string
  emrId?: string | null
  username: string
  firstName: string
  lastName: string
  email: string
  pronouns?: string | null
  isProvider: boolean
  isEnabled: boolean
  permissions?: {
    isSupervisor?: boolean | null
    addPatients?: boolean | null
    viewAllPatients?: boolean | null
    isAdmin?: boolean | null
    caseloadBulkSend?: boolean | null
    accessToNotes?: boolean | null
  } | null
}

export type CareManagerSearchFragment = {
  id: string
  careManagerId: string
  emrId?: string | null
  username: string
  email: string
  firstName: string
  lastName: string
  isEnabled: boolean
  isProvider: boolean
}

export type CognitoFragment = {
  userStatus: string
  isEnabled: boolean
  userAttributes: {
    sub: string
    given_name?: string | null
    family_name?: string | null
    email: string
    picture?: string | null
    pronouns?: string | null
    nickname?: string | null
    phone_number?: string | null
  }
}

export type CognitoSearchFragment = {
  userStatus: string
  isEnabled: boolean
  userAttributes: {
    sub: string
    given_name?: string | null
    family_name?: string | null
    email: string
    picture?: string | null
    nickname?: string | null
  }
}

export type UserSearchFragment = {
  permitRoles?: Array<string> | null
  careManager: CareManagerSearchFragment
  cognito?: CognitoSearchFragment | null
}

export type UserFullFragment = {
  permitRoles?: Array<string> | null
  careManager: CareManagerFragment
  cognito?: CognitoFragment | null
}

export type UserProvisionedFullFragment = {
  permitRoles?: Array<string> | null
  careManager: CareManagerFragment
  cognito: CognitoFragment
}

export type UsrNamesFragment = { expandedName?: string | null }

export type UsrSummaryFragment = {
  careManagerId?: string | null
  providerId?: string | null
  cognitoUserId?: string | null
  emrId?: string | null
  identifiers?: { type: string; value: string } | null
  display: UsrNamesFragment
}

export type UserSignUpWithGoogleVariables = Exact<{
  content: GoogleSignUpInput
}>

export type UserSignUpWithGoogle = {
  signUpGoogleUser: UserProvisionedFullFragment
}

export type UserSignUpVariables = Exact<{
  content: UserSignUpInput
}>

export type UserSignUp = { signUpUser: UserProvisionedFullFragment }

export type UpdateUserVariables = Exact<{
  cognitoUserId: Scalars['ID']['input']
  content: UserUpdateInput
}>

export type UpdateUser = { updateUser: UserProvisionedFullFragment }

export type RevokeUserVariables = Exact<{
  id: Scalars['String']['input']
}>

export type RevokeUser = {
  revokeUser: {
    careManager: { id: string }
    cognito?: { userStatus: string } | null
  }
}

export type RemoveUserVariables = Exact<{
  id: Scalars['String']['input']
}>

export type RemoveUser = { removeUser: { careManager: { id: string } } }

export type RestoreUserVariables = Exact<{
  id: Scalars['String']['input']
}>

export type RestoreUser = {
  restoreUser: { careManager: { id: string }; cognito: { userStatus: string } }
}

export type ResendUserPasswordVariables = Exact<{
  cognitoUserId: Scalars['ID']['input']
}>

export type ResendUserPassword = { resendUserPassword: { isSuccess: boolean } }

export type GetAllUsersVariables = Exact<{ [key: string]: never }>

export type GetAllUsers = { getUsers?: Array<UserSearchFragment> | null }

export type GetUserVariables = Exact<{
  email: Scalars['String']['input']
}>

export type GetUser = { getUser: UserFullFragment }

export type GetUserByCareManagerIdVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GetUserByCareManagerId = { getUserById: UserFullFragment }

export type GetUserByCognitoUserIdVariables = Exact<{
  id: Scalars['ID']['input']
}>

export type GetUserByCognitoUserId = { getUserById: UserFullFragment }

export type GetSecurityRolesVariables = Exact<{ [key: string]: never }>

export type GetSecurityRoles = {
  listSecurityRoles: Array<{ name: string; key: string }>
}

export type DescribeUsersByCareManagerIdVariables = Exact<{
  ids: Array<Scalars['String']['input']>
}>

export type DescribeUsersByCareManagerId = {
  describeUsersByCareManagerId: Array<UsrSummaryFragment>
}

export type DescribeUsersByProviderIdVariables = Exact<{
  ids: Array<Scalars['String']['input']>
}>

export type DescribeUsersByProviderId = {
  describeUsersByProviderId: Array<UsrSummaryFragment>
}

export type DescribeUsersByCognitoIdVariables = Exact<{
  ids: Array<Scalars['String']['input']>
}>

export type DescribeUsersByCognitoId = {
  describeUsersByCognitoUserId: Array<UsrSummaryFragment>
}

export type EncryptResponseFragment = { cipherText: string; algorithm: string }

export type DecryptResponseFragment = { plainText: string }

export type EncryptVariables = Exact<{
  input: EncryptInput
}>

export type Encrypt = { encrypt: EncryptResponseFragment }

export type DecryptVariables = Exact<{
  input: DecryptInput
}>

export type Decrypt = { decrypt: DecryptResponseFragment }

export type EligibilityVerificationExternalFrag = {
  id: string
  billingInsuranceId?: string | null
  ts?: string | null
  payerId: string
  providerName: string
  providerNpi: string
  location?: string | null
  vendor?: string | null
  isActive?: boolean | null
  benefitSummaryPdfFile?: string | null
  requestId?: number | null
  insurancePlanId?: string | null
  coPay?: string | null
  deductible?: number | null
  familyDeductible?: number | null
  coinsurance?: number | null
  eligibilityReason?: string | null
  eligibilityVerificationCategory?: string | null
  insured?: {
    patientRelationship: string
    firstName: string
    lastName: string
    dob: string
    dateOfServiceStart: string
    dateOfServiceEnd: string
    memberId: string
  } | null
}

export type VerifyEligibilityExternalVariables = Exact<{
  input: Array<VerifyEligibilityExternalInput>
}>

export type VerifyEligibilityExternal = {
  verifyEligibilityExternal?: Array<EligibilityVerificationExternalFrag | null> | null
}

export type EligibilityVerificationV2Frag = {
  id: string
  billingInsuranceId?: string | null
  ts?: string | null
  payerId: string
  providerName: string
  providerNpi: string
  location?: string | null
  vendor?: string | null
  isActive?: boolean | null
  benefitSummaryPdfFile?: string | null
  requestId?: number | null
  insurancePlanId?: string | null
  coPay?: string | null
  deductible?: number | null
  familyDeductible?: number | null
  coinsurance?: number | null
  note?: string | null
  insured?: {
    patientRelationship: string
    firstName: string
    lastName: string
    dob: string
    dateOfServiceStart: string
    dateOfServiceEnd: string
    memberId: string
  } | null
  actionLog?: Array<ActionEntryFragment> | null
}

export type VerifyEligibilityVariables = Exact<{
  input: VerifyEligibilityInputV2
}>

export type VerifyEligibility = {
  verifyEligibility?: EligibilityVerificationV2Frag | null
}

export type VerifyEligibilityFromEmrVariables = Exact<{
  input: VerifyEligibilityFromEmrInput
}>

export type VerifyEligibilityFromEmr = {
  verifyEligibilityFromEmr?: Array<EligibilityVerificationV2Frag | null> | null
}
